import * as React from "react";

const BackgroundLoading = () => (
  <svg
    width="921"
    height="448"
    viewBox="0 0 921 448"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M908.892 441.251H819.55C820 440.076 820.247 438.803 820.247 437.47C820.247 432.091 816.255 427.645 811.07 426.931C809.887 417.703 802.005 410.572 792.453 410.572C787.27 410.572 782.576 412.673 779.179 416.07C777.466 417.785 776.081 419.831 775.13 422.102C774.493 422.007 773.842 421.958 773.178 421.958C766.83 421.958 761.542 426.478 760.352 432.474C760.252 432.47 760.151 432.469 760.052 432.469C755.731 432.469 752.229 435.969 752.229 440.288C752.229 440.614 752.249 440.935 752.288 441.251H741.411C741.493 440.915 741.535 440.564 741.535 440.202V434.067C741.535 425.864 734.887 419.217 726.684 419.215V420.16V419.215H712.389H698.335C695.156 419.215 692.208 420.215 689.793 421.915V265.302H695.799C698.122 265.3 700.002 263.422 700.006 261.096V257.294L677.567 235.464L677.565 235.461L676.25 236.817L677.565 235.461C676.147 234.087 674.249 233.314 672.27 233.313H483.321C483.404 233.025 483.449 232.72 483.449 232.405V231.29H487.167L474.812 219.314C473.393 217.939 471.494 217.17 469.518 217.169H467.664C462.683 201.684 448.5 190.328 431.553 189.539V152.9H437.878C438.379 152.9 438.861 152.971 439.326 153.091V149.097C438.31 148.32 437.644 147.038 437.644 145.592V141.532H441.815V130.083L447.967 123.584H479.002L485.15 130.083V141.532H489.361V145.538C489.361 147.125 488.561 148.512 487.379 149.253V214.962L500.017 214.958V199.677H499.766C497.336 199.677 495.363 197.535 495.363 194.905V190.409H538.656L538.678 106.492H544.572V85.0017H566.286C569.424 89.799 571.246 95.5267 571.246 101.691C571.246 104.155 570.95 106.541 570.397 108.842C570.244 109.48 570.434 110.154 570.897 110.618C571.256 110.977 571.74 111.172 572.235 111.172C572.381 111.172 572.528 111.155 572.674 111.121C573.322 110.965 573.982 110.829 574.65 110.713V117.098L588.36 127.763L588.369 214.924L633.896 214.907V176.594C632.503 176.129 631.484 174.74 631.484 173.082V168.307C631.484 166.269 633.013 164.614 634.892 164.614H641.397L675.005 141.024C674.684 140.237 674.503 139.369 674.503 138.455C674.503 135.734 676.087 133.414 678.301 132.498L680.375 91.7682L682.454 132.498C684.667 133.414 686.248 135.737 686.248 138.455C686.248 139.369 686.068 140.237 685.747 141.024L719.356 164.614H725.863C727.739 164.614 729.265 166.3 729.265 168.372V173.014C729.265 174.588 728.386 175.935 727.141 176.492V200.225V203.332V224.523L732.85 220.139V216.042H732.515C731.605 216.042 730.808 215.373 730.577 214.418C730.348 213.459 730.742 212.455 731.538 211.971L744.391 204.175C744.688 203.995 745.024 203.899 745.367 203.899H754.191C754.562 203.899 754.924 204.01 755.238 204.221L766.929 212.019C767.692 212.528 768.05 213.524 767.807 214.459C767.605 215.237 767.024 215.809 766.321 215.983V220.023L774.742 226.606C775.096 226.882 775.243 227.37 775.11 227.821C774.976 228.269 774.591 228.573 774.159 228.573H768.133V231.656L777.851 231.65H777.852C778.381 231.65 778.891 231.88 779.266 232.288C779.643 232.696 779.853 233.248 779.853 233.823V235.097C779.853 236.333 779.274 237.425 778.396 238.074V255.401L779.628 258.293L780.903 258.292C781.434 258.292 781.943 258.519 782.318 258.927C782.693 259.334 782.905 259.886 782.905 260.463V261.735C782.905 262.895 782.388 263.919 781.594 264.58V286.255C782.043 286.309 782.462 286.516 782.787 286.863C783.164 287.27 783.378 287.827 783.378 288.406V289.638C783.378 290.496 783.086 291.274 782.623 291.889L785.649 291.88V290.982C784.971 290.327 784.536 289.387 784.536 288.33V284.528C784.536 283.524 785.163 282.688 786.014 282.438V249.257C785.591 248.657 785.333 247.919 785.333 247.111V245.873C785.333 244.678 786.219 243.708 787.318 243.701L791.774 243.666H791.787C792.317 243.666 792.823 243.894 793.197 244.295C793.575 244.706 793.786 245.26 793.786 245.839V247.075C793.786 247.955 793.482 248.752 792.994 249.372V253.926H795.234V246.519C794.444 245.868 793.922 244.85 793.922 243.695V242.458C793.922 241.258 794.819 240.286 795.923 240.286L804.516 240.277V225.689C803.786 225.036 803.309 224.059 803.309 222.953V221.719C803.309 220.519 804.204 219.548 805.308 219.546L807.011 219.545V215.289C806.272 214.635 805.789 213.653 805.789 212.541V211.303C805.789 210.105 806.683 209.134 807.788 209.132L809.884 209.128L812.504 206.281V205.179L812.511 205.055C812.569 204.506 812.8 203.988 813.158 203.6L816.555 199.91C816.984 199.444 817.574 199.211 818.162 199.211C818.751 199.211 819.34 199.445 819.768 199.914L823.165 203.599C823.527 203.982 823.758 204.506 823.811 205.066L823.819 205.179V206.279L826.415 209.098L828.53 209.095H828.533C829.064 209.095 829.573 209.324 829.947 209.73C830.325 210.138 830.534 210.692 830.534 211.269V212.504C830.534 213.692 829.991 214.741 829.161 215.39V219.512L830.929 219.511H830.93C831.46 219.511 831.972 219.74 832.345 220.145C832.722 220.552 832.931 221.105 832.931 221.684V222.919C832.931 224.094 832.4 225.13 831.59 225.779V240.255L840.181 240.25H840.182C840.712 240.25 841.221 240.479 841.596 240.885C841.973 241.295 842.183 241.846 842.183 242.42V243.659C842.183 244.733 841.733 245.688 841.033 246.339V253.926H843.37V249.335C842.916 248.725 842.631 247.955 842.631 247.111V245.873C842.631 244.678 843.515 243.708 844.617 243.701L849.075 243.666H849.088C849.616 243.666 850.124 243.894 850.499 244.295C850.876 244.706 851.089 245.26 851.089 245.839V247.075C851.089 247.919 850.804 248.688 850.351 249.299V282.443C850.637 282.548 850.902 282.717 851.119 282.955C851.495 283.362 851.704 283.913 851.704 284.491V288.294C851.704 289.309 851.307 290.221 850.677 290.87V291.88L853.666 291.872C853.223 291.264 852.95 290.51 852.95 289.675V288.441C852.95 287.247 853.836 286.277 854.935 286.268L859.391 286.233H859.405C859.933 286.233 860.441 286.458 860.815 286.863C861.193 287.27 861.406 287.827 861.406 288.406V289.638C861.406 290.565 861.072 291.403 860.541 292.035V337.982L879.62 297.264L899.021 338.408H906.646L910.606 348.26H912.811V350.114C912.811 350.545 912.816 350.981 912.819 351.413C912.855 354.236 912.885 356.902 911.578 358.505C910.863 359.355 909.902 359.921 908.892 360.133V441.251V441.251ZM879.561 433.989L864.566 358.644L857.127 321.15L857.122 321.178L857.116 321.15L857.111 321.179L857.106 321.15L834.627 433.989H879.561ZM766.052 408.521C780.64 408.521 792.469 396.695 792.469 382.105C792.469 379.772 792.166 377.511 791.598 375.357C795.468 372.002 797.916 367.05 797.916 361.527C797.916 355.657 795.151 350.432 790.851 347.086C787.467 336.625 777.643 329.061 766.054 329.061C757.9 329.061 750.621 332.807 745.845 338.672C742.693 336.381 738.812 335.03 734.615 335.03C724.061 335.03 715.51 343.585 715.51 354.139C715.51 357.224 716.239 360.138 717.537 362.718C715.555 366.505 714.433 370.814 714.433 375.383C714.433 390.495 726.68 402.74 741.786 402.74C744.123 402.74 746.391 402.448 748.556 401.896C753.215 406.019 759.342 408.521 766.052 408.521V408.521ZM72.0717 441.251H12.1937V366.287C11.2208 365.485 10.5814 364.229 10.5814 362.803V360.28C8.84914 359.925 7.53198 358.277 7.53198 356.294C7.53198 354.054 9.20925 352.232 11.2729 352.232H15.5103C18.0969 360.566 25.865 366.618 35.0506 366.618C46.3479 366.618 55.508 357.458 55.508 346.158C55.508 344.787 55.3733 343.448 55.1164 342.154C60.061 344.938 65.7698 346.525 71.8501 346.525C77.4532 346.525 82.7427 345.174 87.409 342.782C85.4548 346.292 84.3418 350.336 84.3418 354.639C84.3418 361.528 87.1924 367.749 91.7794 372.189L91.0088 392.741C90.9698 393.784 91.7832 394.66 92.8257 394.699C92.8496 394.7 92.8736 394.7 92.8987 394.7C93.9086 394.7 94.7459 393.901 94.7836 392.884L95.4497 375.116C99.2774 377.609 103.848 379.059 108.759 379.059C122.244 379.059 133.173 368.127 133.173 354.639C133.173 341.155 122.244 330.224 108.759 330.224C105.625 330.224 102.628 330.814 99.8755 331.889C103.733 326.358 105.996 319.632 105.996 312.374C105.996 293.514 90.7054 278.228 71.8501 278.228C65.1528 278.228 58.9064 280.155 53.6344 283.483C53.7276 283.29 53.8485 283.111 53.9933 282.955C54.2111 282.717 54.4755 282.548 54.7613 282.443V249.299C54.3081 248.688 54.0222 247.919 54.0222 247.075V245.839C54.0222 245.26 54.235 244.706 54.614 244.295C54.988 243.894 55.4942 243.666 56.023 243.666H56.0381L60.4954 243.701C61.5946 243.708 62.481 244.678 62.481 245.873V247.111C62.481 247.955 62.1964 248.725 61.7406 249.335V253.926H64.0763V246.339C63.3787 245.688 62.928 244.733 62.928 243.659V242.42C62.928 241.846 63.1383 241.295 63.5135 240.885C63.8899 240.479 64.3999 240.25 64.93 240.25L73.5209 240.255V225.779C72.7113 225.13 72.18 224.094 72.18 222.919V221.684C72.18 221.105 72.3902 220.552 72.7667 220.145C73.1407 219.74 73.6519 219.511 74.1807 219.511H74.1832L75.9498 219.512V215.39C75.1213 214.741 74.5748 213.692 74.5748 212.504V211.269C74.5748 210.692 74.7876 210.138 75.1641 209.73C75.5393 209.324 76.0467 209.095 76.5781 209.095H76.5806L78.6972 209.098L81.2922 206.279V205.179L81.301 205.066C81.3539 204.506 81.5868 203.982 81.9457 203.599L85.344 199.914C85.7721 199.445 86.3602 199.211 86.9494 199.211C87.5374 199.211 88.1267 199.444 88.556 199.91L91.9531 203.6C92.312 203.988 92.5424 204.506 92.6003 205.055L92.6066 205.179V206.281L95.2294 209.128L97.3258 209.132C98.4288 209.134 99.3228 210.105 99.3228 211.303V212.541C99.3228 213.653 98.8405 214.635 98.1014 215.289V219.545L99.8037 219.546C100.909 219.548 101.802 220.519 101.802 221.719V222.953C101.802 224.059 101.327 225.036 100.596 225.689V240.277L109.189 240.286C110.293 240.286 111.19 241.258 111.19 242.458V243.695C111.19 244.85 110.669 245.868 109.878 246.519V253.926H112.118V249.372C111.631 248.752 111.325 247.955 111.325 247.075V245.839C111.325 245.26 111.537 244.706 111.915 244.295C112.29 243.894 112.797 243.666 113.327 243.666H113.337L117.793 243.701C118.893 243.708 119.781 244.678 119.781 245.873V247.111C119.781 247.919 119.52 248.657 119.097 249.257V282.438C119.947 282.688 120.578 283.524 120.578 284.528V288.33C120.578 289.387 120.141 290.327 119.464 290.982V291.88L122.488 291.889C122.025 291.274 121.733 290.496 121.733 289.638V288.406C121.733 287.827 121.947 287.27 122.324 286.863C122.648 286.516 123.07 286.309 123.519 286.255V264.58C122.726 263.919 122.207 262.895 122.207 261.735V260.463C122.207 259.886 122.419 259.334 122.794 258.927C123.169 258.519 123.678 258.292 124.208 258.292L125.483 258.293L126.716 255.401V238.074C125.839 237.425 125.258 236.333 125.258 235.097V233.823C125.258 233.248 125.468 232.696 125.845 232.288C126.221 231.88 126.73 231.65 127.259 231.65H127.26L136.978 231.656V228.573H130.954C130.52 228.573 130.136 228.269 130.001 227.821C129.868 227.37 130.016 226.882 130.37 226.606L138.791 220.023V215.983C138.087 215.809 137.507 215.237 137.305 214.459C137.061 213.524 137.42 212.528 138.183 212.019L149.873 204.221C150.187 204.01 150.55 203.899 150.919 203.899H159.745C160.088 203.899 160.423 203.995 160.72 204.175L173.574 211.971C174.367 212.455 174.764 213.459 174.535 214.418C174.303 215.373 173.509 216.042 172.597 216.042H172.262V220.139L177.971 224.523V176.492C176.724 175.935 175.847 174.588 175.847 173.014V168.372C175.847 166.3 177.372 164.614 179.249 164.614H185.755L217.147 148.636L248.359 164.598V131.016C246.793 130.481 245.652 128.89 245.652 127.015C245.652 124.703 247.384 122.823 249.514 122.823H251.686L259.278 116.915V85.9712C258.415 85.5897 257.807 84.6731 257.807 83.6016V80.0206L261.939 80.0169L266.002 74.677V71.7848L270.398 64.7551L268.465 62.6587C268.028 62.1853 267.789 61.557 267.789 60.8833C267.789 60.2135 268.028 59.5852 268.464 59.1092L273.343 53.8134C273.777 53.34 274.375 53.1033 274.975 53.1033C275.575 53.1033 276.176 53.3412 276.611 53.8172L281.488 59.1092C281.925 59.5852 282.168 60.2147 282.168 60.8871C282.164 61.557 281.925 62.1853 281.487 62.66L279.504 64.8105L283.951 71.7256V74.677L287.993 79.9866L292.146 79.9842V83.5651C292.146 84.6341 291.537 85.5519 290.675 85.936V117.133L298.17 122.823H300.437C302.567 122.823 304.299 124.703 304.299 127.015C304.299 128.888 303.161 130.481 301.595 131.016V155.15H328.638V158.111L339.313 158.12L339.298 164.238H346.247V155.15H370.671V164.238H378.702C377.726 163.043 377.126 161.477 377.126 159.757V159.661C377.126 155.934 379.917 152.9 383.351 152.9H393.465V120.135C390.681 119.464 388.59 116.763 388.59 113.538V113.445C388.59 109.714 391.384 106.68 394.817 106.68H396.803L397.169 106.205L399.775 99.5257L397.157 96.6838L399.608 94.0233L402.629 84.6655L400.998 82.9003L402.585 81.1765L404.559 73.1547L403.509 72.0127L408.855 66.2044L409.519 43.0215L410.296 28.1727L411.074 43.0215L411.732 66.081L417.197 72.0152L415.963 73.3524L418.1 81.1589L419.701 82.899L418.072 84.6655L421.045 93.9704L423.545 96.6838L421.115 99.3242L423.744 106.262L424.067 106.68H426.139C429.575 106.68 432.368 109.714 432.368 113.445V113.538C432.368 116.798 430.233 119.527 427.403 120.161V152.9H427.776V189.539C410.832 190.329 396.649 201.685 391.668 217.169H389.958C387.984 217.17 386.084 217.939 384.664 219.321L372.366 231.29H376.07V232.405C376.07 232.72 376.114 233.025 376.198 233.313H189.183C187.198 233.313 185.292 234.104 183.889 235.512L162.174 257.312V261.096C162.175 263.421 164.056 265.3 166.38 265.302H172.611V422.093C172.039 422.512 171.5 422.972 170.995 423.466C168.316 420.837 164.645 419.215 160.593 419.215V420.16V419.215H146.54H142.237C139.302 410.062 130.723 403.435 120.592 403.435C114.316 403.435 108.635 405.98 104.522 410.092C104.514 410.1 104.507 410.107 104.499 410.115C104.491 410.123 104.483 410.132 104.474 410.141C102.42 412.207 100.761 414.666 99.6187 417.395C98.8468 417.28 98.0586 417.22 97.2553 417.22C89.5696 417.22 83.167 422.692 81.7253 429.952C81.6057 429.948 81.4848 429.946 81.364 429.946C76.1323 429.946 71.8916 434.185 71.8916 439.413C71.8916 440.042 71.9533 440.657 72.0717 441.251ZM44.4882 291.933C44.0061 291.313 43.706 290.516 43.706 289.638V288.406C43.706 287.827 43.9191 287.27 44.2956 286.863C44.6708 286.458 45.1795 286.233 45.707 286.233H45.7209L49.8357 286.265C47.845 287.945 46.0508 289.846 44.4882 291.933ZM477.844 227.512H469.528C469.424 225.271 469.134 223.077 468.675 220.946H469.518C469.52 220.946 469.521 220.946 469.522 220.946C470.509 220.946 471.476 221.339 472.183 222.025L473.497 220.67L472.184 222.026L477.844 227.512V227.512ZM389.802 227.512H381.662L387.299 222.028C388.006 221.338 388.97 220.946 389.955 220.946C389.956 220.946 389.957 220.946 389.958 220.946H390.656C390.196 223.077 389.907 225.271 389.802 227.512ZM731.039 203.332H727.141V200.225H731.039V203.332ZM177.971 203.332H174.073V200.225H177.971V203.332ZM574.628 106.889C574.634 106.842 574.642 106.796 574.65 106.749V106.885C574.642 106.886 574.634 106.888 574.628 106.889ZM574.65 96.602C574.031 92.4444 572.668 88.5323 570.698 85.0017H574.65V96.602Z"
      fill="#ACD0DA"
    />
    <path
      d="M834.627 433.988L857.106 321.15L879.561 433.988H834.627"
      fill="#A8A74A"
    />
    <path
      d="M864.566 358.644L861.086 341.155L857.123 321.178L857.128 321.15L864.566 358.644"
      fill="#B7D6CC"
    />
    <path
      d="M874.491 408.661H839.693L844.715 383.452H869.481L861.086 341.155L864.566 358.644L874.491 408.661"
      fill="#B4B333"
    />
    <path
      d="M857.116 321.206L857.111 321.179L857.116 321.15L857.123 321.178L857.116 321.206Z"
      fill="#D1E6EC"
    />
    <path
      d="M844.715 383.453H844.705L857.111 321.18L857.116 321.206L844.715 383.453"
      fill="#CFCE89"
    />
    <path
      d="M861.086 341.155L857.116 321.206L857.123 321.178L861.086 341.155Z"
      fill="#D8EAE4"
    />
    <path
      d="M869.481 383.453H844.715L857.116 321.206L861.086 341.155L869.481 383.453Z"
      fill="#D6D672"
    />
    <path
      d="M862.706 433.988H851.969V440.661H862.706V433.988Z"
      fill="#C49A6C"
    />
    <path
      d="M862.706 433.988H851.969V440.661H862.706V433.988Z"
      fill="#A8A74A"
    />
    <path
      d="M862.707 433.988V432.099H851.969C851.47 432.099 850.984 432.3 850.633 432.652C850.281 433.003 850.08 433.49 850.08 433.988V440.661C850.08 441.159 850.282 441.646 850.633 441.997C850.984 442.348 851.47 442.55 851.969 442.55H862.707C863.204 442.55 863.69 442.348 864.041 441.997C864.394 441.646 864.595 441.159 864.595 440.661V433.988C864.595 433.49 864.394 433.003 864.041 432.652C863.69 432.3 863.204 432.099 862.707 432.099V433.988H860.818V438.773H853.856V435.877H862.707V433.988H860.818H862.707Z"
      fill="#284356"
    />
    <path
      d="M870.241 438.773H844.433C843.391 438.773 842.544 439.618 842.544 440.661C842.544 441.705 843.391 442.55 844.433 442.55H870.241C871.285 442.55 872.13 441.705 872.13 440.661C872.13 439.618 871.285 438.773 870.241 438.773Z"
      fill="#284356"
    />
    <path
      d="M792.111 355.111C792.111 369.502 780.445 381.164 766.055 381.164C751.668 381.164 740.005 369.502 740.005 355.111C740.005 340.723 751.668 329.061 766.055 329.061C780.445 329.061 792.111 340.723 792.111 355.111Z"
      fill="#A8A74A"
    />
    <path
      d="M766.054 349.256V329.062C777.643 329.062 787.467 336.626 790.851 347.086C787.752 344.673 783.853 343.236 779.62 343.236C774.239 343.236 769.401 345.559 766.054 349.256"
      fill="#CFCE89"
    />
    <path
      d="M769.145 375.383C769.145 390.495 756.897 402.74 741.786 402.74C726.681 402.74 714.433 390.495 714.433 375.383C714.433 360.28 726.681 348.031 741.786 348.031C756.897 348.031 769.145 360.28 769.145 375.383Z"
      fill="#A8A74A"
    />
    <path
      d="M741.786 402.74V392.555C743.336 396.153 745.663 399.337 748.556 401.896C746.39 402.448 744.123 402.74 741.786 402.74ZM753.707 355.077C753.722 354.768 753.73 354.454 753.73 354.139C753.73 352.936 753.618 351.756 753.405 350.614C755.442 351.571 757.341 352.771 759.066 354.177C757.194 354.197 755.393 354.513 753.707 355.077Z"
      fill="#CFCE89"
    />
    <path
      d="M736.755 387.015L729.861 382.115C728.073 380.844 727 378.766 727.001 376.576V357.59C727.001 356.547 726.157 355.701 725.113 355.701C724.07 355.701 723.225 356.547 723.225 357.59L723.224 376.576C723.227 379.996 724.886 383.209 727.671 385.192L734.565 390.094C735.415 390.698 736.595 390.499 737.199 389.649C737.803 388.799 737.604 387.62 736.755 387.015Z"
      fill="#284356"
    />
    <path
      d="M792.469 382.105C792.469 396.695 780.64 408.521 766.052 408.521C751.462 408.521 739.639 396.695 739.639 382.105C739.639 367.517 751.462 355.692 766.052 355.692C780.64 355.692 792.469 367.517 792.469 382.105Z"
      fill="#A8A74A"
    />
    <path
      d="M766.052 408.521V387.756C769.975 386.102 773.167 383.056 775.012 379.236C776.484 379.619 778.027 379.821 779.62 379.821C784.201 379.821 788.388 378.138 791.598 375.356C792.166 377.511 792.469 379.772 792.469 382.105C792.469 396.695 780.64 408.521 766.052 408.521Z"
      fill="#CFCE89"
    />
    <path
      d="M756.699 442.55H741.413C740.37 442.55 739.525 443.396 739.525 444.438C739.525 445.482 740.37 446.327 741.413 446.327H756.699C757.743 446.327 758.588 445.482 758.588 444.438C758.588 443.396 757.743 442.55 756.699 442.55Z"
      fill="#284356"
    />
    <path
      d="M753.73 354.14C753.73 364.697 745.174 373.252 734.615 373.252C724.061 373.252 715.51 364.697 715.51 354.14C715.51 343.586 724.061 335.03 734.615 335.03C745.174 335.03 753.73 343.586 753.73 354.14Z"
      fill="#A8A74A"
    />
    <path
      d="M734.615 373.252V335.03C745.174 335.03 753.73 343.586 753.73 354.14C753.73 354.454 753.722 354.768 753.707 355.078C746.781 357.399 741.79 363.941 741.79 371.648C741.79 371.719 741.79 371.79 741.791 371.86C741.753 371.875 741.717 371.891 741.68 371.906C739.494 372.774 737.111 373.252 734.615 373.252"
      fill="#CFCE89"
    />
    <path
      d="M776.739 371.648C776.739 381.302 768.917 389.125 759.264 389.125C749.614 389.125 741.79 381.302 741.79 371.648C741.79 361.999 749.614 354.177 759.264 354.177C768.917 354.177 776.739 361.999 776.739 371.648Z"
      fill="#A8A74A"
    />
    <path
      d="M759.264 389.125V354.177C760.446 354.177 761.602 354.294 762.719 354.518C761.822 356.677 761.327 359.044 761.327 361.527C761.327 370.04 767.139 377.194 775.011 379.237C773.167 383.057 769.975 386.103 766.052 387.757C763.965 388.637 761.671 389.125 759.264 389.125"
      fill="#CFCE89"
    />
    <path
      d="M797.916 361.527C797.916 371.632 789.724 379.822 779.62 379.822C769.517 379.822 761.328 371.632 761.328 361.527C761.328 351.425 769.517 343.235 779.62 343.235C789.724 343.235 797.916 351.425 797.916 361.527Z"
      fill="#A8A74A"
    />
    <path
      d="M779.62 379.822V343.235C789.725 343.235 797.916 351.425 797.916 361.527C797.916 371.632 789.725 379.822 779.62 379.822Z"
      fill="#CFCE89"
    />
    <path
      d="M750.945 410.903V403.123C750.941 402.102 751.161 400.509 751.578 399.071C751.786 398.35 752.042 397.663 752.32 397.096C752.596 396.528 752.901 396.087 753.139 395.851L753.265 395.711L760.732 386.499C761.006 386.16 761.152 385.746 761.152 385.31V362.034C761.152 360.992 760.308 360.146 759.265 360.146C758.221 360.146 757.376 360.992 757.376 362.034V384.641L750.332 393.331L751.798 394.521L750.458 393.191C749.81 393.847 749.332 394.613 748.928 395.434C748.326 396.664 747.903 398.03 747.612 399.367C747.322 400.707 747.169 402.002 747.167 403.123V410.903C747.167 411.946 748.014 412.792 749.056 412.792C750.099 412.792 750.945 411.946 750.945 410.903"
      fill="#284356"
    />
    <path
      d="M750.507 420.81L778.682 386.991C780.593 384.696 781.64 381.806 781.64 378.821V352.92C781.64 351.877 780.793 351.031 779.751 351.031C778.708 351.031 777.862 351.877 777.862 352.92V378.821C777.862 380.923 777.126 382.957 775.78 384.574L747.606 418.393C746.937 419.193 747.045 420.385 747.847 421.052C748.648 421.72 749.839 421.612 750.508 420.81"
      fill="#284356"
    />
    <path
      d="M731.385 348.03V380.546C731.386 384.123 732.587 387.627 734.778 390.454L736.27 389.296L734.706 390.355L747.164 408.755V444.438C747.164 445.482 748.01 446.327 749.052 446.327C750.096 446.327 750.941 445.482 750.941 444.438V408.176C750.941 407.798 750.828 407.429 750.616 407.117L737.834 388.238L737.762 388.138C736.09 385.985 735.159 383.271 735.162 380.546V348.03C735.162 346.988 734.316 346.142 733.273 346.142C732.231 346.142 731.385 346.988 731.385 348.03Z"
      fill="#284356"
    />
    <path
      d="M787.346 357.745L778.951 371.148C778.674 371.59 778.809 372.173 779.251 372.45C779.693 372.726 780.276 372.592 780.553 372.15L788.946 358.747C789.223 358.306 789.09 357.723 788.648 357.446C788.206 357.169 787.623 357.303 787.346 357.745"
      fill="#284356"
    />
    <path
      d="M769.424 358.358L779.202 365.363C779.626 365.667 780.215 365.57 780.52 365.146C780.824 364.723 780.725 364.132 780.302 363.829L770.523 356.822C770.098 356.518 769.509 356.615 769.206 357.039C768.901 357.464 768.999 358.053 769.424 358.358Z"
      fill="#284356"
    />
    <path
      d="M750.001 366.783L758.82 371.488C759.28 371.733 759.852 371.558 760.098 371.099C760.343 370.638 760.169 370.066 759.708 369.821L750.89 365.117C750.429 364.871 749.857 365.045 749.612 365.506C749.366 365.965 749.54 366.537 750.001 366.783Z"
      fill="#284356"
    />
    <path
      d="M759.885 381.487L765.651 376.466C766.044 376.124 766.086 375.528 765.743 375.134C765.401 374.741 764.805 374.7 764.411 375.042L758.644 380.062C758.251 380.405 758.21 381.001 758.552 381.394C758.895 381.788 759.49 381.83 759.885 381.487"
      fill="#284356"
    />
    <path
      d="M723.467 347.505L732.441 364.245C732.688 364.705 733.259 364.877 733.719 364.632C734.179 364.385 734.352 363.812 734.106 363.352L725.132 346.612C724.885 346.153 724.313 345.98 723.854 346.227C723.394 346.473 723.22 347.046 723.467 347.505Z"
      fill="#284356"
    />
    <path
      d="M745.79 347.939L732.763 356.307C732.324 356.589 732.197 357.174 732.479 357.613C732.761 358.051 733.345 358.178 733.783 357.896L746.811 349.528C747.249 349.246 747.377 348.662 747.096 348.222C746.814 347.784 746.229 347.657 745.79 347.939Z"
      fill="#284356"
    />
    <path
      d="M37.6958 312.375C37.6958 331.239 52.9848 346.526 71.8501 346.526C90.7054 346.526 105.996 331.239 105.996 312.375C105.996 293.515 90.7054 278.229 71.8501 278.229C52.9848 278.229 37.6958 293.515 37.6958 312.375Z"
      fill="#A8A74A"
    />
    <path
      d="M71.8501 346.526C65.7698 346.526 60.061 344.938 55.1164 342.154C53.6244 334.644 48.0201 328.613 40.7476 326.509C38.7882 322.203 37.6958 317.415 37.6958 312.375C37.6958 293.515 52.9848 278.229 71.8501 278.229V346.526"
      fill="#CFCE89"
    />
    <path
      d="M14.594 346.158C14.594 357.459 23.7497 366.619 35.0507 366.619C46.348 366.619 55.5081 357.459 55.5081 346.158C55.5081 334.862 46.348 325.705 35.0507 325.705C23.7497 325.705 14.594 334.862 14.594 346.158Z"
      fill="#A8A74A"
    />
    <path
      d="M35.0507 366.619C23.7497 366.619 14.594 357.459 14.594 346.158C14.594 334.862 23.7497 325.705 35.0507 325.705V366.619"
      fill="#CFCE89"
    />
    <path
      d="M91.8248 370.974L91.0089 392.741C90.9699 393.784 91.7833 394.66 92.8258 394.699C93.8684 394.739 94.7447 393.926 94.7837 392.883L95.5984 371.116C95.6374 370.073 94.8253 369.197 93.7827 369.158C92.7402 369.118 91.8639 369.931 91.8248 370.974"
      fill="#284356"
    />
    <path
      d="M84.3418 354.639C84.3418 368.126 95.2709 379.058 108.759 379.058C122.244 379.058 133.173 368.126 133.173 354.639C133.173 341.155 122.244 330.223 108.759 330.223C95.2709 330.223 84.3418 341.155 84.3418 354.639Z"
      fill="#A8A74A"
    />
    <path
      d="M108.759 379.058C103.848 379.058 99.2774 377.609 95.4497 375.116C94.1327 374.258 92.9025 373.276 91.7794 372.188C87.1924 367.748 84.3418 361.527 84.3418 354.639C84.3418 341.155 95.2709 330.223 108.759 330.223V379.058Z"
      fill="#CFCE89"
    />
    <path
      d="M69.9551 303.022V444.438C69.9551 445.482 70.7999 446.327 71.8438 446.327C72.8863 446.327 73.7324 445.482 73.7324 444.438V303.022C73.7324 301.979 72.8863 301.133 71.8438 301.133C70.7999 301.133 69.9551 301.979 69.9551 303.022Z"
      fill="#284356"
    />
    <path
      d="M73.021 387.702L56.242 374.316L36.9392 358.917V337.644C36.9392 336.602 36.0937 335.755 35.0505 335.755C34.0079 335.755 33.1624 336.602 33.1624 337.644L33.1619 359.826C33.1619 360.4 33.4245 360.945 33.8731 361.303L53.8862 377.27L70.6652 390.654C71.4811 391.305 72.6684 391.171 73.3194 390.356C73.9704 389.541 73.8369 388.353 73.021 387.702"
      fill="#284356"
    />
    <path
      d="M38.0449 380.914L55.4123 377.648C56.4384 377.455 57.1121 376.468 56.9194 375.443C56.7268 374.418 55.7396 373.743 54.7147 373.936L37.3465 377.202C36.3215 377.394 35.6467 378.382 35.8395 379.407C36.0323 380.431 37.0195 381.106 38.0449 380.914"
      fill="#284356"
    />
    <path
      d="M107.376 374.504L70.469 414.112C69.7576 414.876 69.8005 416.071 70.5635 416.781C71.3265 417.493 72.5214 417.451 73.2328 416.688L110.14 377.08C110.851 376.316 110.809 375.121 110.046 374.411C109.283 373.699 108.088 373.741 107.376 374.504Z"
      fill="#284356"
    />
    <path
      d="M110.647 374.502V346.555C110.647 345.512 109.801 344.666 108.759 344.666C107.715 344.666 106.87 345.512 106.87 346.555V374.502C106.87 375.545 107.715 376.391 108.759 376.391C109.801 376.391 110.647 375.545 110.647 374.502Z"
      fill="#284356"
    />
    <path
      d="M97.8989 351.06L108.093 361.198C108.463 361.566 109.06 361.565 109.429 361.195C109.796 360.825 109.794 360.226 109.425 359.859L99.2311 349.72C98.8609 349.353 98.2628 349.355 97.8952 349.724C97.5275 350.094 97.5288 350.692 97.8989 351.06Z"
      fill="#284356"
    />
    <path
      d="M121.092 351.728L108.125 363.464C107.737 363.813 107.708 364.411 108.058 364.798C108.408 365.184 109.005 365.215 109.392 364.864L122.36 353.128C122.746 352.779 122.776 352.181 122.426 351.795C122.076 351.408 121.479 351.378 121.092 351.728Z"
      fill="#284356"
    />
    <path
      d="M23.1727 341.711L34.4743 350.424C34.8874 350.743 35.48 350.666 35.7988 350.253C36.1175 349.84 36.0407 349.247 35.6276 348.928L24.326 340.215C23.9129 339.897 23.3202 339.974 23.0016 340.387C22.6833 340.8 22.7601 341.393 23.1727 341.711Z"
      fill="#284356"
    />
    <path
      d="M43.7103 344.049L34.4282 352.195C34.0362 352.539 33.9973 353.136 34.341 353.527C34.6854 353.919 35.282 353.958 35.6739 353.614L44.9555 345.468C45.3484 345.124 45.3874 344.527 45.0424 344.136C44.6987 343.743 44.1022 343.705 43.7103 344.049Z"
      fill="#284356"
    />
    <path
      d="M54.0362 301.602L71.1074 322.791C71.4347 323.197 72.029 323.26 72.4357 322.934C72.8424 322.607 72.9054 322.013 72.578 321.606L55.5069 300.417C55.1795 300.011 54.5852 299.948 54.1785 300.274C53.7731 300.601 53.7089 301.196 54.0362 301.602Z"
      fill="#284356"
    />
    <path
      d="M89.5446 306.734L71.091 331.7C70.7812 332.119 70.8694 332.711 71.2887 333.021C71.7092 333.331 72.2998 333.242 72.6095 332.823L91.0644 307.856C91.3741 307.437 91.2847 306.846 90.8654 306.535C90.4461 306.226 89.8556 306.315 89.5446 306.734Z"
      fill="#284356"
    />
    <path
      d="M57.5781 446.327H86.1198C87.1636 446.327 88.0085 445.482 88.0085 444.438C88.0085 443.396 87.1636 442.55 86.1198 442.55H57.5781C56.5356 442.55 55.6895 443.396 55.6895 444.438C55.6895 445.482 56.5356 446.327 57.5781 446.327"
      fill="#284356"
    />
    <path
      d="M766.674 444.438C767.433 443.233 767.878 441.817 767.878 440.287C767.878 435.968 764.373 432.468 760.052 432.468C755.731 432.468 752.229 435.968 752.229 440.287C752.229 441.817 752.672 443.233 753.428 444.438H766.674"
      fill="#A8A74A"
    />
    <path
      d="M781.304 444.438H803.605C808.227 441.02 811.224 435.531 811.224 429.343C811.224 418.976 802.822 410.571 792.453 410.571C782.087 410.571 773.682 418.976 773.682 429.343C773.682 435.531 776.683 441.02 781.304 444.438Z"
      fill="#A8A74A"
    />
    <path
      d="M817.634 444.438C819.257 442.57 820.247 440.137 820.247 437.469C820.247 431.591 815.483 426.829 809.603 426.829C803.726 426.829 798.961 431.591 798.961 437.469C798.961 440.137 799.95 442.57 801.571 444.438H817.634"
      fill="#A8A74A"
    />
    <path
      d="M764.101 444.438H782.249C784.714 442.062 786.254 438.731 786.254 435.035C786.254 427.81 780.399 421.957 773.178 421.957C765.952 421.957 760.101 427.81 760.101 435.035C760.101 438.731 761.637 442.062 764.101 444.438"
      fill="#A8A74A"
    />
    <path
      d="M775.13 422.103C776.081 419.831 777.466 417.785 779.179 416.07C777.465 417.785 776.081 419.83 775.13 422.103Z"
      fill="#D1E6EC"
    />
    <path
      d="M792.453 441.251H784.679C785.683 439.403 786.254 437.288 786.254 435.036C786.254 428.475 781.426 423.044 775.13 422.102C776.081 419.83 777.465 417.785 779.179 416.07C782.577 412.673 787.269 410.573 792.453 410.572V441.251Z"
      fill="#CFCE89"
    />
    <path
      d="M784.679 441.251H777.947C775.282 438.012 773.682 433.865 773.682 429.344C773.682 426.776 774.197 424.331 775.13 422.102C781.426 423.044 786.254 428.475 786.254 435.036C786.254 437.288 785.683 439.403 784.679 441.251Z"
      fill="#CFCE89"
    />
    <path
      d="M760.101 435.036C760.101 435.022 760.101 435.008 760.101 434.994C760.101 435.008 760.101 435.022 760.101 435.036ZM760.101 434.98C760.101 434.971 760.101 434.961 760.101 434.953C760.101 434.961 760.101 434.971 760.101 434.98ZM760.101 434.933C760.101 434.926 760.101 434.919 760.101 434.911C760.101 434.919 760.101 434.926 760.101 434.933ZM760.101 434.892C760.101 434.884 760.101 434.877 760.101 434.868C760.101 434.875 760.101 434.884 760.101 434.892ZM760.102 434.85C760.102 434.843 760.102 434.836 760.102 434.828C760.102 434.836 760.102 434.843 760.102 434.85ZM760.102 434.807C760.102 434.8 760.102 434.792 760.102 434.786C760.102 434.792 760.102 434.8 760.102 434.807ZM760.104 434.766C760.104 434.758 760.104 434.752 760.104 434.745C760.104 434.752 760.104 434.758 760.104 434.766ZM760.104 434.724C760.105 434.717 760.105 434.711 760.105 434.703C760.105 434.711 760.105 434.717 760.104 434.724ZM760.105 434.683C760.105 434.675 760.105 434.669 760.106 434.661C760.105 434.669 760.105 434.675 760.105 434.683ZM760.106 434.641C760.106 434.635 760.106 434.628 760.107 434.62C760.106 434.628 760.106 434.634 760.106 434.641ZM760.107 434.6C760.107 434.594 760.109 434.586 760.109 434.58C760.109 434.586 760.107 434.592 760.107 434.6ZM760.109 434.557C760.109 434.551 760.11 434.544 760.11 434.54C760.11 434.544 760.109 434.551 760.109 434.557ZM760.111 434.515C760.111 434.51 760.111 434.503 760.111 434.498C760.111 434.504 760.111 434.509 760.111 434.515ZM760.112 434.473C760.112 434.468 760.112 434.463 760.112 434.458C760.112 434.463 760.112 434.468 760.112 434.473ZM760.114 434.432C760.115 434.426 760.115 434.422 760.115 434.416C760.115 434.421 760.115 434.427 760.114 434.432ZM760.116 434.389C760.116 434.385 760.116 434.381 760.116 434.376C760.116 434.381 760.116 434.386 760.116 434.389ZM760.119 434.349C760.119 434.344 760.119 434.34 760.119 434.335C760.119 434.34 760.119 434.344 760.119 434.349ZM760.12 434.308C760.12 434.304 760.121 434.299 760.121 434.295C760.121 434.299 760.12 434.304 760.12 434.308ZM760.122 434.267C760.122 434.263 760.123 434.259 760.124 434.255C760.124 434.259 760.122 434.263 760.122 434.267ZM760.125 434.225C760.125 434.222 760.125 434.218 760.126 434.214C760.125 434.218 760.125 434.222 760.125 434.225ZM760.128 434.184C760.128 434.18 760.128 434.178 760.129 434.176C760.128 434.178 760.128 434.182 760.128 434.184ZM760.13 434.143C760.13 434.14 760.131 434.139 760.131 434.137C760.131 434.139 760.13 434.14 760.13 434.143ZM760.134 434.101C760.134 434.1 760.134 434.1 760.134 434.099C760.134 434.1 760.134 434.1 760.134 434.101Z"
      fill="#CFCE89"
    />
    <path
      d="M772.505 441.251H761.674C760.67 439.403 760.101 437.288 760.101 435.036C760.101 435.022 760.101 435.008 760.101 434.995C760.101 434.99 760.101 434.985 760.101 434.981C760.101 434.972 760.101 434.962 760.101 434.953C760.101 434.947 760.101 434.941 760.101 434.934C760.101 434.927 760.101 434.919 760.101 434.912C760.101 434.905 760.101 434.899 760.101 434.893C760.101 434.885 760.101 434.876 760.101 434.869C760.101 434.864 760.101 434.857 760.102 434.851C760.102 434.844 760.102 434.836 760.102 434.828C760.102 434.821 760.102 434.815 760.102 434.808C760.102 434.801 760.102 434.793 760.102 434.787C760.102 434.781 760.104 434.773 760.104 434.767C760.104 434.759 760.104 434.753 760.104 434.745C760.104 434.739 760.104 434.732 760.104 434.725C760.105 434.718 760.105 434.711 760.105 434.704C760.105 434.698 760.105 434.69 760.105 434.684C760.105 434.676 760.105 434.67 760.106 434.662C760.106 434.655 760.106 434.648 760.106 434.642C760.106 434.635 760.106 434.628 760.107 434.621C760.107 434.614 760.107 434.607 760.107 434.601C760.107 434.593 760.109 434.587 760.109 434.581C760.109 434.573 760.109 434.565 760.109 434.558C760.109 434.551 760.11 434.545 760.11 434.54C760.11 434.531 760.11 434.524 760.111 434.516C760.111 434.51 760.111 434.505 760.111 434.498C760.111 434.49 760.112 434.482 760.112 434.473C760.112 434.468 760.112 434.463 760.112 434.459C760.114 434.45 760.114 434.441 760.114 434.433C760.115 434.428 760.115 434.422 760.115 434.417C760.115 434.409 760.116 434.399 760.116 434.39C760.116 434.387 760.116 434.381 760.116 434.376C760.117 434.367 760.117 434.359 760.119 434.35C760.119 434.345 760.119 434.341 760.119 434.336C760.119 434.327 760.12 434.317 760.12 434.309C760.12 434.305 760.121 434.3 760.121 434.296C760.121 434.287 760.122 434.277 760.122 434.268C760.122 434.263 760.124 434.259 760.124 434.255C760.124 434.246 760.125 434.235 760.125 434.225C760.125 434.223 760.125 434.219 760.126 434.215C760.126 434.205 760.128 434.195 760.128 434.185C760.128 434.183 760.128 434.179 760.129 434.176C760.129 434.165 760.13 434.154 760.13 434.144C760.13 434.141 760.131 434.14 760.131 434.137C760.131 434.126 760.133 434.113 760.134 434.102C760.134 434.101 760.134 434.101 760.134 434.1C760.598 427.537 765.903 422.328 772.505 421.993V441.251"
      fill="#CFCE89"
    />
    <path
      d="M809.603 441.251H799.656C799.208 440.076 798.961 438.803 798.961 437.47C798.961 431.593 803.726 426.831 809.603 426.831V441.251Z"
      fill="#CFCE89"
    />
    <path
      d="M824.115 442.55H748.394C747.35 442.55 746.505 443.396 746.505 444.438C746.505 445.482 747.35 446.327 748.394 446.327H824.115C825.159 446.327 826.003 445.482 826.003 444.438C826.003 443.396 825.159 442.55 824.115 442.55Z"
      fill="#284356"
    />
    <path
      d="M89.3807 444.438C90.2986 442.98 90.8375 441.263 90.8375 439.412C90.8375 434.184 86.5943 429.945 81.3639 429.945C76.1323 429.945 71.8916 434.184 71.8916 439.412C71.8916 441.263 72.4292 442.98 73.3434 444.438H89.3807"
      fill="#A8A74A"
    />
    <path
      d="M107.093 444.438H134.095C139.689 440.3 143.318 433.655 143.318 426.161C143.318 413.61 133.145 403.434 120.592 403.434C108.042 403.434 97.866 413.61 97.866 426.161C97.866 433.655 101.496 440.3 107.093 444.438Z"
      fill="#A8A74A"
    />
    <path
      d="M151.079 444.438C153.044 442.175 154.242 439.232 154.242 435.999C154.242 428.884 148.474 423.119 141.357 423.119C134.241 423.119 128.47 428.884 128.47 435.999C128.47 439.232 129.667 442.175 131.633 444.438H151.079"
      fill="#A8A74A"
    />
    <path
      d="M86.267 444.438H108.24C111.225 441.563 113.086 437.527 113.086 433.052C113.086 424.306 105.997 417.219 97.2553 417.219C88.5082 417.219 81.4219 424.306 81.4219 433.052C81.4219 437.527 83.2828 441.563 86.267 444.438Z"
      fill="#A8A74A"
    />
    <path
      d="M99.6187 417.394C100.761 414.666 102.42 412.206 104.474 410.14C102.42 412.206 100.761 414.666 99.6187 417.394ZM104.499 410.114C104.507 410.106 104.514 410.099 104.522 410.091C104.514 410.099 104.507 410.106 104.499 410.114Z"
      fill="#D1E6EC"
    />
    <path
      d="M117.522 441.251H110.795C112.249 438.862 113.086 436.056 113.086 433.053C113.086 425.111 107.24 418.537 99.6187 417.395C100.761 414.666 102.42 412.207 104.474 410.141C104.483 410.132 104.491 410.123 104.499 410.115C104.507 410.107 104.514 410.1 104.522 410.092C108.635 405.98 114.316 403.436 120.592 403.435V424.861C118.591 427.392 117.396 430.589 117.396 434.067V440.202C117.396 440.564 117.44 440.915 117.522 441.251"
      fill="#CFCE89"
    />
    <path
      d="M110.795 441.251H103.602C100.034 437.238 97.866 431.954 97.866 426.162C97.866 423.055 98.4892 420.093 99.6187 417.395C107.24 418.537 113.086 425.111 113.086 433.053C113.086 436.056 112.249 438.862 110.795 441.251"
      fill="#CFCE89"
    />
    <path
      d="M81.4219 433.053C81.4219 433.036 81.4219 433.02 81.4219 433.002C81.4219 433.02 81.4219 433.036 81.4219 433.053ZM81.4219 432.993C81.4219 432.98 81.4219 432.966 81.4219 432.952C81.4219 432.966 81.4219 432.98 81.4219 432.993ZM81.4219 432.936C81.4219 432.924 81.4219 432.913 81.4231 432.902C81.4219 432.913 81.4219 432.924 81.4219 432.936ZM81.4231 432.88C81.4231 432.87 81.4231 432.861 81.4231 432.852C81.4231 432.861 81.4231 432.87 81.4231 432.88ZM81.4231 432.826C81.4231 432.818 81.4231 432.809 81.4244 432.802C81.4231 432.809 81.4231 432.817 81.4231 432.826ZM81.4244 432.776C81.4244 432.768 81.4244 432.759 81.4244 432.752C81.4244 432.759 81.4244 432.767 81.4244 432.776ZM81.4257 432.725C81.4257 432.718 81.4257 432.71 81.4257 432.701C81.4257 432.71 81.4257 432.718 81.4257 432.725ZM81.4257 432.674C81.4269 432.666 81.4269 432.658 81.4269 432.651C81.4269 432.66 81.4269 432.666 81.4257 432.674ZM81.4269 432.626C81.4282 432.618 81.4282 432.609 81.4282 432.602C81.4282 432.609 81.4282 432.617 81.4269 432.626ZM81.4294 432.574C81.4294 432.567 81.4294 432.559 81.4294 432.552C81.4294 432.559 81.4294 432.567 81.4294 432.574ZM81.4307 432.524C81.4307 432.516 81.4307 432.51 81.4307 432.503C81.4307 432.509 81.4307 432.516 81.4307 432.524ZM81.4319 432.474C81.4319 432.466 81.4332 432.46 81.4332 432.452C81.4332 432.46 81.4319 432.466 81.4319 432.474ZM81.4345 432.423C81.4345 432.417 81.4345 432.409 81.4345 432.403C81.4345 432.409 81.4345 432.417 81.4345 432.423ZM81.4357 432.373C81.437 432.366 81.437 432.36 81.437 432.354C81.437 432.36 81.437 432.366 81.4357 432.373ZM81.4382 432.323C81.4382 432.318 81.4395 432.31 81.4395 432.305C81.4395 432.31 81.4382 432.318 81.4382 432.323ZM81.4408 432.271C81.4408 432.266 81.4408 432.262 81.442 432.257C81.4408 432.262 81.4408 432.266 81.4408 432.271ZM81.4433 432.222C81.4433 432.217 81.4433 432.212 81.4445 432.206C81.4433 432.212 81.4433 432.217 81.4433 432.222ZM81.4458 432.172C81.4458 432.168 81.4471 432.163 81.4471 432.159C81.4458 432.163 81.4458 432.168 81.4458 432.172ZM81.4483 432.121C81.4496 432.117 81.4496 432.114 81.4496 432.111C81.4496 432.115 81.4496 432.117 81.4483 432.121ZM81.4521 432.071C81.4521 432.068 81.4521 432.067 81.4521 432.064C81.4521 432.065 81.4521 432.068 81.4521 432.071ZM81.4546 432.022C81.4546 432.019 81.4546 432.017 81.4559 432.015C81.4546 432.018 81.4546 432.019 81.4546 432.022Z"
      fill="#CFCE89"
    />
    <path
      d="M96.4419 441.251H83.7135C82.2604 438.862 81.4219 436.056 81.4219 433.053C81.4219 433.037 81.4219 433.02 81.4219 433.003C81.4219 433 81.4219 432.996 81.4219 432.994C81.4219 432.98 81.4219 432.966 81.4219 432.952C81.4219 432.948 81.4219 432.941 81.4219 432.936C81.4219 432.924 81.4219 432.913 81.4231 432.902C81.4231 432.894 81.4231 432.888 81.4231 432.881C81.4231 432.87 81.4231 432.861 81.4231 432.853C81.4231 432.844 81.4231 432.835 81.4231 432.827C81.4231 432.818 81.4231 432.81 81.4244 432.803C81.4244 432.794 81.4244 432.785 81.4244 432.776C81.4244 432.767 81.4244 432.76 81.4244 432.752C81.4244 432.743 81.4244 432.735 81.4257 432.726C81.4257 432.718 81.4257 432.711 81.4257 432.702C81.4257 432.693 81.4257 432.684 81.4257 432.674C81.4269 432.667 81.4269 432.66 81.4269 432.652C81.4269 432.643 81.4269 432.635 81.4269 432.626C81.4282 432.618 81.4282 432.61 81.4282 432.602C81.4282 432.593 81.4282 432.584 81.4294 432.575C81.4294 432.567 81.4294 432.56 81.4294 432.552C81.4294 432.543 81.4307 432.534 81.4307 432.524C81.4307 432.517 81.4307 432.509 81.4307 432.503C81.4319 432.494 81.4319 432.483 81.4319 432.474C81.4319 432.467 81.4332 432.46 81.4332 432.452C81.4332 432.442 81.4332 432.434 81.4345 432.424C81.4345 432.417 81.4345 432.41 81.4345 432.404C81.4357 432.393 81.4357 432.384 81.4357 432.373C81.437 432.367 81.437 432.361 81.437 432.354C81.437 432.343 81.4382 432.334 81.4382 432.323C81.4382 432.318 81.4395 432.31 81.4395 432.305C81.4395 432.294 81.4408 432.283 81.4408 432.271C81.4408 432.266 81.4408 432.263 81.442 432.258C81.442 432.246 81.4433 432.233 81.4433 432.222C81.4433 432.217 81.4433 432.212 81.4445 432.207C81.4445 432.195 81.4458 432.183 81.4458 432.172C81.4458 432.168 81.4458 432.163 81.4471 432.159C81.4471 432.146 81.4483 432.134 81.4483 432.121C81.4496 432.117 81.4496 432.115 81.4496 432.111C81.4496 432.098 81.4508 432.083 81.4521 432.071C81.4521 432.069 81.4521 432.066 81.4521 432.065C81.4534 432.049 81.4546 432.036 81.4546 432.022C81.4546 432.019 81.4546 432.018 81.4559 432.016C81.9721 424.025 88.4175 417.67 96.4419 417.263V441.251"
      fill="#CFCE89"
    />
    <path
      d="M158.927 442.55H67.2481C66.2055 442.55 65.3594 443.396 65.3594 444.438C65.3594 445.482 66.2055 446.327 67.2481 446.327H158.927C159.969 446.327 160.816 445.482 160.816 444.438C160.816 443.396 159.969 442.55 158.927 442.55Z"
      fill="#284356"
    />
    <path
      d="M3.18909 447.629H917.811C919.572 447.629 921 446.202 921 444.44C921 442.68 919.572 441.252 917.811 441.252H3.18909C1.42834 441.252 0 442.68 0 444.44C0 446.202 1.42834 447.629 3.18909 447.629"
      fill="#284356"
    />
    <path
      d="M611.396 138.515C610.353 138.515 609.507 137.669 609.507 136.627C609.504 129.389 606.284 122.833 600.993 118.03C595.702 113.232 588.355 110.237 580.209 110.238C578.305 110.238 576.446 110.402 574.649 110.713V106.885C576.456 106.606 578.315 106.461 580.209 106.461C589.284 106.461 597.531 109.794 603.53 115.231C609.526 120.66 613.287 128.242 613.284 136.627C613.284 137.669 612.438 138.515 611.396 138.515V138.515ZM331.109 114.299C330.105 114.299 329.27 113.509 329.224 112.497L329.209 112.177L329.207 112.09C329.209 97.7024 336.869 85.0923 348.324 78.1281C347.798 75.2523 347.515 72.2846 347.515 69.2564C347.516 42.4875 369.209 20.7955 395.978 20.7955C398.446 20.7955 400.864 20.9869 403.233 21.3432C411.926 8.47123 426.674 -7.57789e-05 443.389 -7.57789e-05C470.157 0.00118334 491.85 21.692 491.85 48.4633C491.851 50.313 491.743 52.1362 491.539 53.9291C493.431 53.4733 495.407 53.2291 497.439 53.2291C497.44 53.2291 497.442 53.2291 497.442 53.2291C509.461 53.2329 519.506 61.6463 522.016 72.8978C527.389 69.4025 533.808 67.3677 540.694 67.3677C540.695 67.3677 540.696 67.3677 540.699 67.3677C553.597 67.369 564.833 74.483 570.698 85.0016H566.286C565.128 83.2301 563.791 81.5844 562.299 80.0923C556.764 74.561 549.139 71.1463 540.699 71.1451C533.552 71.1463 527.002 73.5928 521.801 77.6975C521.461 77.9657 521.048 78.1042 520.63 78.1042C520.378 78.1042 520.125 78.0538 519.885 77.9518C519.248 77.6786 518.813 77.0806 518.75 76.3906C517.742 65.5357 508.592 57.0065 497.449 57.0065C497.447 57.0065 497.444 57.0065 497.442 57.0065C494.785 57.0077 492.259 57.4925 489.905 58.3738C489.688 58.4557 489.463 58.496 489.24 58.496C488.807 58.496 488.38 58.3461 488.034 58.0578C487.511 57.6234 487.263 56.9473 487.381 56.2774C487.831 53.739 488.074 51.1276 488.074 48.4633C488.073 36.1152 483.075 24.9556 474.987 16.8633C466.894 8.7747 455.736 3.77853 443.389 3.77728C443.388 3.77728 443.388 3.77728 443.387 3.77728C427.557 3.77728 413.66 12.0094 405.731 24.4205C405.38 24.9707 404.778 25.2931 404.141 25.2931C404.033 25.2931 403.922 25.283 403.812 25.2641C401.251 24.8146 398.646 24.5728 395.978 24.5716C383.631 24.5728 372.472 29.5703 364.379 37.6588C356.29 45.7499 351.293 56.9095 351.292 69.2564C351.292 72.486 351.641 75.6464 352.286 78.6897C352.456 79.4993 352.083 80.3228 351.363 80.7269C340.408 86.8815 333 98.5963 332.985 112.046L332.997 112.324C333.045 113.366 332.238 114.25 331.197 114.298C331.168 114.299 331.138 114.299 331.109 114.299V114.299ZM574.649 106.749V96.6019C574.896 98.2627 575.023 99.9625 575.023 101.691C575.023 103.41 574.895 105.098 574.649 106.749Z"
      fill="#E4F7FA"
    />
    <path
      d="M572.235 111.172C571.74 111.172 571.256 110.977 570.898 110.618C570.434 110.153 570.244 109.48 570.398 108.841C570.95 106.541 571.246 104.155 571.246 101.691C571.246 95.5263 569.424 89.7986 566.287 85.0014H570.699C572.668 88.5319 574.031 92.444 574.65 96.6016V106.749C574.642 106.795 574.635 106.842 574.628 106.889C574.635 106.887 574.642 106.886 574.65 106.885V110.713C573.982 110.828 573.323 110.964 572.674 111.12C572.528 111.154 572.381 111.172 572.235 111.172"
      fill="#CFE4EA"
    />
    <path
      d="M48.1106 192.758C47.0668 192.758 46.2219 191.912 46.2219 190.869C46.2194 185.025 48.8434 179.742 53.0048 175.977C57.1662 172.206 62.8763 169.903 69.1517 169.902C70.1829 169.902 71.2003 169.966 72.1975 170.089C72.088 169.173 72.0313 168.243 72.0313 167.301C72.0326 154.172 82.6809 143.527 95.8085 143.525C100.268 143.525 104.452 144.76 108.021 146.904C110.072 139.457 116.89 133.99 124.99 133.986C126.114 133.986 127.213 134.092 128.279 134.294C128.194 133.336 128.151 132.367 128.151 131.387C128.153 112.986 143.062 98.0734 161.464 98.0734C172.81 98.0734 182.841 103.757 188.843 112.426C190.351 112.214 191.884 112.104 193.449 112.104C211.852 112.105 226.757 127.018 226.758 145.414C226.758 146.457 225.912 147.302 224.869 147.302C223.825 147.302 222.981 146.457 222.981 145.414C222.979 137.253 219.679 129.882 214.333 124.531C208.984 119.184 201.613 115.882 193.449 115.881C191.684 115.881 189.965 116.04 188.272 116.341C188.162 116.36 188.051 116.37 187.942 116.37C187.305 116.37 186.702 116.047 186.35 115.497C181.106 107.29 171.925 101.849 161.464 101.851C153.3 101.851 145.929 105.153 140.579 110.501C135.231 115.851 131.93 123.223 131.929 131.387C131.929 133.151 132.086 134.871 132.385 136.553C132.503 137.223 132.255 137.902 131.731 138.336C131.386 138.623 130.959 138.772 130.526 138.772C130.301 138.772 130.074 138.732 129.858 138.65C128.339 138.077 126.712 137.763 124.99 137.763C124.987 137.763 124.985 137.763 124.982 137.763C117.79 137.763 111.877 143.276 111.228 150.288C111.163 150.978 110.728 151.577 110.091 151.849C109.851 151.952 109.598 152.003 109.347 152.003C108.93 152.003 108.515 151.863 108.177 151.595C104.772 148.906 100.486 147.304 95.8085 147.302C90.2822 147.304 85.2936 149.539 81.6686 153.161C78.0449 156.787 75.8099 161.775 75.8087 167.301C75.8087 168.905 76.0051 170.47 76.3677 171.985C76.5201 172.623 76.3312 173.296 75.8666 173.76C75.5077 174.118 75.0255 174.313 74.5307 174.313C74.3846 174.313 74.2373 174.297 74.0912 174.261C72.5211 173.886 70.8591 173.68 69.1517 173.68C69.1504 173.68 69.1505 173.68 69.1492 173.68C63.8042 173.68 58.9944 175.645 55.5419 178.776C52.0869 181.915 50.0018 186.171 49.9993 190.869C49.9993 191.912 49.1532 192.758 48.1106 192.758"
      fill="#E4F7FA"
    />
    <path
      d="M823.83 187.151C822.786 187.151 821.942 186.305 821.942 185.262C821.939 179.481 819.37 174.246 815.133 170.398C810.898 166.557 805.008 164.153 798.468 164.154C796.38 164.154 794.347 164.407 792.427 164.867C792.28 164.902 792.133 164.919 791.986 164.919C791.491 164.919 791.008 164.723 790.65 164.366C790.185 163.901 789.995 163.228 790.15 162.589C790.595 160.738 790.834 158.819 790.834 156.853C790.833 150.087 788.094 143.978 783.657 139.54C779.217 135.105 773.105 132.368 766.339 132.367C760.611 132.367 755.361 134.332 751.194 137.623C750.854 137.892 750.441 138.03 750.023 138.03C749.771 138.03 749.518 137.98 749.279 137.878C748.642 137.604 748.206 137.006 748.142 136.316C747.339 127.665 740.047 120.868 731.176 120.868C731.173 120.868 731.17 120.868 731.168 120.868C729.046 120.868 727.036 121.254 725.166 121.96C724.948 122.042 724.721 122.082 724.497 122.082C724.064 122.082 723.638 121.934 723.293 121.648C722.77 121.213 722.52 120.536 722.639 119.865C723 117.815 723.194 115.716 723.194 113.568C723.193 103.623 719.17 94.6384 712.655 88.1212C706.138 81.6065 697.153 77.5836 687.206 77.5824C687.205 77.5824 687.206 77.5824 687.205 77.5824C674.465 77.5824 663.275 84.2116 656.881 94.2103C656.521 94.7744 655.912 95.0829 655.289 95.0829C654.94 95.0829 654.589 94.9859 654.274 94.7857C653.394 94.2229 653.137 93.0557 653.698 92.1768C660.752 81.1343 673.131 73.805 687.206 73.805C709.174 73.8063 726.97 91.6039 726.971 113.568C726.971 114.916 726.902 116.247 726.77 117.558C728.186 117.252 729.656 117.091 731.163 117.091C731.165 117.091 731.167 117.091 731.168 117.091C740.932 117.095 749.124 123.811 751.379 132.878C755.713 130.163 760.847 128.589 766.335 128.589C766.335 128.589 766.338 128.589 766.339 128.589C781.948 128.59 794.609 141.246 794.611 156.853C794.611 158.143 794.522 159.415 794.35 160.663C795.693 160.475 797.069 160.377 798.468 160.377C805.937 160.378 812.727 163.118 817.671 167.599C822.613 172.073 825.721 178.336 825.719 185.262C825.719 186.305 824.873 187.151 823.83 187.151"
      fill="#E4F7FA"
    />
    <path
      d="M219.081 54.1399C219.081 41.8093 209.085 31.8157 196.756 31.8157C184.427 31.8157 174.433 41.8093 174.433 54.1399C174.433 66.4704 184.427 76.464 196.756 76.464C209.085 76.464 219.081 66.4704 219.081 54.1399Z"
      fill="#FCFCFC"
    />
    <path
      d="M216.107 88.396C216.754 89.4045 218.099 89.6967 219.106 89.0482C220.115 88.401 220.408 87.0576 219.759 86.0477L215.061 78.7386C214.412 77.73 213.07 77.4379 212.062 78.0851C211.053 78.7348 210.761 80.0795 211.407 81.0868L216.107 88.396Z"
      fill="#FCFCFC"
    />
    <path
      d="M231.451 72.5571C232.541 73.0544 233.83 72.5722 234.327 71.4831C234.826 70.3927 234.347 69.1046 233.255 68.6072L225.349 64.9973C224.26 64.4987 222.973 64.9785 222.472 66.0701C221.977 67.1592 222.457 68.4473 223.546 68.9472L231.451 72.5571"
      fill="#FCFCFC"
    />
    <path
      d="M235.795 50.9328C236.983 50.7616 237.806 49.6612 237.634 48.4751C237.466 47.289 236.365 46.4655 235.176 46.6355L226.577 47.872C225.389 48.0432 224.565 49.1424 224.737 50.3285C224.907 51.5158 226.008 52.3393 227.194 52.1693L235.795 50.9328Z"
      fill="#FCFCFC"
    />
    <path
      d="M227.762 30.3943C228.667 29.6099 228.764 28.2399 227.979 27.3321C227.194 26.4268 225.824 26.3286 224.919 27.113L218.351 32.8042C217.444 33.5886 217.346 34.9598 218.131 35.8651C218.916 36.773 220.288 36.8699 221.194 36.0855L227.762 30.3943Z"
      fill="#FCFCFC"
    />
    <path
      d="M209.897 17.4592C210.236 16.3084 209.578 15.1021 208.424 14.7634C207.275 14.426 206.067 15.0845 205.731 16.2366L203.283 24.5732C202.946 25.7241 203.604 26.9316 204.754 27.2677C205.905 27.6064 207.111 26.9467 207.45 25.7958L209.897 17.4592Z"
      fill="#FCFCFC"
    />
    <path
      d="M187.878 16.2366C187.539 15.0845 186.333 14.426 185.181 14.7634C184.03 15.1021 183.373 16.3084 183.711 17.4592L186.158 25.7958C186.497 26.9467 187.703 27.6064 188.852 27.2677C190.004 26.9316 190.662 25.7241 190.324 24.5732L187.878 16.2366Z"
      fill="#FCFCFC"
    />
    <path
      d="M168.691 27.113C167.783 26.3286 166.412 26.4268 165.627 27.3321C164.842 28.2399 164.94 29.6099 165.846 30.3943L172.412 36.0855C173.319 36.8699 174.691 36.773 175.475 35.8651C176.26 34.9598 176.163 33.5886 175.256 32.8042L168.691 27.113Z"
      fill="#FCFCFC"
    />
    <path
      d="M158.431 46.6355C157.243 46.4655 156.143 47.289 155.972 48.4751C155.802 49.6612 156.624 50.7616 157.811 50.9328L166.412 52.1693C167.6 52.3393 168.699 51.5158 168.87 50.3285C169.041 49.1424 168.219 48.0432 167.031 47.872L158.431 46.6355Z"
      fill="#FCFCFC"
    />
    <path
      d="M160.352 68.6072C159.262 69.1046 158.781 70.3927 159.281 71.4831C159.777 72.5722 161.065 73.0544 162.157 72.5571L170.06 68.9472C171.152 68.4473 171.63 67.1592 171.135 66.0701C170.635 64.9785 169.347 64.4987 168.257 64.9973L160.352 68.6072Z"
      fill="#FCFCFC"
    />
    <path
      d="M173.849 86.0477C173.201 87.0576 173.492 88.401 174.501 89.0482C175.508 89.6967 176.853 89.4045 177.501 88.396L182.199 81.0868C182.846 80.0795 182.553 78.7348 181.547 78.0851C180.538 77.4379 179.194 77.73 178.546 78.7386L173.849 86.0477"
      fill="#FCFCFC"
    />
    <path
      d="M194.633 93.4284C194.633 94.6258 195.605 95.5979 196.805 95.5979C198.002 95.5979 198.974 94.6258 198.974 93.4284V84.738C198.974 83.5393 198.002 82.5673 196.805 82.5673C195.605 82.5673 194.633 83.5393 194.634 84.738L194.633 93.4284Z"
      fill="#FCFCFC"
    />
    <path
      d="M431.553 191.384V122.662C431.553 121.618 430.707 120.774 429.665 120.774C428.621 120.774 427.776 121.618 427.776 122.662V191.384C427.776 192.426 428.621 193.272 429.665 193.272C430.707 193.272 431.553 192.426 431.553 191.384Z"
      fill="#284356"
    />
    <path
      d="M464.813 145.19C452.161 133.439 442.545 158.399 429.895 146.648C429.895 137.609 429.895 133.09 429.895 124.051C442.547 135.805 452.161 110.843 464.812 122.598C464.812 131.636 464.813 136.154 464.813 145.19Z"
      fill="#B26767"
    />
    <path
      d="M464.813 145.19L465.455 144.499C462.802 142.021 460.116 141.005 457.534 141.014C455.602 141.014 453.764 141.558 452.003 142.331C449.36 143.496 446.854 145.183 444.389 146.548C441.922 147.919 439.523 148.941 437.171 148.936C435.081 148.928 432.947 148.181 430.537 145.956L429.895 146.649H430.839C430.839 137.609 430.839 133.09 430.839 124.051H429.895L429.252 124.744C431.906 127.222 434.592 128.238 437.174 128.23C439.105 128.229 440.944 127.686 442.705 126.912C445.347 125.748 447.851 124.06 450.318 122.696C452.783 121.325 455.181 120.303 457.533 120.308C459.624 120.317 461.758 121.063 464.168 123.291L464.812 122.598H463.867C463.867 131.636 463.869 136.154 463.869 145.19H464.813L465.455 144.499L464.813 145.19H465.757C465.757 136.154 465.756 131.636 465.756 122.598V122.186L465.455 121.907C462.801 119.428 460.115 118.412 457.533 118.419C455.601 118.42 453.763 118.963 452.001 119.737C449.36 120.901 446.854 122.589 444.389 123.953C441.923 125.324 439.525 126.347 437.174 126.342C435.083 126.333 432.947 125.586 430.537 123.36L428.951 121.885V124.051C428.951 133.09 428.951 137.609 428.951 146.649V147.06L429.252 147.34C431.905 149.816 434.59 150.833 437.171 150.825C439.104 150.824 440.943 150.281 442.704 149.507C445.346 148.343 447.851 146.655 450.318 145.29C452.785 143.919 455.182 142.896 457.534 142.903C459.625 142.91 461.761 143.657 464.171 145.883L465.757 147.357V145.19H464.813"
      fill="#284356"
    />
    <path
      d="M467.685 229.401H391.647C391.647 208.404 408.669 191.383 429.666 191.383C450.664 191.383 467.685 208.404 467.685 229.401Z"
      fill="#FFFCDE"
    />
    <path
      d="M467.685 229.401V227.512H391.647V229.401H393.534C393.536 219.417 397.576 210.397 404.117 203.853C410.662 197.312 419.682 193.273 429.666 193.272C439.65 193.273 448.67 197.312 455.213 203.853C461.755 210.397 465.795 219.417 465.795 229.401H467.685V227.512V229.401H469.572C469.571 207.36 451.708 189.495 429.666 189.494C407.625 189.495 389.76 207.359 389.758 229.401V231.289H469.572V229.401H467.685Z"
      fill="#284356"
    />
    <path
      d="M465.747 227.512H453.585C453.475 225.267 453.17 223.072 452.687 220.946H464.802C465.31 223.067 465.631 225.263 465.747 227.512ZM463.674 217.168H451.619C447.804 205.941 438.879 197.074 427.616 193.328C428.294 193.29 428.979 193.272 429.666 193.272C439.65 193.273 448.67 197.312 455.214 203.853C458.941 207.581 461.855 212.113 463.674 217.168Z"
      fill="#D6D2BA"
    />
    <path
      d="M467.639 227.512H453.586H465.747C465.632 225.263 465.31 223.067 464.802 220.946H466.741C467.224 223.072 467.529 225.267 467.639 227.512ZM465.674 217.168H463.674C461.855 212.113 458.941 207.581 455.214 203.853C448.67 197.312 439.65 193.273 429.666 193.272C428.979 193.272 428.294 193.29 427.616 193.328C426.002 192.792 424.34 192.36 422.638 192.041C424.918 191.617 427.262 191.383 429.666 191.383C446.385 191.383 460.582 202.172 465.674 217.168Z"
      fill="#2A3E4D"
    />
    <path
      d="M589.537 252.793H174.5V443.677H687.904V252.793H589.537Z"
      fill="#FFFCDE"
    />
    <path
      d="M589.537 252.793V250.905H172.611V445.565H689.793V250.905H589.537V252.793V254.682H686.016V441.788H176.388V254.682H275.059H589.537V252.793Z"
      fill="#284356"
    />
    <path
      d="M297.227 399.949H362.675V371.467H297.227V399.949Z"
      fill="#6C8696"
    />
    <path
      d="M326.865 399.007H312.865V397.515L334.559 375.673V391.287L326.865 399.007ZM347.427 378.375V372.412H353.37L347.427 378.375Z"
      fill="#8199A7"
    />
    <path
      d="M299.998 399.007H299.84L299.998 398.851V399.007ZM312.865 389.921V386.157L326.798 372.412H330.438L312.865 389.921"
      fill="#8199A7"
    />
    <path
      d="M297.227 371.468H296.283V400.896H363.619V370.523H296.283V371.468H297.227V372.412H361.73V399.007H298.171V371.468H297.227V372.412V371.468Z"
      fill="#284356"
    />
    <path
      d="M497.233 399.949H562.679V371.467H497.233V399.949Z"
      fill="#6C8696"
    />
    <path
      d="M526.871 399.007H511.389L530.793 379.468V395.07L526.871 399.007ZM543.665 382.155V372.412H553.374L543.665 382.155Z"
      fill="#8199A7"
    />
    <path
      d="M510.405 392.378V388.588L526.802 372.411H530.441L510.405 392.378Z"
      fill="#8199A7"
    />
    <path
      d="M497.233 371.468H496.289V400.896H563.624V370.523H496.289V371.468H497.233V372.412H561.735V399.007H498.177V371.468H497.233V372.412V371.468Z"
      fill="#284356"
    />
    <path
      d="M500.494 436.316H369.1V428.227C369.1 427.438 369.737 426.796 370.532 426.796H499.065C499.853 426.796 500.494 427.438 500.494 428.227V436.316"
      fill="white"
    />
    <path
      d="M500.494 436.316V435.371H370.044V428.227C370.046 427.958 370.26 427.74 370.532 427.74H499.065C499.328 427.74 499.55 427.96 499.55 428.227V436.316H500.494V435.371V436.316H501.438V428.227C501.436 426.917 500.378 425.854 499.065 425.851H370.532C369.215 425.851 368.158 426.919 368.157 428.227V437.26H501.438V436.316H500.494"
      fill="#284356"
    />
    <path
      d="M507.258 441.074H357.998V432.985C357.998 432.194 358.638 431.553 359.427 431.553H505.826C506.617 431.553 507.258 432.194 507.258 432.985V441.074Z"
      fill="white"
    />
    <path
      d="M507.258 441.074V440.13H358.943V432.985C358.943 432.714 359.16 432.497 359.427 432.497H505.826C506.096 432.497 506.313 432.715 506.313 432.985V441.074H507.258V440.13V441.074H508.202V432.985C508.202 431.672 507.139 430.61 505.826 430.608H359.427C358.114 430.61 357.054 431.674 357.054 432.985V442.019H508.202V441.074H507.258Z"
      fill="#284356"
    />
    <path
      d="M513.872 443.677H351.121V438.586C351.121 437.793 351.759 437.152 352.549 437.152H512.44C513.231 437.152 513.872 437.793 513.872 438.586V443.677Z"
      fill="white"
    />
    <path
      d="M513.872 443.677V442.732H352.065V438.586C352.067 438.31 352.283 438.096 352.549 438.096H512.44C512.709 438.097 512.928 438.313 512.928 438.586V443.677H513.872V442.732V443.677H514.816V438.586C514.814 437.273 513.754 436.209 512.44 436.208H352.549C351.236 436.21 350.179 437.275 350.177 438.586V444.621H514.816V443.677H513.872Z"
      fill="#284356"
    />
    <path
      d="M160.593 420.159H132.246C124.566 420.159 118.341 426.385 118.341 434.066V440.201C118.341 442.118 119.894 443.677 121.817 443.677H136.108H171.023C172.943 443.677 174.5 442.118 174.5 440.201V434.066C174.5 426.385 168.276 420.159 160.593 420.159"
      fill="#C2C76C"
    />
    <path
      d="M160.593 420.159V419.215H132.246C124.043 419.216 117.397 425.863 117.396 434.066V440.201C117.397 442.639 119.372 444.62 121.817 444.621H136.108H171.023C173.467 444.62 175.443 442.639 175.444 440.201V434.066C175.443 425.863 168.798 419.216 160.593 419.215V420.159V421.103C164.176 421.105 167.411 422.553 169.759 424.9C172.106 427.249 173.554 430.483 173.555 434.066V440.201C173.553 441.595 172.421 442.73 171.023 442.732H136.108H121.817C120.417 442.73 119.287 441.597 119.285 440.201V434.066C119.286 430.483 120.734 427.249 123.081 424.9C125.429 422.553 128.663 421.105 132.246 421.103H146.54H160.593V420.159"
      fill="#284356"
    />
    <path
      d="M209.744 420.159H181.395C173.718 420.159 167.49 426.385 167.49 434.066V440.201C167.49 442.118 169.047 443.677 170.964 443.677H185.261H220.175C222.096 443.677 223.652 442.118 223.652 440.201V434.066C223.652 426.385 217.424 420.159 209.744 420.159Z"
      fill="#C2C76C"
    />
    <path
      d="M209.744 420.159V419.215H181.395C173.195 419.216 166.547 425.863 166.546 434.066V440.201C166.547 442.639 168.523 444.62 170.964 444.621H185.261H220.175C222.619 444.62 224.595 442.639 224.596 440.201V434.066C224.596 425.863 217.947 419.216 209.744 419.215V420.159V421.103C213.326 421.105 216.562 422.553 218.91 424.9C221.258 427.249 222.708 430.484 222.708 434.066V440.201C222.705 441.595 221.573 442.73 220.175 442.732H185.261H170.964C169.57 442.73 168.437 441.595 168.435 440.201V434.066C168.436 430.484 169.884 427.249 172.231 424.9C174.58 422.553 177.814 421.105 181.395 421.103H195.689H209.744V420.159"
      fill="#284356"
    />
    <path
      d="M260.196 420.159H231.85C224.167 420.159 217.94 426.385 217.94 434.066V440.201C217.94 442.118 219.495 443.677 221.418 443.677H235.713H270.626C272.547 443.677 274.102 442.118 274.102 440.201V434.066C274.102 426.385 267.876 420.159 260.196 420.159Z"
      fill="#C2C76C"
    />
    <path
      d="M260.196 420.159V419.215H231.85C223.645 419.216 216.996 425.863 216.996 434.066V440.201C216.996 442.64 218.973 444.62 221.418 444.621H235.713H270.626C273.07 444.62 275.045 442.639 275.046 440.201V434.066C275.046 425.863 268.397 419.216 260.196 419.215V420.159V421.103C263.779 421.105 267.013 422.553 269.362 424.9C271.708 427.249 273.158 430.484 273.158 434.066V440.201C273.155 441.595 272.025 442.73 270.626 442.732H235.713H221.418C220.018 442.73 218.887 441.595 218.885 440.201V434.066C218.885 430.484 220.334 427.249 222.681 424.9C225.031 422.553 228.265 421.105 231.85 421.103H246.142H260.196V420.159"
      fill="#284356"
    />
    <path
      d="M726.684 420.159H698.335C690.652 420.159 684.426 426.385 684.426 434.066V440.201C684.426 442.118 685.983 443.677 687.905 443.677H722.819H737.114C739.035 443.677 740.591 442.118 740.591 440.201V434.066C740.591 426.385 734.365 420.159 726.684 420.159Z"
      fill="#C2C76C"
    />
    <path
      d="M726.684 420.159V419.215H698.335C690.131 419.216 683.481 425.863 683.481 434.066V440.201C683.483 442.64 685.461 444.62 687.905 444.621H722.819H737.114C739.558 444.62 741.534 442.64 741.536 440.201V434.066C741.536 425.863 734.887 419.216 726.684 419.215V420.159V421.103C730.266 421.105 733.501 422.553 735.851 424.9C738.198 427.249 739.647 430.484 739.648 434.066V440.201C739.644 441.595 738.512 442.73 737.114 442.732H722.819H687.905C686.506 442.73 685.373 441.594 685.37 440.201V434.066C685.37 430.484 686.819 427.249 689.168 424.9C691.516 422.553 694.752 421.105 698.335 421.103H712.39H726.684V420.159Z"
      fill="#284356"
    />
    <path
      d="M677.529 420.159H649.183C641.505 420.159 635.272 426.385 635.272 434.066V440.201C635.272 442.118 636.831 443.677 638.754 443.677H673.666H687.96C689.884 443.677 691.436 442.118 691.436 440.201V434.066C691.436 426.385 685.213 420.159 677.529 420.159Z"
      fill="#C2C76C"
    />
    <path
      d="M677.529 420.159V419.215H649.183C640.984 419.216 634.329 425.863 634.328 434.066V440.201C634.329 442.642 636.31 444.62 638.754 444.621H673.667H687.96C690.406 444.621 692.381 442.639 692.381 440.201V434.066C692.381 425.863 685.734 419.216 677.529 419.215V420.159V421.103C681.114 421.105 684.348 422.553 686.697 424.9C689.043 427.249 690.492 430.483 690.492 434.066V440.201C690.49 441.597 689.361 442.73 687.96 442.732H673.667H638.754C637.354 442.73 636.219 441.594 636.217 440.201V434.066C636.217 430.484 637.667 427.249 640.017 424.901C642.366 422.553 645.602 421.105 649.183 421.103H663.236H677.529V420.159"
      fill="#284356"
    />
    <path
      d="M627.08 420.159H598.731C591.053 420.159 584.824 426.385 584.824 434.066V440.201C584.824 442.118 586.383 443.677 588.302 443.677H623.217H637.511C639.43 443.677 640.987 442.118 640.987 440.201V434.066C640.987 426.385 634.764 420.159 627.08 420.159"
      fill="#C2C76C"
    />
    <path
      d="M627.08 420.159V419.215H598.731C590.531 419.216 583.88 425.863 583.88 434.066V440.201C583.881 442.642 585.861 444.62 588.302 444.621H623.217H637.511C639.952 444.62 641.931 442.64 641.932 440.201V434.066C641.931 425.863 635.285 419.216 627.08 419.215V420.159V421.103C630.664 421.105 633.899 422.553 636.247 424.9C638.594 427.249 640.042 430.483 640.043 434.066V440.201C640.041 441.594 638.906 442.73 637.511 442.732H623.217H588.302C586.906 442.73 585.771 441.594 585.769 440.201V434.066C585.769 430.484 587.218 427.249 589.566 424.9C591.916 422.553 595.151 421.105 598.731 421.103H612.787H627.08V420.159"
      fill="#284356"
    />
    <path
      d="M676.25 236.817C675.186 235.786 673.752 235.202 672.27 235.202H189.183C187.701 235.202 186.272 235.793 185.226 236.843L164.063 258.091V261.095C164.063 262.376 165.102 263.413 166.38 263.413H695.799C697.077 263.413 698.117 262.376 698.117 261.095V258.091L676.25 236.817"
      fill="#B26767"
    />
    <path
      d="M676.25 236.817L677.565 235.461C676.147 234.087 674.249 233.314 672.27 233.313H189.183C187.198 233.313 185.291 234.104 183.889 235.511L162.174 257.312V261.095C162.175 263.421 164.056 265.3 166.38 265.302H695.799C698.122 265.3 700.002 263.422 700.006 261.095V257.294L677.567 235.464L677.565 235.461L676.25 236.817L674.933 238.171L696.229 258.889V261.095C696.229 261.33 696.032 261.525 695.799 261.525H166.38C166.145 261.525 165.951 261.331 165.951 261.095V258.872L186.564 238.177C187.253 237.484 188.205 237.089 189.183 237.09H672.27C673.256 237.089 674.226 237.483 674.934 238.173L674.933 238.171L676.25 236.817"
      fill="#284356"
    />
    <path
      d="M571.861 323.43C570.798 322.398 569.364 321.818 567.881 321.818H294.509C293.027 321.818 291.593 322.398 290.53 323.434L281.562 332.163V335.165C281.562 336.447 282.597 337.483 283.881 337.483H578.552C579.832 337.483 580.871 336.447 580.871 335.165V332.163L571.861 323.43Z"
      fill="#B26767"
    />
    <path
      d="M571.861 323.43L573.176 322.075C571.757 320.698 569.856 319.93 567.88 319.93H294.508C292.534 319.93 290.63 320.698 289.21 322.081L279.674 331.365V335.165C279.672 336.32 280.146 337.384 280.905 338.14C281.66 338.9 282.724 339.373 283.88 339.372H578.551C580.873 339.372 582.758 337.492 582.759 335.165V331.362L573.175 322.074L573.176 322.075L571.861 323.43L570.546 324.786L578.982 332.963V335.165C578.981 335.402 578.789 335.594 578.551 335.594H283.88C283.64 335.594 283.452 335.405 283.451 335.165V332.96L291.847 324.787C292.553 324.096 293.518 323.706 294.508 323.707H567.88C568.871 323.706 569.838 324.097 570.543 324.785L570.546 324.786L571.861 323.43Z"
      fill="#284356"
    />
    <path
      d="M473.498 220.67C472.434 219.637 471 219.057 469.518 219.057H389.958C388.479 219.057 387.045 219.637 385.982 220.674L377.015 229.401H482.505L473.498 220.67"
      fill="#B26767"
    />
    <path
      d="M473.497 220.67L474.813 219.314C473.393 217.939 471.494 217.17 469.518 217.168H389.958C387.984 217.17 386.084 217.939 384.664 219.32L372.366 231.289H487.167L474.811 219.314L473.497 220.67L472.184 222.026L477.843 227.512H381.662L387.299 222.027C388.007 221.336 388.974 220.946 389.958 220.946H469.518C470.507 220.946 471.475 221.337 472.182 222.025L473.497 220.67"
      fill="#284356"
    />
    <path
      d="M482.505 232.405C482.505 233.684 481.47 234.722 480.191 234.722H379.332C378.05 234.722 377.014 233.684 377.014 232.405V229.401H482.505V232.405Z"
      fill="white"
    />
    <path
      d="M482.505 232.405H481.56C481.559 233.163 480.946 233.776 480.191 233.777H379.331C378.571 233.776 377.96 233.163 377.958 232.405V230.345H481.56V232.405H482.505H483.449V228.456H376.07V232.405C376.07 234.206 377.527 235.666 379.331 235.666H480.191C481.992 235.665 483.449 234.204 483.449 232.405H482.505Z"
      fill="#284356"
    />
    <path d="M384.713 365.666H481.47V348.234H384.713V365.666Z" fill="#E1FFFE" />
    <path
      d="M481.47 365.666V365.193H385.185V348.707H480.998V365.666H481.47V365.193V365.666H481.942V347.762H384.241V366.138H481.942V365.666H481.47Z"
      fill="#284356"
    />
    <path d="M387.2 362.622H478.764V351.469H387.2V362.622Z" fill="#9ECCCA" />
    <path
      d="M478.764 362.622V362.15H387.672V351.94H478.292V362.622H478.764V362.15V362.622H479.236V350.997H386.728V363.094H479.236V362.622H478.764Z"
      fill="#284356"
    />
    <path d="M192.782 243.449H263.05V242.505H192.782V243.449Z" fill="#284356" />
    <path
      d="M288.742 244.327H310.481V243.383H288.742V244.327Z"
      fill="#284356"
    />
    <path d="M508.108 243.01H529.846V242.066H508.108V243.01Z" fill="#284356" />
    <path d="M376.357 252.6H388.723V251.655H376.357V252.6Z" fill="#284356" />
    <path
      d="M540.608 250.477H629.541V249.532H540.608V250.477Z"
      fill="#284356"
    />
    <path d="M348.47 243.743H433.597V242.798H348.47V243.743Z" fill="#284356" />
    <path d="M291.45 252.015H340.637V251.071H291.45V252.015Z" fill="#284356" />
    <path d="M420.569 252.6H510.743V251.655H420.569V252.6Z" fill="#284356" />
    <path
      d="M211.521 252.015H241.238V251.071H211.521V252.015Z"
      fill="#284356"
    />
    <path
      d="M406.411 369.49L388.479 377.013V425.271C392.927 425.271 419.864 425.271 424.341 425.271V377.013L406.411 369.49"
      fill="#B26767"
    />
    <path
      d="M406.411 369.49L406.046 368.619L387.535 376.385V426.216H388.479C392.927 426.216 419.864 426.216 424.341 426.216H425.284V376.385L406.411 368.466L406.046 368.619L406.411 369.49L406.046 370.361L423.397 377.64V425.271H424.341V424.327C419.864 424.327 392.927 424.327 388.479 424.327V425.271H389.423V377.64L406.777 370.361L406.411 369.49L406.046 370.361L406.411 369.49"
      fill="#284356"
    />
    <path
      d="M403.129 394.741V375.863L392.957 379.896V394.741H403.129Z"
      fill="#DADFE0"
    />
    <path
      d="M403.129 394.741H403.601V375.167L392.484 379.575V395.213H403.601V394.741H403.129V394.269H393.427V380.216L402.657 376.558V394.741H403.129V394.269V394.741Z"
      fill="#284356"
    />
    <path d="M403.129 420.496H392.957V397.88H403.129V420.496Z" fill="#DADFE0" />
    <path
      d="M403.129 420.496V420.024H393.427V398.352H402.657V420.496H403.129V420.024V420.496H403.601V397.408H392.484V420.968H403.601V420.496H403.129Z"
      fill="#284356"
    />
    <path
      d="M409.695 394.741V375.863L419.866 379.896V394.741H409.695Z"
      fill="#DADFE0"
    />
    <path
      d="M409.695 394.741H410.167V376.558L419.394 380.217V394.269H409.695V394.741H410.167H409.695V395.213H420.339V379.575L409.223 375.168V395.213H409.695V394.741"
      fill="#284356"
    />
    <path d="M409.695 420.496H419.866V397.88H409.695V420.496Z" fill="#DADFE0" />
    <path
      d="M409.695 420.496V420.968H420.339V397.408H409.223V420.968H409.695V420.496H410.167V398.352H419.394V420.024H409.695V420.496H410.167H409.695Z"
      fill="#284356"
    />
    <path
      d="M461.497 369.49L443.563 377.013V425.271C448.013 425.271 474.949 425.271 479.426 425.271V377.013L461.497 369.49"
      fill="#B26767"
    />
    <path
      d="M461.497 369.49L461.131 368.619L442.619 376.385V426.216H443.563C448.013 426.216 474.949 426.216 479.426 426.216H480.369V376.385L461.497 368.466L461.131 368.619L461.497 369.49L461.131 370.361L478.482 377.64V425.271H479.426V424.327C474.949 424.327 448.013 424.327 443.563 424.327V425.271H444.507V377.64L461.862 370.361L461.497 369.49L461.131 370.361L461.497 369.49"
      fill="#284356"
    />
    <path
      d="M458.214 394.741V375.863L448.041 379.896V394.741H458.214Z"
      fill="#DADFE0"
    />
    <path
      d="M458.214 394.741H458.686V375.167L447.568 379.575V395.213H458.686V394.741H458.214V394.269H448.513V380.216L457.742 376.558V394.741H458.214V394.269V394.741Z"
      fill="#284356"
    />
    <path d="M458.214 420.496H448.041V397.88H458.214V420.496Z" fill="#DADFE0" />
    <path
      d="M458.214 420.496V420.024H448.511L448.513 398.352H457.742V420.496H458.214V420.024V420.496H458.686V397.408H447.568V420.968H458.686V420.496H458.214Z"
      fill="#284356"
    />
    <path
      d="M464.778 394.741V375.863L474.949 379.896V394.741H464.778Z"
      fill="#DADFE0"
    />
    <path
      d="M464.778 394.741H465.25V376.558L474.477 380.217V394.269H464.778V394.741H465.25H464.778V395.213H475.421V379.575L464.305 375.168V395.213H464.778V394.741"
      fill="#284356"
    />
    <path d="M464.778 420.496H474.949V397.88H464.778V420.496Z" fill="#DADFE0" />
    <path
      d="M464.778 420.496V420.968H475.421V397.408H464.305V420.968H464.778V420.496H465.25V398.352H474.477V420.024H464.778V420.496H465.25H464.778Z"
      fill="#284356"
    />
    <path d="M175.42 270.418H227.462V269.473H175.42V270.418Z" fill="#284356" />
    <path
      d="M244.663 270.418H257.764V269.473H244.663V270.418Z"
      fill="#284356"
    />
    <path
      d="M278.333 269.836H347.063V268.891H278.333V269.836Z"
      fill="#284356"
    />
    <path
      d="M226.365 288.426H278.405V287.481H226.365V288.426Z"
      fill="#284356"
    />
    <path d="M178.347 307.161H230.39V306.217H178.347V307.161Z" fill="#284356" />
    <path
      d="M192.986 340.833H245.027V339.888H192.986V340.833Z"
      fill="#284356"
    />
    <path d="M178.347 354.594H230.39V353.649H178.347V354.594Z" fill="#284356" />
    <path d="M221.097 370.99H273.139V370.046H221.097V370.99Z" fill="#284356" />
    <path d="M178.058 389.139H230.1V388.195H178.058V389.139Z" fill="#284356" />
    <path d="M237.197 408.758H289.24V407.814H237.197V408.758Z" fill="#284356" />
    <path
      d="M185.556 313.069H218.129V277.033H185.556V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M213.731 276.738H208.935C209.362 284.214 210.552 296.34 213.848 308.254C214.381 310.188 214.855 311.873 215.29 313.364H218.129V312.403C217.817 311.067 217.478 309.588 217.105 307.924C214.475 296.12 213.828 284.276 213.731 276.738"
      fill="#B4D0DB"
    />
    <path
      d="M214.613 276.738C214.702 284.267 215.344 296.148 217.989 307.992C218.036 308.21 218.081 308.402 218.129 308.616V276.738H214.613"
      fill="#B4D0DB"
    />
    <path
      d="M185.556 276.738V313.364H187.875C192.764 300.83 193.932 286.075 194.361 276.738H185.556"
      fill="#B4D0DB"
    />
    <path
      d="M199.508 276.738H195.118C194.723 289.667 193.012 302.952 188.535 313.364H190.437C190.489 313.156 190.532 312.953 190.63 312.748C196.422 300.469 198.502 285.684 199.508 276.738"
      fill="#B4D0DB"
    />
    <path
      d="M200.236 276.738C199.025 289.502 196.459 302.651 191.272 312.743C191.168 312.948 191.1 313.156 191.014 313.364H192.164C193.114 311.873 194.176 310.188 195.361 308.254C202.664 296.34 205.294 284.214 206.251 276.738H200.236"
      fill="#B4D0DB"
    />
    <path
      d="M192.432 296.122C193.025 292.59 193.44 289.143 193.739 285.935L194.672 285.017C194.407 288.377 194.032 291.715 193.522 294.974L192.432 296.122V296.122ZM197.397 290.897C197.839 288.63 198.206 286.438 198.517 284.372H199.343C199.089 286.175 198.803 287.974 198.481 289.756L197.397 290.897Z"
      fill="#8199A7"
    />
    <path
      d="M186.5 302.364V293.044L193.739 285.933C193.44 289.142 193.025 292.589 192.432 296.121L186.5 302.364"
      fill="#BBD4DF"
    />
    <path
      d="M193.522 294.973C194.032 291.714 194.408 288.377 194.672 285.016L195.331 284.371H198.517C198.206 286.437 197.839 288.63 197.397 290.896L193.522 294.973"
      fill="#BBD4DF"
    />
    <path
      d="M198.481 289.755C198.803 287.973 199.089 286.174 199.343 284.371H200.9V287.209L198.481 289.755ZM202.788 285.222V284.371H203.082L203.247 284.741L202.788 285.222Z"
      fill="#BBD4DF"
    />
    <path
      d="M190.626 304.724C190.872 303.766 191.102 302.804 191.318 301.842L192.463 300.693C192.257 301.648 192.037 302.594 191.801 303.527L190.626 304.724V304.724ZM195.269 299.994C195.536 299.032 195.786 298.075 196.024 297.121L197.198 295.942C196.975 296.885 196.741 297.821 196.493 298.746L195.269 299.994V299.994ZM202.788 292.33V292.078C202.793 292.063 202.798 292.046 202.803 292.033L202.941 292.176L202.788 292.33"
      fill="#8199A7"
    />
    <path
      d="M186.5 308.93V306.677L191.318 301.842C191.102 302.804 190.872 303.766 190.626 304.724L186.5 308.93"
      fill="#BBD4DF"
    />
    <path
      d="M191.801 303.526C192.037 302.593 192.257 301.647 192.464 300.691L196.024 297.119C195.786 298.074 195.536 299.031 195.269 299.993L191.801 303.526"
      fill="#BBD4DF"
    />
    <path
      d="M196.493 298.745C196.741 297.819 196.975 296.884 197.198 295.941L200.9 292.226V294.254L196.493 298.745ZM202.788 292.077V292.015L202.803 292.031C202.798 292.045 202.793 292.061 202.788 292.077Z"
      fill="#BBD4DF"
    />
    <path
      d="M202.788 301.954V292.808L209.713 286.01C209.979 288.417 210.315 290.991 210.738 293.667L202.788 301.954V301.954ZM214.39 289.86C214.221 287.949 214.093 286.112 213.994 284.372H214.871C214.953 285.856 215.058 287.411 215.192 289.024L214.39 289.86"
      fill="#8199A7"
    />
    <path
      d="M210.738 293.665C210.315 290.99 209.979 288.416 209.713 286.009L211.383 284.371H213.994C214.093 286.111 214.221 287.948 214.39 289.859L210.738 293.665Z"
      fill="#BBD4DF"
    />
    <path
      d="M215.192 289.023C215.058 287.41 214.952 285.855 214.871 284.371H217.185V286.944L215.192 289.023Z"
      fill="#BBD4DF"
    />
    <path
      d="M202.788 308.718V306.359L211.413 297.597C211.534 298.252 211.661 298.912 211.794 299.573L202.788 308.718ZM215.08 296.236C214.988 295.53 214.902 294.827 214.823 294.133L215.605 293.339C215.682 294.036 215.764 294.74 215.852 295.452L215.08 296.236Z"
      fill="#8199A7"
    />
    <path
      d="M211.794 299.573C211.661 298.912 211.534 298.252 211.413 297.597L214.823 294.134C214.902 294.827 214.988 295.53 215.08 296.236L211.794 299.573Z"
      fill="#BBD4DF"
    />
    <path
      d="M215.852 295.453C215.763 294.741 215.682 294.037 215.605 293.34L217.185 291.734V294.098L215.852 295.453Z"
      fill="#BBD4DF"
    />
    <path
      d="M218.129 313.069V312.126H186.5V277.977H217.185V313.069H218.129V312.126V313.069H219.074V276.088H184.612V314.013H219.074V313.069H218.129Z"
      fill="#284356"
    />
    <path d="M200.9 313.751H202.788V276.351H200.9V313.751Z" fill="#284356" />
    <path
      d="M235.568 362.545H268.143V326.507H235.568V362.545Z"
      fill="#6C8696"
    />
    <path
      d="M263.744 326.213H258.946C259.376 333.687 260.567 345.816 263.859 357.729C264.392 359.664 264.873 361.35 265.301 362.838H268.143V361.88C267.831 360.543 267.494 359.063 267.119 357.4C264.488 345.596 263.843 333.751 263.744 326.213Z"
      fill="#B4D0DB"
    />
    <path
      d="M264.625 326.214C264.713 333.745 265.356 345.626 268 357.469C268.05 357.686 268.094 357.881 268.143 358.093V326.214H264.625Z"
      fill="#B4D0DB"
    />
    <path
      d="M235.568 326.213V362.838H237.887C242.78 350.305 243.948 335.551 244.374 326.213H235.568"
      fill="#B4D0DB"
    />
    <path
      d="M249.523 326.213H245.13C244.736 339.143 243.027 352.426 238.546 362.838H240.451C240.503 362.632 240.545 362.43 240.642 362.222C246.434 349.945 248.517 335.16 249.523 326.213"
      fill="#B4D0DB"
    />
    <path
      d="M250.251 326.213C249.037 338.978 246.473 352.127 241.283 362.217C241.18 362.425 241.112 362.632 241.026 362.838H242.176C243.128 361.35 244.187 359.664 245.373 357.729C252.674 345.816 255.306 333.687 256.264 326.213H250.251"
      fill="#B4D0DB"
    />
    <path
      d="M235.568 346.982L235.485 343.528L235.568 343.447V346.982"
      fill="#F7F8E1"
    />
    <path
      d="M242.447 345.593C243.04 342.062 243.455 338.616 243.754 335.407L244.685 334.491C244.42 337.852 244.046 341.189 243.536 344.448L242.447 345.593V345.593ZM247.41 340.37C248.122 336.722 248.643 333.266 249.04 330.215L249.926 329.345C249.553 332.653 249.084 335.967 248.494 339.229L247.41 340.37"
      fill="#8199A7"
    />
    <path
      d="M235.704 352.687L235.568 346.98V343.446L243.754 335.405C243.455 338.615 243.04 342.061 242.447 345.591L235.704 352.687"
      fill="#BBD4DF"
    />
    <path
      d="M243.536 344.448C244.046 341.188 244.42 337.851 244.685 334.49L249.039 330.214C248.643 333.265 248.122 336.722 247.41 340.369L243.536 344.448"
      fill="#BBD4DF"
    />
    <path
      d="M248.494 339.228C249.083 335.965 249.553 332.651 249.926 329.344L250.735 328.548L253.259 334.216L248.494 339.228"
      fill="#BBD4DF"
    />
    <path
      d="M235.568 359.256L235.476 357.193L235.568 357.101V359.256"
      fill="#F7F8E1"
    />
    <path
      d="M240.64 354.199C240.887 353.24 241.117 352.276 241.332 351.314L242.476 350.167C242.269 351.123 242.049 352.07 241.813 353.003L240.64 354.199V354.199ZM245.281 349.468C245.548 348.508 245.8 347.548 246.036 346.594L247.211 345.414C246.988 346.358 246.753 347.294 246.506 348.221L245.281 349.468V349.468ZM252.675 341.933C252.722 341.789 252.769 341.647 252.816 341.505L252.953 341.649L252.675 341.933Z"
      fill="#8199A7"
    />
    <path
      d="M235.573 359.365L235.568 359.257V357.101L241.332 351.316C241.117 352.278 240.887 353.241 240.64 354.2L235.573 359.365"
      fill="#BBD4DF"
    />
    <path
      d="M241.813 353.004C242.049 352.071 242.269 351.124 242.476 350.168L246.037 346.595C245.8 347.549 245.548 348.509 245.281 349.469L241.813 353.004"
      fill="#BBD4DF"
    />
    <path
      d="M246.506 348.221C246.753 347.294 246.988 346.359 247.211 345.415L251.982 340.627L252.816 341.505C252.769 341.647 252.722 341.79 252.675 341.933L246.506 348.221"
      fill="#BBD4DF"
    />
    <path
      d="M252.075 352.189L252.389 342.779C252.404 342.734 252.419 342.69 252.434 342.645L259.726 335.485C259.992 337.891 260.329 340.466 260.752 343.143L252.075 352.189ZM264.402 339.337C264.153 336.504 263.99 333.829 263.887 331.398L264.731 330.57C264.82 332.981 264.967 335.654 265.203 338.502L264.402 339.337"
      fill="#8199A7"
    />
    <path
      d="M260.752 343.144C260.329 340.467 259.993 337.892 259.726 335.486L263.887 331.399C263.99 333.83 264.153 336.504 264.402 339.337L260.752 343.144"
      fill="#BBD4DF"
    />
    <path
      d="M265.203 338.503C264.967 335.655 264.82 332.982 264.73 330.571L267.644 327.709L267.995 335.592L265.203 338.503"
      fill="#BBD4DF"
    />
    <path
      d="M252.389 342.78L252.391 342.688L252.434 342.645C252.419 342.69 252.404 342.735 252.389 342.78Z"
      fill="#BBD4DF"
    />
    <path
      d="M268.143 342.612V340.249L268.372 340.016L268.143 342.612Z"
      fill="#F7F8E1"
    />
    <path
      d="M252.476 358.528L251.859 357.694V356.791L261.425 347.074C261.547 347.728 261.675 348.388 261.807 349.05L252.476 358.528ZM251.859 357.694L251.478 357.179L251.859 356.791V357.694V357.694ZM265.092 345.712C265.001 345.006 264.916 344.305 264.835 343.61L265.617 342.816C265.694 343.514 265.776 344.219 265.862 344.929L265.092 345.712Z"
      fill="#8199A7"
    />
    <path
      d="M261.807 349.049C261.675 348.387 261.547 347.727 261.425 347.072L264.835 343.609C264.916 344.304 265.001 345.005 265.092 345.711L261.807 349.049"
      fill="#BBD4DF"
    />
    <path
      d="M265.862 344.929C265.776 344.219 265.694 343.514 265.617 342.816L268.143 340.25V342.613L265.862 344.929Z"
      fill="#BBD4DF"
    />
    <path
      d="M268.143 362.545V361.6H236.511V327.452H267.198V362.545H268.143V361.6V362.545H269.087V325.563H234.624V363.489H269.087V362.545H268.143Z"
      fill="#284356"
    />
    <path
      d="M250.914 363.225H252.803V325.827H250.914V363.225Z"
      fill="#284356"
    />
    <path
      d="M588.778 362.545H621.355V326.507H588.778V362.545Z"
      fill="#6C8696"
    />
    <path
      d="M616.956 326.213H612.157C612.587 333.687 613.778 345.816 617.072 357.729C617.603 359.664 618.084 361.35 618.512 362.838H621.354V361.88C621.039 360.543 620.704 359.063 620.33 357.4C617.7 345.596 617.055 333.751 616.956 326.213"
      fill="#B4D0DB"
    />
    <path
      d="M617.835 326.214C617.927 333.745 618.566 345.626 621.213 357.469C621.261 357.686 621.304 357.881 621.354 358.093V326.214H617.835Z"
      fill="#B4D0DB"
    />
    <path
      d="M588.778 326.213V362.838H591.099C595.993 350.305 597.158 335.551 597.587 326.213H588.778"
      fill="#B4D0DB"
    />
    <path
      d="M602.733 326.213H598.341C597.946 339.143 596.237 352.426 591.756 362.838H593.662C593.712 362.632 593.757 362.43 593.852 362.222C599.645 349.945 601.728 335.16 602.733 326.213"
      fill="#B4D0DB"
    />
    <path
      d="M588.778 346.938L588.696 343.528L588.778 343.447V346.938Z"
      fill="#F7F8E1"
    />
    <path
      d="M595.658 345.593C596.251 342.062 596.668 338.615 596.965 335.405L597.895 334.493C597.631 337.853 597.256 341.19 596.746 344.45L595.658 345.593V345.593ZM600.621 340.371C601.333 336.722 601.853 333.267 602.249 330.217L603.948 328.548L605.07 331.069V335.69L600.621 340.371ZM605.07 335.69V331.069L606.47 334.217L605.07 335.69Z"
      fill="#8199A7"
    />
    <path
      d="M588.917 352.687L588.778 346.936V343.446L596.965 335.405C596.668 338.615 596.251 342.062 595.658 345.593L588.917 352.687Z"
      fill="#BBD4DF"
    />
    <path
      d="M596.746 344.449C597.256 341.189 597.631 337.853 597.895 334.492L602.249 330.216C601.853 333.267 601.333 336.722 600.621 340.371L596.746 344.449"
      fill="#BBD4DF"
    />
    <path
      d="M588.778 359.254L588.69 357.193L588.778 357.104V359.254Z"
      fill="#F7F8E1"
    />
    <path
      d="M593.852 354.199C594.098 353.241 594.328 352.279 594.544 351.317L595.687 350.17C595.479 351.125 595.259 352.071 595.023 353.004L593.852 354.199V354.199ZM598.492 349.47C598.759 348.508 599.011 347.55 599.248 346.595L605.07 340.752V342.765L598.492 349.47ZM605.07 342.765V340.752L605.192 340.628L606.164 341.651L605.07 342.765"
      fill="#8199A7"
    />
    <path
      d="M588.783 359.365L588.778 359.254V357.104L594.544 351.317C594.328 352.279 594.098 353.241 593.853 354.199L588.783 359.365Z"
      fill="#BBD4DF"
    />
    <path
      d="M595.023 353.004C595.259 352.071 595.479 351.125 595.687 350.169L599.248 346.595C599.011 347.549 598.759 348.507 598.492 349.469L595.023 353.004"
      fill="#BBD4DF"
    />
    <path
      d="M605.285 352.189L605.601 342.687L612.937 335.484C613.204 337.891 613.539 340.466 613.963 343.142L605.285 352.189V352.189ZM617.614 339.334C617.365 336.501 617.203 333.828 617.101 331.397L617.942 330.57C618.031 332.981 618.18 335.654 618.414 338.499L617.614 339.334"
      fill="#8199A7"
    />
    <path
      d="M613.963 343.142C613.539 340.466 613.204 337.891 612.937 335.484L617.101 331.397C617.203 333.828 617.365 336.501 617.615 339.334L613.963 343.142Z"
      fill="#BBD4DF"
    />
    <path
      d="M618.414 338.499C618.18 335.654 618.031 332.981 617.942 330.569L620.857 327.707L621.204 335.591L618.414 338.499"
      fill="#BBD4DF"
    />
    <path
      d="M621.354 342.612V340.249L621.584 340.016L621.354 342.612Z"
      fill="#F7F8E1"
    />
    <path
      d="M605.688 358.528L605.07 357.693V356.791L614.637 347.074C614.759 347.728 614.886 348.388 615.018 349.05L605.688 358.528V358.528ZM605.07 357.693L604.688 357.179L605.07 356.791V357.693V357.693ZM618.305 345.712C618.213 345.005 618.128 344.303 618.048 343.608L618.828 342.816C618.905 343.514 618.987 344.218 619.075 344.931L618.305 345.712Z"
      fill="#8199A7"
    />
    <path
      d="M615.018 349.049C614.886 348.387 614.759 347.727 614.637 347.072L618.048 343.607C618.128 344.302 618.213 345.004 618.305 345.711L615.018 349.049Z"
      fill="#BBD4DF"
    />
    <path
      d="M619.075 344.931C618.987 344.218 618.905 343.514 618.828 342.817L621.354 340.251V342.614L619.075 344.931Z"
      fill="#BBD4DF"
    />
    <path
      d="M621.354 362.545V361.6H589.723V327.452H620.41V362.545H621.354V361.6V362.545H622.299V325.563H587.834V363.489H622.299V362.545H621.354Z"
      fill="#284356"
    />
    <path
      d="M604.125 363.225H606.014V325.827H604.125V363.225Z"
      fill="#284356"
    />
    <path
      d="M185.537 362.545H218.111V326.507H185.537V362.545Z"
      fill="#6C8696"
    />
    <path
      d="M213.712 326.213H208.918C209.347 333.687 210.537 345.816 213.831 357.729C214.363 359.664 214.843 361.35 215.272 362.838H218.112V361.88C217.8 360.543 217.465 359.063 217.089 357.4C214.458 345.596 213.812 333.751 213.712 326.213Z"
      fill="#B4D0DB"
    />
    <path
      d="M214.594 326.214C214.684 333.745 215.327 345.626 217.971 357.469C218.019 357.686 218.064 357.881 218.112 358.093V326.214H214.594Z"
      fill="#B4D0DB"
    />
    <path
      d="M185.537 326.213V362.838H187.858C192.751 350.305 193.918 335.551 194.343 326.213H185.537"
      fill="#B4D0DB"
    />
    <path
      d="M199.491 326.213H195.1C194.706 339.143 192.998 352.426 188.516 362.838H190.42C190.472 362.632 190.516 362.43 190.614 362.222C196.406 349.945 198.487 335.16 199.491 326.213"
      fill="#B4D0DB"
    />
    <path
      d="M185.537 346.925L185.457 343.527L185.537 343.448V346.925"
      fill="#F7F8E1"
    />
    <path
      d="M192.417 345.593C193.01 342.062 193.426 338.615 193.724 335.407L194.654 334.491C194.39 337.852 194.015 341.19 193.505 344.448L192.417 345.593V345.593ZM197.382 340.369C198.092 336.721 198.613 333.266 199.008 330.215L200.706 328.548L201.83 331.073V335.689L197.382 340.369ZM201.83 335.689V331.073L203.229 334.217L201.83 335.689Z"
      fill="#8199A7"
    />
    <path
      d="M185.676 352.687L185.537 346.924V343.447L193.724 335.406C193.425 338.615 193.01 342.062 192.417 345.593L185.676 352.687"
      fill="#BBD4DF"
    />
    <path
      d="M193.505 344.449C194.015 341.191 194.39 337.853 194.654 334.492L199.008 330.216C198.613 333.267 198.092 336.722 197.382 340.37L193.505 344.449"
      fill="#BBD4DF"
    />
    <path
      d="M185.537 359.277L185.449 357.193L185.537 357.103V359.277Z"
      fill="#F7F8E1"
    />
    <path
      d="M190.61 354.199C190.857 353.24 191.087 352.28 191.301 351.318L192.446 350.17C192.239 351.124 192.019 352.071 191.784 353.003L190.61 354.199V354.199ZM195.252 349.467C195.519 348.507 195.771 347.55 196.008 346.595L201.83 340.752V342.765L195.252 349.467ZM201.83 342.765V340.752L201.954 340.628L202.923 341.651L201.83 342.765"
      fill="#8199A7"
    />
    <path
      d="M185.541 359.365L185.537 359.277V357.104L191.301 351.318C191.087 352.28 190.857 353.24 190.61 354.199L185.541 359.365Z"
      fill="#BBD4DF"
    />
    <path
      d="M191.784 353.002C192.019 352.07 192.239 351.123 192.446 350.169L196.008 346.594C195.771 347.549 195.519 348.506 195.253 349.466L191.784 353.002"
      fill="#BBD4DF"
    />
    <path
      d="M202.046 352.189L202.362 342.687L209.696 335.484C209.962 337.891 210.299 340.466 210.722 343.143L202.046 352.189V352.189ZM214.372 339.337C214.123 336.503 213.96 333.829 213.857 331.397L214.701 330.568C214.79 332.981 214.937 335.654 215.173 338.502L214.372 339.337"
      fill="#8199A7"
    />
    <path
      d="M210.722 343.144C210.299 340.467 209.963 337.892 209.696 335.484L213.857 331.397C213.96 333.83 214.123 336.503 214.372 339.337L210.722 343.144"
      fill="#BBD4DF"
    />
    <path
      d="M215.173 338.503C214.937 335.655 214.79 332.982 214.701 330.569L217.613 327.709L217.964 335.592L215.173 338.503"
      fill="#BBD4DF"
    />
    <path
      d="M202.447 358.528L201.83 357.694V356.791L211.397 347.074C211.518 347.73 211.645 348.388 211.777 349.049L202.447 358.528ZM201.83 357.694L201.448 357.179L201.83 356.791V357.694"
      fill="#8199A7"
    />
    <path
      d="M215.062 345.713C214.971 345.006 214.886 344.305 214.806 343.611L215.587 342.818C215.664 343.514 215.746 344.219 215.833 344.93L215.062 345.713"
      fill="#8199A7"
    />
    <path d="M218.112 342.612V340.831H218.27L218.112 342.612Z" fill="#F7F8E1" />
    <path
      d="M218.27 340.833H218.112V340.252L218.343 340.018L218.27 340.833"
      fill="#4B6474"
    />
    <path
      d="M211.777 349.049C211.645 348.388 211.518 347.73 211.397 347.074L214.806 343.611C214.886 344.305 214.971 345.006 215.062 345.713L211.777 349.049Z"
      fill="#BBD4DF"
    />
    <path
      d="M215.833 344.929C215.746 344.219 215.664 343.514 215.587 342.817L218.112 340.251V340.832V342.613L215.833 344.929"
      fill="#BBD4DF"
    />
    <path
      d="M218.112 362.545V361.6H186.481V327.452H217.167V362.545H218.112V361.6V362.545H219.056V325.563H184.593V363.489H219.056V362.545H218.112Z"
      fill="#284356"
    />
    <path
      d="M200.886 363.225H202.774V325.827H200.886V363.225Z"
      fill="#284356"
    />
    <path
      d="M638.166 362.545H670.741V326.507H638.166V362.545Z"
      fill="#6C8696"
    />
    <path
      d="M666.342 326.213H661.545C661.973 333.687 663.164 345.816 666.458 357.729C666.99 359.664 667.466 361.35 667.9 362.838H670.74V361.88C670.427 360.543 670.086 359.063 669.716 357.4C667.085 345.596 666.438 333.751 666.342 326.213Z"
      fill="#B4D0DB"
    />
    <path
      d="M667.222 326.214C667.312 333.745 667.954 345.626 670.599 357.469C670.643 357.686 670.693 357.881 670.74 358.093V326.214H667.222Z"
      fill="#B4D0DB"
    />
    <path
      d="M638.166 326.213V362.838H640.485C645.373 350.305 646.54 335.551 646.971 326.213H638.166"
      fill="#B4D0DB"
    />
    <path
      d="M652.116 326.213H647.727C647.333 339.143 645.622 352.426 641.144 362.838H643.05C643.101 362.632 643.141 362.43 643.24 362.222C649.032 349.945 651.111 335.16 652.116 326.213"
      fill="#B4D0DB"
    />
    <path
      d="M652.847 326.213C651.635 338.978 649.07 352.127 643.882 362.217C643.778 362.425 643.71 362.632 643.624 362.838H644.774C645.724 361.35 646.784 359.664 647.97 357.729C655.272 345.816 657.905 333.687 658.857 326.213H652.847"
      fill="#B4D0DB"
    />
    <path
      d="M638.166 346.974L638.083 343.528L638.166 343.448V346.974Z"
      fill="#F7F8E1"
    />
    <path
      d="M645.041 345.597C645.634 342.065 646.049 338.619 646.347 335.409L647.282 334.491C647.017 337.852 646.642 341.19 646.132 344.447L645.041 345.597ZM650.005 340.371C650.717 336.724 651.237 333.27 651.632 330.219L652.522 329.344C652.149 332.652 651.68 335.967 651.092 339.228L650.005 340.371"
      fill="#8199A7"
    />
    <path
      d="M638.302 352.687L638.166 346.973V343.446L646.348 335.409C646.049 338.618 645.634 342.065 645.041 345.596L638.302 352.687"
      fill="#BBD4DF"
    />
    <path
      d="M646.132 344.448C646.642 341.19 647.017 337.852 647.282 334.492L651.632 330.219C651.237 333.27 650.717 336.724 650.005 340.372L646.132 344.448Z"
      fill="#BBD4DF"
    />
    <path
      d="M651.092 339.228C651.68 335.967 652.15 332.651 652.522 329.344L653.333 328.548L655.855 334.216L651.092 339.228"
      fill="#BBD4DF"
    />
    <path
      d="M638.166 359.282L638.073 357.193L638.166 357.099V359.282Z"
      fill="#F7F8E1"
    />
    <path
      d="M643.234 354.203C643.481 353.243 643.711 352.28 643.926 351.318L645.073 350.167C644.866 351.124 644.645 352.071 644.41 353.004L643.234 354.203V354.203ZM647.877 349.47C648.144 348.509 648.396 347.551 648.633 346.595L649.809 345.415C649.586 346.358 649.351 347.295 649.104 348.221L647.877 349.47"
      fill="#8199A7"
    />
    <path
      d="M638.17 359.365L638.166 359.282V357.099L643.926 351.318C643.711 352.28 643.481 353.243 643.234 354.203L638.17 359.365Z"
      fill="#BBD4DF"
    />
    <path
      d="M644.41 353.004C644.645 352.071 644.865 351.124 645.073 350.167L648.633 346.595C648.396 347.55 648.144 348.509 647.877 349.469L644.41 353.004"
      fill="#BBD4DF"
    />
    <path
      d="M655.272 341.932C655.32 341.789 655.366 341.647 655.413 341.505L655.55 341.65L655.272 341.932Z"
      fill="#8199A7"
    />
    <path
      d="M649.104 348.219C649.351 347.294 649.586 346.357 649.809 345.414L654.58 340.627L655.413 341.504C655.367 341.647 655.32 341.789 655.272 341.931L649.104 348.219"
      fill="#BBD4DF"
    />
    <path
      d="M654.673 352.189L654.98 342.794C654.999 342.741 655.017 342.69 655.034 342.638L662.323 335.483C662.59 337.889 662.926 340.464 663.349 343.141L654.673 352.189ZM667 339.336C666.749 336.501 666.587 333.829 666.485 331.397L667.329 330.568C667.418 332.98 667.566 335.651 667.8 338.498L667 339.336"
      fill="#8199A7"
    />
    <path
      d="M663.349 343.142C662.926 340.465 662.59 337.89 662.323 335.484L666.485 331.398C666.587 333.83 666.749 336.502 667 339.337L663.349 343.142"
      fill="#BBD4DF"
    />
    <path
      d="M667.8 338.499C667.566 335.652 667.417 332.981 667.329 330.569L670.242 327.709L670.589 335.592L667.8 338.499"
      fill="#BBD4DF"
    />
    <path
      d="M654.98 342.795L654.984 342.687L655.034 342.638C655.017 342.69 654.999 342.742 654.98 342.795"
      fill="#BBD4DF"
    />
    <path
      d="M670.74 342.612V340.249L670.971 340.016L670.74 342.612Z"
      fill="#F7F8E1"
    />
    <path
      d="M655.069 358.528L654.451 357.69V356.796L664.024 347.074C664.145 347.728 664.272 348.387 664.405 349.048L655.069 358.528ZM654.451 357.69L654.076 357.179L654.451 356.796V357.69ZM667.69 345.712C667.598 345.006 667.512 344.305 667.433 343.611L668.215 342.816C668.291 343.514 668.373 344.218 668.461 344.928L667.69 345.712Z"
      fill="#8199A7"
    />
    <path
      d="M664.404 349.047C664.272 348.386 664.145 347.728 664.024 347.073L667.433 343.611C667.512 344.304 667.598 345.006 667.689 345.712L664.404 349.047"
      fill="#BBD4DF"
    />
    <path
      d="M668.461 344.927C668.373 344.217 668.291 343.513 668.215 342.815L670.74 340.249V342.613L668.461 344.927Z"
      fill="#BBD4DF"
    />
    <path
      d="M670.74 362.545V361.6H639.109L639.11 327.452H669.796V362.545H670.74V361.6V362.545H671.684V325.563H637.221V363.489H671.684V362.545H670.74Z"
      fill="#284356"
    />
    <path
      d="M653.507 363.225H655.396V325.827H653.507V363.225Z"
      fill="#284356"
    />
    <path d="M185.556 412.32H218.129V376.283H185.556V412.32Z" fill="#6C8696" />
    <path
      d="M213.731 375.986H208.935C209.362 383.463 210.552 395.591 213.848 407.503C214.381 409.439 214.855 411.125 215.29 412.611H218.129V411.651C217.817 410.315 217.478 408.835 217.105 407.175C214.475 395.369 213.828 383.526 213.731 375.986"
      fill="#B4D0DB"
    />
    <path
      d="M214.613 375.986C214.702 383.516 215.344 395.399 217.989 407.242C218.036 407.458 218.081 407.651 218.129 407.864V375.986H214.613"
      fill="#B4D0DB"
    />
    <path
      d="M185.556 375.986V412.611H187.875C192.764 400.078 193.932 385.325 194.361 375.986H185.556"
      fill="#B4D0DB"
    />
    <path
      d="M199.508 375.986H195.118C194.723 388.913 193.012 402.201 188.535 412.611H190.437C190.489 412.402 190.532 412.201 190.63 411.996C196.422 399.719 198.502 384.935 199.508 375.986"
      fill="#B4D0DB"
    />
    <path
      d="M200.236 375.986C199.025 388.75 196.459 401.902 191.272 411.992C191.168 412.196 191.1 412.402 191.014 412.611H192.164C193.114 411.125 194.176 409.439 195.361 407.503C202.664 395.591 205.294 383.463 206.251 375.986H200.236"
      fill="#B4D0DB"
    />
    <path
      d="M185.556 396.746L185.474 393.299L185.556 393.218V396.746Z"
      fill="#F7F8E1"
    />
    <path
      d="M192.432 395.37C193.025 391.838 193.44 388.391 193.739 385.181L194.672 384.264C194.407 387.625 194.032 390.963 193.522 394.223L192.432 395.37ZM197.397 390.145C198.108 386.497 198.628 383.042 199.025 379.99L199.911 379.12C199.54 382.428 199.07 385.742 198.481 389.005L197.397 390.145"
      fill="#8199A7"
    />
    <path
      d="M185.692 402.462L185.556 396.746V393.218L193.739 385.181C193.44 388.391 193.025 391.838 192.432 395.37L185.692 402.462"
      fill="#BBD4DF"
    />
    <path
      d="M193.522 394.223C194.032 390.963 194.408 387.625 194.672 384.264L199.025 379.99C198.628 383.042 198.108 386.497 197.397 390.145L193.522 394.223"
      fill="#BBD4DF"
    />
    <path
      d="M198.481 389.005C199.07 385.741 199.54 382.427 199.911 379.12L200.723 378.323L203.247 383.991L198.481 389.005Z"
      fill="#BBD4DF"
    />
    <path
      d="M185.556 409.081L185.465 406.966L185.556 406.874V409.081Z"
      fill="#F7F8E1"
    />
    <path
      d="M190.626 403.972C190.872 403.014 191.102 402.053 191.316 401.092L192.463 399.943C192.257 400.897 192.037 401.841 191.801 402.774L190.626 403.972ZM195.269 399.239C195.536 398.28 195.788 397.323 196.024 396.368L197.198 395.19C196.975 396.133 196.741 397.067 196.494 397.992L195.269 399.239ZM202.665 391.702C202.711 391.56 202.758 391.42 202.805 391.279L202.941 391.421L202.665 391.702Z"
      fill="#8199A7"
    />
    <path
      d="M185.558 409.136L185.556 409.081V406.874L191.316 401.092C191.102 402.052 190.872 403.014 190.626 403.972L185.558 409.136"
      fill="#BBD4DF"
    />
    <path
      d="M191.801 402.775C192.037 401.842 192.257 400.898 192.464 399.944L196.024 396.369C195.788 397.324 195.536 398.28 195.269 399.24L191.801 402.775"
      fill="#BBD4DF"
    />
    <path
      d="M196.494 397.993C196.741 397.067 196.975 396.133 197.198 395.19L201.97 390.4L202.805 391.279C202.758 391.42 202.711 391.56 202.665 391.702L196.494 397.993Z"
      fill="#BBD4DF"
    />
    <path
      d="M202.061 401.964L202.373 392.564C202.389 392.514 202.407 392.465 202.424 392.413L209.713 385.258C209.979 387.665 210.315 390.239 210.738 392.917L202.061 401.964V401.964ZM214.39 389.109C214.139 386.276 213.977 383.603 213.875 381.172L214.72 380.342C214.808 382.753 214.956 385.425 215.192 388.273L214.39 389.109Z"
      fill="#8199A7"
    />
    <path
      d="M210.738 392.917C210.315 390.239 209.979 387.665 209.713 385.258L213.875 381.172C213.977 383.603 214.139 386.276 214.39 389.109L210.738 392.917"
      fill="#BBD4DF"
    />
    <path
      d="M215.192 388.274C214.956 385.426 214.808 382.754 214.72 380.343L217.633 377.483L217.982 385.365L215.192 388.274"
      fill="#BBD4DF"
    />
    <path
      d="M202.373 392.564L202.375 392.461L202.424 392.413C202.407 392.465 202.389 392.514 202.373 392.564"
      fill="#BBD4DF"
    />
    <path
      d="M218.129 392.387V390.022L218.359 389.789L218.129 392.387Z"
      fill="#F7F8E1"
    />
    <path
      d="M202.462 408.299L201.845 407.464V406.565L211.412 396.845C211.534 397.5 211.661 398.16 211.793 398.822L202.462 408.299ZM201.845 407.464L201.466 406.951L201.845 406.565V407.464ZM215.08 395.484C214.988 394.776 214.902 394.075 214.823 393.38L215.605 392.586C215.682 393.283 215.763 393.989 215.851 394.7L215.08 395.484Z"
      fill="#8199A7"
    />
    <path
      d="M211.793 398.823C211.661 398.16 211.534 397.5 211.412 396.846L214.823 393.381C214.902 394.076 214.988 394.777 215.08 395.485L211.793 398.823Z"
      fill="#BBD4DF"
    />
    <path
      d="M215.852 394.7C215.763 393.99 215.682 393.284 215.605 392.586L218.129 390.021V392.387L215.852 394.7Z"
      fill="#BBD4DF"
    />
    <path
      d="M218.129 412.32V411.376H186.5V377.227H217.185V412.32H218.129V411.376V412.32H219.074V375.339H184.612V413.264H219.074V412.32H218.129Z"
      fill="#284356"
    />
    <path d="M200.9 412.999H202.788V375.6H200.9V412.999Z" fill="#284356" />
    <path
      d="M639.012 412.905H671.588V376.867H639.012V412.905Z"
      fill="#6C8696"
    />
    <path
      d="M655.299 376.867H655.257L655.299 376.826V376.867Z"
      fill="#F7F8E1"
    />
    <path
      d="M639.021 402.015L639.337 392.514L655.257 376.868H655.299V384.695L639.021 402.015Z"
      fill="#8199A7"
    />
    <path
      d="M655.337 376.867H655.299V376.826L655.337 376.788V376.867Z"
      fill="#F7F8E1"
    />
    <path
      d="M655.299 384.694V376.868H655.336V384.654L655.299 384.694"
      fill="#8199A7"
    />
    <path
      d="M638.278 408.808L637.279 407.463L639.012 405.732V408.059L638.278 408.808Z"
      fill="#F7F8E1"
    />
    <path
      d="M639.012 408.059V405.732L654.688 390.071L655.299 390.713V391.458L639.012 408.059ZM655.299 391.458V390.713L655.657 391.091L655.299 391.458Z"
      fill="#8199A7"
    />
    <path
      d="M671.588 384.359V381.497L671.674 384.268L671.588 384.359ZM671.443 376.868H671.356L671.44 376.79L671.443 376.868"
      fill="#F7F8E1"
    />
    <path
      d="M655.111 401.519L655.1 392.13L655.298 391.942V401.324L655.111 401.519ZM655.298 401.324V391.942L671.356 376.867H671.443L671.588 381.495V384.357L655.298 401.324"
      fill="#8199A7"
    />
    <path
      d="M671.588 391.609V389.236L671.593 389.231L671.675 391.522L671.588 391.609Z"
      fill="#F7F8E1"
    />
    <path
      d="M655.185 407.967L655.265 405.64L655.299 405.606V407.854L655.185 407.967V407.967ZM655.299 407.854V405.606L671.588 389.235V391.609L655.299 407.854Z"
      fill="#8199A7"
    />
    <path
      d="M643.318 402.396C653.107 393.639 653.737 384.653 648.114 376.536H646.909C648.21 378.69 650.196 383.14 649.109 389.038C647.867 395.754 641.417 401.204 638.832 403.152V413.2L643.756 413.233C641.244 410.582 640.366 405.571 643.318 402.396"
      fill="#B4D0DB"
    />
    <path
      d="M642.336 376.536H638.832V394.33C644.096 387.791 643.224 380.224 642.336 376.536Z"
      fill="#B4D0DB"
    />
    <path
      d="M645.74 376.537H643.366C644.288 380.55 645.076 388.548 639.255 395.351L638.832 395.708V401.932C641.616 399.713 647.04 394.731 648.114 388.887C649.226 382.867 646.909 378.347 645.74 376.537"
      fill="#B4D0DB"
    />
    <path
      d="M667.279 402.396C657.491 393.639 656.862 384.653 662.489 376.536H663.693C662.394 378.69 660.403 383.14 661.491 389.038C662.734 395.754 669.179 401.204 671.763 403.152V413.2L666.84 413.233C669.351 410.582 670.23 405.571 667.279 402.396"
      fill="#B4D0DB"
    />
    <path
      d="M668.265 376.536H671.763V394.33C666.505 387.791 667.372 380.224 668.265 376.536Z"
      fill="#B4D0DB"
    />
    <path
      d="M664.859 376.537H667.241C666.308 380.55 665.519 388.548 671.342 395.351L671.763 395.708V401.932C668.985 399.713 663.564 394.731 662.483 388.887C661.371 382.867 663.691 378.347 664.859 376.537Z"
      fill="#B4D0DB"
    />
    <path
      d="M671.588 412.905V411.96H639.955V377.812H670.643V412.905H671.588V411.96V412.905H672.532V375.923H638.068V413.849H672.532V412.905H671.588Z"
      fill="#284356"
    />
    <path
      d="M654.354 413.583H656.243V376.185H654.354V413.583Z"
      fill="#284356"
    />
    <path
      d="M588.778 413.489H621.355V377.451H588.778V413.489Z"
      fill="#6C8696"
    />
    <path
      d="M616.956 377.158H612.157C612.587 384.631 613.778 396.759 617.072 408.672C617.603 410.607 618.084 412.292 618.512 413.782H621.354V412.822C621.039 411.486 620.704 410.005 620.33 408.342C617.7 396.54 617.055 384.696 616.956 377.158"
      fill="#B4D0DB"
    />
    <path
      d="M617.835 377.158C617.927 384.686 618.566 396.568 621.213 408.411C621.261 408.629 621.304 408.822 621.354 409.035V377.158H617.835Z"
      fill="#B4D0DB"
    />
    <path
      d="M588.778 377.158V413.782H591.099C595.993 401.248 597.158 386.494 597.587 377.158H588.778Z"
      fill="#B4D0DB"
    />
    <path
      d="M602.733 377.158H598.341C597.946 390.083 596.237 403.37 591.756 413.782H593.662C593.712 413.575 593.757 413.372 593.852 413.166C599.645 400.888 601.728 386.104 602.733 377.158Z"
      fill="#B4D0DB"
    />
    <path
      d="M603.461 377.158C602.249 389.921 599.683 403.07 594.496 413.162C594.392 413.368 594.323 413.575 594.236 413.782H595.387C596.337 412.292 597.398 410.607 598.584 408.672C605.886 396.759 608.517 384.631 609.475 377.158H603.461Z"
      fill="#B4D0DB"
    />
    <path
      d="M588.778 397.882L588.696 394.472L588.778 394.391V397.882Z"
      fill="#F7F8E1"
    />
    <path
      d="M595.658 396.539C596.251 393.007 596.668 389.56 596.965 386.35L597.895 385.437C597.631 388.798 597.256 392.136 596.746 395.394L595.658 396.539ZM600.621 391.316C601.333 387.667 601.853 384.212 602.249 381.161L603.137 380.29C602.764 383.598 602.295 386.913 601.707 390.174L600.621 391.316"
      fill="#8199A7"
    />
    <path
      d="M588.917 403.633L588.778 397.881V394.391L596.965 386.35C596.668 389.56 596.251 393.007 595.658 396.539L588.917 403.633"
      fill="#BBD4DF"
    />
    <path
      d="M596.746 395.394C597.256 392.135 597.631 388.798 597.895 385.437L602.249 381.161C601.853 384.212 601.333 387.667 600.621 391.316L596.746 395.394Z"
      fill="#BBD4DF"
    />
    <path
      d="M601.707 390.174C602.295 386.913 602.764 383.598 603.137 380.29L603.948 379.493L606.47 385.16L601.707 390.174"
      fill="#BBD4DF"
    />
    <path
      d="M588.778 410.199L588.69 408.135L588.778 408.047V410.199Z"
      fill="#F7F8E1"
    />
    <path
      d="M593.851 405.143C594.098 404.185 594.328 403.222 594.544 402.26L595.686 401.114C595.479 402.07 595.259 403.015 595.023 403.948L593.851 405.143V405.143ZM598.492 400.414C598.759 399.453 599.011 398.494 599.248 397.539L600.424 396.359C600.2 397.303 599.964 398.239 599.717 399.165L598.492 400.414V400.414ZM605.886 392.877C605.934 392.735 605.98 392.592 606.027 392.45L606.164 392.595L605.886 392.877"
      fill="#8199A7"
    />
    <path
      d="M588.783 410.31L588.778 410.199V408.047L594.544 402.26C594.328 403.222 594.098 404.185 593.851 405.144L588.783 410.31Z"
      fill="#BBD4DF"
    />
    <path
      d="M595.023 403.948C595.259 403.015 595.479 402.07 595.686 401.114L599.248 397.539C599.011 398.493 598.759 399.453 598.492 400.414L595.023 403.948Z"
      fill="#BBD4DF"
    />
    <path
      d="M599.718 399.166C599.964 398.24 600.2 397.304 600.424 396.36L605.192 391.573L606.027 392.451C605.98 392.593 605.934 392.735 605.886 392.877L599.718 399.166Z"
      fill="#BBD4DF"
    />
    <path
      d="M605.285 403.133L605.599 393.727C605.614 393.681 605.63 393.636 605.645 393.59L612.937 386.431C613.204 388.837 613.54 391.411 613.963 394.087L605.285 403.133V403.133ZM617.614 390.279C617.365 387.446 617.203 384.774 617.101 382.343L617.942 381.517C618.031 383.927 618.18 386.598 618.414 389.444L617.614 390.279Z"
      fill="#8199A7"
    />
    <path
      d="M613.963 394.086C613.54 391.411 613.204 388.837 612.937 386.431L617.101 382.343C617.203 384.774 617.365 387.445 617.615 390.278L613.963 394.086Z"
      fill="#BBD4DF"
    />
    <path
      d="M618.414 389.444C618.18 386.598 618.031 383.926 617.942 381.516L620.857 378.654L621.204 386.535L618.414 389.444Z"
      fill="#BBD4DF"
    />
    <path
      d="M605.599 393.726L605.601 393.633L605.645 393.589C605.63 393.635 605.614 393.68 605.599 393.726"
      fill="#BBD4DF"
    />
    <path
      d="M621.354 393.557V391.194L621.584 390.961L621.354 393.557Z"
      fill="#F7F8E1"
    />
    <path
      d="M605.688 409.47L605.07 408.637V407.735L614.637 398.017C614.759 398.672 614.886 399.332 615.018 399.994L605.688 409.47V409.47ZM605.07 408.637L604.688 408.123L605.07 407.735V408.637ZM618.305 396.656C618.213 395.949 618.128 395.247 618.048 394.552L618.828 393.76C618.905 394.458 618.987 395.163 619.075 395.873L618.305 396.656Z"
      fill="#8199A7"
    />
    <path
      d="M615.018 399.994C614.886 399.332 614.759 398.672 614.637 398.017L618.048 394.552C618.128 395.247 618.213 395.948 618.305 396.656L615.018 399.994Z"
      fill="#BBD4DF"
    />
    <path
      d="M619.075 395.871C618.987 395.162 618.905 394.456 618.828 393.759L621.354 391.193V393.556L619.075 395.871"
      fill="#BBD4DF"
    />
    <path
      d="M621.354 413.489V412.545H589.723V378.395H620.41V413.489H621.354V412.545V413.489H622.299V376.507H587.834V414.434H622.299V413.489H621.354Z"
      fill="#284356"
    />
    <path
      d="M604.125 414.168H606.014V376.768H604.125V414.168Z"
      fill="#284356"
    />
    <path
      d="M235.681 313.069H268.261V277.033H235.681V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M235.47 276.771L235.413 313.33H236.033C239.117 308.064 242.803 301.329 244.69 293.944C246.176 288.093 247.13 282.496 246.143 276.771H235.47"
      fill="#B4D0DB"
    />
    <path
      d="M268.47 276.771L268.529 313.33H267.907C264.825 308.064 261.137 301.329 259.251 293.944C257.764 288.093 256.811 282.496 257.795 276.771H268.47Z"
      fill="#B4D0DB"
    />
    <path
      d="M245.266 291.557C245.816 289.136 246.239 286.749 246.432 284.371H251.025V285.603L245.266 291.557"
      fill="#8199A7"
    />
    <path
      d="M236.625 300.492V291.339L243.82 284.372H246.432C246.239 286.75 245.816 289.137 245.266 291.558L236.625 300.492"
      fill="#BBD4DF"
    />
    <path
      d="M241.762 302.336C242.317 301.059 242.841 299.75 243.319 298.409L251.025 290.689V292.724L241.762 302.336"
      fill="#8199A7"
    />
    <path
      d="M236.625 307.664V305.115L243.319 298.407C242.841 299.748 242.317 301.058 241.762 302.335L236.625 307.664Z"
      fill="#BBD4DF"
    />
    <path
      d="M252.914 300.403V291.286L257.743 286.525C258.07 288.949 258.604 291.389 259.233 293.875L252.914 300.403"
      fill="#8199A7"
    />
    <path
      d="M259.233 293.874C258.604 291.388 258.07 288.948 257.742 286.524L259.927 284.371H267.317V285.525L259.233 293.874"
      fill="#BBD4DF"
    />
    <path
      d="M251.025 307.399L250.74 307.016L251.025 306.733V307.399ZM252.914 307.165V304.845L260.297 297.47C260.476 298.002 260.662 298.528 260.856 299.052L252.914 307.165Z"
      fill="#8199A7"
    />
    <path
      d="M260.856 299.053C260.663 298.529 260.476 298.003 260.297 297.47L267.317 290.458V292.455L260.856 299.053Z"
      fill="#BBD4DF"
    />
    <path
      d="M268.261 313.069V312.126H236.624V277.977H267.317V313.069H268.261V312.126V313.069H269.205V276.088H234.737V314.013H269.205V313.069H268.261Z"
      fill="#284356"
    />
    <path
      d="M251.025 313.751H252.914V276.351H251.025V313.751Z"
      fill="#284356"
    />
    <path d="M638.18 313.069H670.754V277.033H638.18V313.069Z" fill="#6C8696" />
    <path
      d="M639.123 300.154V300.031C640.438 295.975 641.413 292.026 642.136 288.388L643.868 286.654C643.223 290.194 642.341 294.076 641.131 298.099L639.123 300.154V300.154ZM644.961 294.18C645.469 290.712 645.842 287.407 646.118 284.405L646.152 284.371H653.523V285.42L644.961 294.18"
      fill="#8199A7"
    />
    <path
      d="M643.472 302.747C643.663 301.808 643.843 300.872 644.014 299.942L653.523 290.308V292.346L643.472 302.747"
      fill="#8199A7"
    />
    <path
      d="M655.412 300.11V290.912L660.839 285.581C661.142 287.981 661.526 290.554 662.011 293.234L655.412 300.11"
      fill="#8199A7"
    />
    <path
      d="M663.684 291.493C663.263 288.99 662.93 286.597 662.667 284.372H663.698C663.929 286.324 664.212 288.405 664.562 290.576L663.684 291.493"
      fill="#8199A7"
    />
    <path
      d="M655.412 306.822V304.496L662.776 297.128C662.914 297.776 663.057 298.428 663.208 299.084L655.412 306.822Z"
      fill="#8199A7"
    />
    <path
      d="M664.829 297.476C664.684 296.809 664.547 296.146 664.416 295.488L665.277 294.627C665.404 295.29 665.538 295.959 665.677 296.632L664.829 297.476"
      fill="#8199A7"
    />
    <path
      d="M661.957 276.717H659.981C660.485 284.2 661.873 296.34 665.72 308.268C666.34 310.204 666.903 311.89 667.405 313.382H669.379C668.876 311.89 668.318 310.204 667.699 308.268C663.852 296.34 662.459 284.2 661.957 276.717Z"
      fill="#B4D0DB"
    />
    <path
      d="M662.992 276.717C663.491 284.197 664.878 296.339 668.727 308.268C669.352 310.208 669.907 311.889 670.408 313.382H670.722V276.717H662.992"
      fill="#B4D0DB"
    />
    <path
      d="M645.226 276.717C644.58 283.803 642.845 295.062 638.215 306.363V313.382H640.913C641.301 311.89 641.734 310.204 642.221 308.268C645.204 296.34 646.281 284.2 646.672 276.717H645.226"
      fill="#B4D0DB"
    />
    <path
      d="M638.215 276.717V302.696C641.807 292.668 643.246 283.033 643.824 276.717H638.215Z"
      fill="#B4D0DB"
    />
    <path
      d="M670.754 313.069V312.126H639.123V277.977H669.81V313.069H670.754V312.126V313.069H671.697V276.088H637.235V314.013H671.697V313.069H670.754Z"
      fill="#284356"
    />
    <path
      d="M653.523 313.751H655.412V276.351H653.523V313.751Z"
      fill="#284356"
    />
    <path d="M487.9 313.069H520.48V277.033H487.9V313.069Z" fill="#6C8696" />
    <path
      d="M487.69 276.771L487.632 313.33H488.253C491.336 308.064 495.023 301.329 496.909 293.944C498.396 288.093 499.351 282.496 498.366 276.771H487.69Z"
      fill="#B4D0DB"
    />
    <path
      d="M520.69 276.771L520.749 313.33H520.127C517.045 308.064 513.36 301.329 511.473 293.944C509.985 288.093 509.032 282.496 510.017 276.771H520.69"
      fill="#B4D0DB"
    />
    <path
      d="M497.486 291.557C498.036 289.136 498.459 286.75 498.652 284.371H503.245V285.603L497.486 291.557Z"
      fill="#8199A7"
    />
    <path
      d="M488.844 300.492V291.342L496.042 284.372H498.652C498.459 286.751 498.036 289.137 497.486 291.558L488.844 300.492"
      fill="#BBD4DF"
    />
    <path
      d="M493.982 302.334C494.537 301.06 495.061 299.749 495.538 298.409L503.245 290.687V292.723L493.982 302.334Z"
      fill="#8199A7"
    />
    <path
      d="M488.844 307.664V305.117L495.538 298.409C495.061 299.748 494.537 301.059 493.982 302.333L488.844 307.664Z"
      fill="#BBD4DF"
    />
    <path
      d="M505.134 300.401V291.285L509.965 286.525C510.292 288.947 510.825 291.387 511.455 293.871L505.134 300.401"
      fill="#8199A7"
    />
    <path
      d="M511.454 293.872C510.825 291.388 510.292 288.948 509.965 286.525L512.148 284.372H519.535V285.525L511.454 293.872"
      fill="#BBD4DF"
    />
    <path
      d="M503.245 307.399L502.962 307.016L503.245 306.733V307.399ZM505.134 307.166V304.845L512.518 297.47C512.697 298.001 512.883 298.528 513.077 299.052L505.134 307.166"
      fill="#8199A7"
    />
    <path
      d="M513.078 299.053C512.884 298.529 512.697 298.002 512.519 297.47L519.536 290.461V292.456L513.078 299.053Z"
      fill="#BBD4DF"
    />
    <path
      d="M520.48 313.069V312.126H488.844V277.977H519.535V313.069H520.48V312.126V313.069H521.424V276.088H486.956V314.013H521.424V313.069H520.48Z"
      fill="#284356"
    />
    <path
      d="M503.245 313.751H505.134V276.351H503.245V313.751Z"
      fill="#284356"
    />
    <path
      d="M588.784 313.069H621.357V277.033H588.784V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M588.613 277.135L588.609 304.356L589.204 304.317L603.437 277.135H588.613"
      fill="#B4D0DB"
    />
    <path
      d="M620.969 277.134H609.566L621.222 304.43L621.534 304.496L621.044 277.271L620.969 277.134"
      fill="#B4D0DB"
    />
    <path
      d="M592.048 298.883L599.647 284.372H604.128V286.37L592.048 298.883V298.883ZM606.017 284.414V284.372H606.023L606.033 284.396L606.017 284.414"
      fill="#8199A7"
    />
    <path
      d="M589.729 301.286V292.392L597.824 284.372H599.647L592.048 298.883L589.729 301.286"
      fill="#BBD4DF"
    />
    <path
      d="M589.729 308.38V305.889L604.128 291.437V293.485L589.729 308.38Z"
      fill="#8199A7"
    />
    <path
      d="M606.017 301.119V292.033L613 285.176L615.471 290.964L606.017 301.119Z"
      fill="#8199A7"
    />
    <path
      d="M615.472 290.963L613 285.175L613.817 284.372H620.412V285.656L615.472 290.963Z"
      fill="#BBD4DF"
    />
    <path
      d="M606.017 307.932V305.557L617.02 294.592L617.682 296.142L606.017 307.932"
      fill="#8199A7"
    />
    <path
      d="M617.682 296.142L617.02 294.592L620.412 291.212V293.384L617.682 296.142"
      fill="#BBD4DF"
    />
    <path
      d="M621.357 313.069V312.126H589.729V277.977H620.412V313.069H621.357V312.126V313.069H622.301V276.088H587.84V314.013H622.301V313.069H621.357Z"
      fill="#284356"
    />
    <path
      d="M604.128 313.751H606.017V276.351H604.128V313.751Z"
      fill="#284356"
    />
    <path
      d="M282.286 354.007H334.328V353.063H282.286V354.007Z"
      fill="#284356"
    />
    <path
      d="M273.209 385.923H285.729V384.979H273.209V385.923Z"
      fill="#284356"
    />
    <path
      d="M274.54 442.688H274.28C274.375 442.55 274.461 442.405 274.54 442.256V442.688Z"
      fill="#1E3424"
    />
    <path
      d="M167.313 442.688H121.347C120.173 442.465 119.287 441.435 119.285 440.201V434.721C120.917 428.855 126.298 424.551 132.684 424.551H146.978H161.032C163.778 424.551 166.332 425.35 168.484 426.725C167.251 428.891 166.546 431.395 166.546 434.066V440.201C166.547 441.123 166.829 441.979 167.313 442.688Z"
      fill="#949B2E"
    />
    <path
      d="M121.347 442.688H118.777V438.458C118.777 437.163 118.954 435.911 119.285 434.721V440.201C119.287 441.435 120.172 442.465 121.347 442.688"
      fill="#1E3424"
    />
    <path
      d="M217.762 442.688H170.496C169.325 442.465 168.437 441.435 168.435 440.201V434.066C168.436 431.815 169.007 429.701 170.015 427.859C170.521 428.287 170.996 428.754 171.435 429.25C173.984 426.374 177.692 424.551 181.835 424.551H196.129H210.183C213.341 424.551 216.248 425.608 218.58 427.385C217.567 429.393 216.996 431.662 216.996 434.066V440.201C216.996 441.123 217.278 441.979 217.762 442.688Z"
      fill="#949B2E"
    />
    <path
      d="M170.496 442.688H167.313C166.829 441.979 166.547 441.123 166.546 440.201V434.066C166.546 431.395 167.251 428.891 168.484 426.725C169.02 427.069 169.531 427.446 170.015 427.859C169.007 429.701 168.436 431.815 168.435 434.066V440.201C168.437 441.435 169.325 442.465 170.496 442.688"
      fill="#1E3424"
    />
    <path
      d="M271.095 442.688H220.948C219.772 442.465 218.886 441.435 218.885 440.201V434.066C218.885 432.143 219.303 430.32 220.052 428.68C220.475 429.107 220.87 429.562 221.236 430.04C223.775 426.71 227.775 424.551 232.287 424.551H246.582H260.635C266.03 424.551 270.705 427.622 273.012 432.111C273.107 432.749 273.158 433.401 273.158 434.066V440.201C273.155 441.435 272.269 442.465 271.095 442.688"
      fill="#949B2E"
    />
    <path
      d="M274.28 442.688H271.095C272.269 442.465 273.155 441.435 273.158 440.201V434.066C273.158 433.401 273.107 432.749 273.012 432.111C273.989 434.014 274.54 436.171 274.54 438.458V442.256C274.461 442.405 274.375 442.55 274.28 442.688ZM220.948 442.688H217.762C217.278 441.979 216.996 441.123 216.996 440.201V434.066C216.996 431.662 217.566 429.393 218.58 427.385C219.1 427.781 219.592 428.215 220.052 428.68C219.303 430.32 218.885 432.143 218.885 434.066V440.201C218.886 441.435 219.772 442.465 220.948 442.688Z"
      fill="#1E3424"
    />
    <path
      d="M741.233 443.859H739.596C740.331 443.361 740.906 442.648 741.233 441.81V443.859"
      fill="#1E3424"
    />
    <path
      d="M585.821 443.859H585.472V443.597C585.584 443.69 585.7 443.777 585.821 443.859Z"
      fill="#1E3424"
    />
    <path
      d="M737.113 442.732H691.585C692.086 442.016 692.381 441.142 692.381 440.201V434.066C692.381 432.136 692.013 430.292 691.343 428.6C693.533 427.152 696.157 426.306 698.981 426.306H713.275H727.329C732.674 426.306 737.316 429.324 739.643 433.75C739.646 433.854 739.648 433.96 739.648 434.066V440.201C739.644 441.595 738.512 442.73 737.113 442.732Z"
      fill="#949B2E"
    />
    <path
      d="M739.597 443.859H690.443C690.889 443.557 691.277 443.174 691.585 442.734H722.819H737.114C738.512 442.731 739.644 441.596 739.648 440.203V434.067C739.648 433.961 739.646 433.855 739.643 433.751C740.659 435.683 741.233 437.882 741.233 440.215V441.81C740.906 442.648 740.331 443.361 739.597 443.859"
      fill="#1E3424"
    />
    <path
      d="M687.96 442.732H641.134C641.636 442.016 641.931 441.143 641.932 440.201V434.066C641.932 432.137 641.563 430.292 640.894 428.601C643.083 427.152 645.703 426.306 648.527 426.306H662.821H676.875C681.388 426.306 685.388 428.466 687.927 431.796C688.479 431.074 689.098 430.407 689.777 429.805C690.24 431.138 690.492 432.572 690.492 434.066V440.201C690.49 441.597 689.362 442.73 687.96 442.732"
      fill="#949B2E"
    />
    <path
      d="M690.443 443.859H639.991C640.437 443.557 640.825 443.174 641.133 442.734H673.667H687.96C689.361 442.731 690.49 441.598 690.492 440.203V434.067C690.492 432.574 690.24 431.139 689.777 429.806C690.269 429.369 690.792 428.966 691.343 428.601C692.013 430.293 692.381 432.137 692.381 434.067V440.203C692.381 441.143 692.086 442.017 691.585 442.734C691.277 443.174 690.889 443.557 690.443 443.859"
      fill="#1E3424"
    />
    <path
      d="M637.511 442.732H588.302C586.906 442.73 585.772 441.594 585.769 440.201V437.343C587.091 431.039 592.68 426.306 599.378 426.306H613.672H627.724C631.87 426.306 635.581 428.129 638.128 431.005C638.503 430.582 638.904 430.182 639.327 429.805C639.792 431.14 640.043 432.572 640.043 434.066V440.201C640.041 441.594 638.906 442.73 637.511 442.732"
      fill="#949B2E"
    />
    <path
      d="M639.992 443.859H585.821C585.7 443.777 585.584 443.69 585.472 443.597V440.215C585.472 439.231 585.574 438.271 585.769 437.344V440.203C585.772 441.595 586.906 442.731 588.302 442.734H623.218H637.511C638.906 442.731 640.041 441.595 640.043 440.203V434.067C640.043 432.574 639.792 431.141 639.327 429.806C639.82 429.369 640.343 428.966 640.894 428.602C641.563 430.293 641.932 432.138 641.932 434.067V440.203C641.931 441.144 641.636 442.017 641.134 442.734C640.825 443.174 640.437 443.557 639.992 443.859"
      fill="#1E3424"
    />
    <path
      d="M374.292 270.418H404.887V269.473H374.292V270.418Z"
      fill="#284356"
    />
    <path
      d="M422.089 270.418H435.191V269.473H422.089V270.418Z"
      fill="#284356"
    />
    <path d="M455.76 269.836H524.489V268.891H455.76V269.836Z" fill="#284356" />
    <path
      d="M524.489 284.766H537.737V283.822H524.489V284.766Z"
      fill="#284356"
    />
    <path
      d="M571.042 297.063H584.291V296.118H571.042V297.063Z"
      fill="#284356"
    />
    <path d="M403.79 288.426H423.992V287.481H403.79V288.426Z" fill="#284356" />
    <path d="M479 291.353H487.013V290.408H479V291.353Z" fill="#284356" />
    <path
      d="M519.694 305.407H532.247V304.463H519.694V305.407Z"
      fill="#284356"
    />
    <path
      d="M429.811 288.426H446.279V287.481H429.811V288.426Z"
      fill="#284356"
    />
    <path
      d="M562.002 269.836H578.472V268.891H562.002V269.836Z"
      fill="#284356"
    />
    <path
      d="M355.773 307.161H378.538V306.217H355.773V307.161Z"
      fill="#284356"
    />
    <path d="M375.757 295.305H398.52V294.361H375.757V295.305Z" fill="#284356" />
    <path d="M574.92 388.116H588.462V387.171H574.92V388.116Z" fill="#284356" />
    <path d="M569.87 364.255H581.434V363.31H569.87V364.255Z" fill="#284356" />
    <path d="M576.459 347.565H588.023V346.62H576.459V347.565Z" fill="#284356" />
    <path
      d="M622.572 335.268H634.138V334.323H622.572V335.268Z"
      fill="#284356"
    />
    <path d="M644.968 270.71H687.494V269.766H644.968V270.71Z" fill="#284356" />
    <path d="M671.1 300.575H682.224V299.63H671.1V300.575Z" fill="#284356" />
    <path
      d="M675.821 284.873H686.948V283.929H675.821V284.873Z"
      fill="#284356"
    />
    <path d="M628.281 370.404H663.122V369.46H628.281V370.404Z" fill="#284356" />
    <path
      d="M388.176 313.069H420.751V277.033H388.176V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M389.12 300.154V300.031C390.433 295.975 391.408 292.029 392.129 288.39L393.866 286.655C393.221 290.196 392.337 294.076 391.128 298.099L389.12 300.154V300.154ZM394.956 294.182C395.464 290.714 395.838 287.411 396.113 284.408L396.15 284.371H403.518V285.42L394.956 294.182"
      fill="#8199A7"
    />
    <path
      d="M393.465 302.749C393.657 301.809 393.838 300.873 394.008 299.943L403.518 290.308V292.345L393.465 302.749Z"
      fill="#8199A7"
    />
    <path
      d="M405.406 300.11V290.913L410.835 285.581C411.138 287.982 411.521 290.553 412.007 293.234L405.406 300.11ZM413.68 291.491C413.258 288.989 412.926 286.596 412.663 284.371H413.694C413.924 286.322 414.209 288.405 414.559 290.576L413.68 291.491Z"
      fill="#8199A7"
    />
    <path
      d="M405.406 306.823V304.497L412.771 297.128C412.91 297.775 413.053 298.429 413.203 299.085L405.406 306.823V306.823ZM414.823 297.477C414.68 296.808 414.543 296.145 414.412 295.486L415.273 294.625C415.4 295.289 415.534 295.958 415.673 296.632L414.823 297.477"
      fill="#8199A7"
    />
    <path
      d="M411.954 276.717H409.977C410.482 284.2 411.867 296.34 415.716 308.268C416.336 310.204 416.9 311.89 417.402 313.382H419.375C418.872 311.89 418.315 310.204 417.694 308.268C413.848 296.34 412.455 284.2 411.954 276.717Z"
      fill="#B4D0DB"
    />
    <path
      d="M412.988 276.717C413.486 284.197 414.874 296.339 418.723 308.268C419.348 310.208 419.903 311.889 420.405 313.382H420.717V276.717H412.988"
      fill="#B4D0DB"
    />
    <path
      d="M395.222 276.717C394.577 283.803 392.843 295.062 388.211 306.363V313.382H390.91C391.297 311.89 391.731 310.204 392.216 308.268C395.198 296.34 396.277 284.2 396.668 276.717H395.222"
      fill="#B4D0DB"
    />
    <path
      d="M388.211 276.717V302.696C391.803 292.668 393.24 283.033 393.82 276.717H388.211Z"
      fill="#B4D0DB"
    />
    <path
      d="M420.75 313.069V312.126H389.12V277.977H419.806V313.069H420.75V312.126V313.069H421.695V276.088H387.231V314.013H421.695V313.069H420.75Z"
      fill="#284356"
    />
    <path
      d="M403.518 313.751H405.407V276.351H403.518V313.751Z"
      fill="#284356"
    />
    <path
      d="M288.548 313.069H321.123V277.033H288.548V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M289.492 300.154V300.033C290.805 295.976 291.78 292.029 292.503 288.389L294.238 286.654C293.593 290.194 292.71 294.075 291.502 298.097L289.492 300.154ZM295.329 294.181C295.837 290.713 296.211 287.408 296.487 284.405L296.522 284.371H303.891V285.42L295.329 294.181"
      fill="#8199A7"
    />
    <path
      d="M293.839 302.749C294.03 301.81 294.211 300.874 294.381 299.944L303.891 290.309V292.346L293.839 302.749"
      fill="#8199A7"
    />
    <path
      d="M305.78 300.11V290.913L311.208 285.581C311.512 287.982 311.895 290.554 312.381 293.235L305.78 300.11Z"
      fill="#8199A7"
    />
    <path
      d="M314.053 291.493C313.632 288.99 313.299 286.597 313.035 284.371H314.068C314.298 286.323 314.582 288.405 314.932 290.576L314.053 291.493Z"
      fill="#8199A7"
    />
    <path
      d="M305.78 306.822V304.495L313.145 297.126C313.282 297.775 313.426 298.428 313.577 299.084L305.78 306.822"
      fill="#8199A7"
    />
    <path
      d="M315.197 297.476C315.054 296.807 314.916 296.144 314.784 295.485L315.645 294.624C315.773 295.288 315.907 295.957 316.047 296.632L315.197 297.476"
      fill="#8199A7"
    />
    <path
      d="M312.326 276.717H310.351C310.856 284.2 312.24 296.34 316.09 308.268C316.709 310.204 317.272 311.89 317.773 313.382H319.749C319.244 311.89 318.687 310.204 318.067 308.268C314.22 296.34 312.828 284.2 312.326 276.717"
      fill="#B4D0DB"
    />
    <path
      d="M313.359 276.717C313.86 284.197 315.246 296.339 319.097 308.268C319.72 310.208 320.276 311.889 320.778 313.382H321.09V276.717H313.359"
      fill="#B4D0DB"
    />
    <path
      d="M295.594 276.717C294.951 283.803 293.216 295.062 288.584 306.363V313.382H291.284C291.671 311.89 292.104 310.204 292.59 308.268C295.571 296.34 296.649 284.2 297.042 276.717H295.594"
      fill="#B4D0DB"
    />
    <path
      d="M288.584 276.717V302.696C292.175 292.668 293.613 283.033 294.193 276.717H288.584Z"
      fill="#B4D0DB"
    />
    <path
      d="M321.123 313.069V312.126H289.492V277.977H320.178V313.069H321.123V312.126V313.069H322.067V276.088H287.604V314.013H322.067V313.069H321.123Z"
      fill="#284356"
    />
    <path d="M303.892 313.751H305.78V276.351H303.892V313.751Z" fill="#284356" />
    <path
      d="M537.696 313.069H570.272V277.033H537.696V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M538.64 300.154V300.034C539.955 295.978 540.929 292.029 541.652 288.388L543.386 286.654C542.741 290.194 541.858 294.075 540.65 298.097L538.64 300.154V300.154ZM544.479 294.18C544.985 290.712 545.36 287.407 545.636 284.405L545.67 284.371H553.041V285.42L544.479 294.18"
      fill="#8199A7"
    />
    <path
      d="M542.987 302.747C543.179 301.808 543.359 300.872 543.53 299.943L553.041 290.308V292.344L542.987 302.747"
      fill="#8199A7"
    />
    <path
      d="M554.929 300.11V290.911L560.356 285.581C560.66 287.981 561.042 290.554 561.528 293.234L554.929 300.11"
      fill="#8199A7"
    />
    <path
      d="M563.2 291.493C562.78 288.991 562.447 286.597 562.184 284.372H563.216C563.446 286.324 563.729 288.407 564.079 290.577L563.2 291.493Z"
      fill="#8199A7"
    />
    <path
      d="M554.929 306.822V304.495L562.293 297.128C562.431 297.775 562.575 298.428 562.725 299.084L554.929 306.822Z"
      fill="#8199A7"
    />
    <path
      d="M564.345 297.476C564.201 296.809 564.064 296.146 563.933 295.487L564.793 294.627C564.92 295.289 565.055 295.959 565.195 296.632L564.345 297.476"
      fill="#8199A7"
    />
    <path
      d="M561.474 276.717H559.498C560.004 284.2 561.388 296.34 565.239 308.268C565.857 310.204 566.42 311.89 566.921 313.382H568.897C568.392 311.89 567.835 310.204 567.215 308.268C563.368 296.34 561.977 284.2 561.474 276.717Z"
      fill="#B4D0DB"
    />
    <path
      d="M562.509 276.717C563.008 284.197 564.394 296.339 568.244 308.268C568.869 310.208 569.425 311.889 569.924 313.382H570.24V276.717H562.509"
      fill="#B4D0DB"
    />
    <path
      d="M544.744 276.717C544.097 283.803 542.363 295.062 537.732 306.363V313.382H540.431C540.818 311.89 541.253 310.204 541.738 308.268C544.721 296.34 545.798 284.2 546.19 276.717H544.744"
      fill="#B4D0DB"
    />
    <path
      d="M537.732 276.717V302.696C541.325 292.668 542.761 283.033 543.341 276.717H537.732Z"
      fill="#B4D0DB"
    />
    <path
      d="M570.272 313.069V312.126H538.64V277.977H569.327V313.069H570.272V312.126V313.069H571.216V276.088H536.751V314.013H571.216V313.069H570.272Z"
      fill="#284356"
    />
    <path
      d="M553.041 313.751H554.929V276.351H553.041V313.751Z"
      fill="#284356"
    />
    <path
      d="M338.352 313.069H370.925V277.033H338.352V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M338.182 277.135L338.179 304.356L338.77 304.317L353.002 277.135H338.182"
      fill="#B4D0DB"
    />
    <path
      d="M370.535 277.134H359.133L370.791 304.43L371.101 304.496L370.612 277.271L370.535 277.134Z"
      fill="#B4D0DB"
    />
    <path
      d="M341.613 298.885L349.213 284.371H353.695V286.37L341.613 298.885V298.885ZM355.583 284.413V284.371H355.589L355.601 284.395L355.583 284.413"
      fill="#8199A7"
    />
    <path
      d="M339.295 301.286V292.391L347.39 284.372H349.213L341.613 298.885L339.295 301.286"
      fill="#BBD4DF"
    />
    <path
      d="M339.295 308.382V305.889L353.695 291.438V293.486L339.295 308.382Z"
      fill="#8199A7"
    />
    <path
      d="M355.583 301.119V292.033L362.568 285.174L365.039 290.963L355.583 301.119Z"
      fill="#8199A7"
    />
    <path
      d="M365.039 290.963L362.568 285.175L363.385 284.372H369.98V285.656L365.039 290.963Z"
      fill="#BBD4DF"
    />
    <path
      d="M355.583 307.934V305.559L366.589 294.591L367.252 296.142L355.583 307.934"
      fill="#8199A7"
    />
    <path
      d="M367.252 296.142L366.589 294.591L369.98 291.212V293.384L367.252 296.142"
      fill="#BBD4DF"
    />
    <path
      d="M370.924 313.069V312.126H339.295V277.977H369.98V313.069H370.924V312.126V313.069H371.867V276.088H337.408V314.013H371.867V313.069H370.924Z"
      fill="#284356"
    />
    <path
      d="M353.695 313.751H355.584V276.351H353.695V313.751Z"
      fill="#284356"
    />
    <path d="M235.576 412.32H268.147V376.283H235.576V412.32Z" fill="#6C8696" />
    <path
      d="M235.403 376.384L235.399 403.607L235.994 403.568L250.224 376.384H235.403"
      fill="#B4D0DB"
    />
    <path
      d="M267.756 376.382H256.354L268.012 403.68L268.322 403.743L267.832 376.518L267.756 376.382"
      fill="#B4D0DB"
    />
    <path
      d="M238.841 398.129L248.401 379.867L250.305 377.981L251.86 381.48V384.644L238.841 398.129ZM251.86 384.644V381.48L252.823 383.647L251.86 384.644Z"
      fill="#8199A7"
    />
    <path
      d="M235.614 401.471L235.688 392.461L248.401 379.867L238.841 398.13L235.614 401.471Z"
      fill="#BBD4DF"
    />
    <path
      d="M235.538 408.644L235.576 407.986V408.605L235.538 408.644Z"
      fill="#F7F8E1"
    />
    <path
      d="M235.576 408.605V407.985L235.688 405.971L251.543 390.058L251.86 390.392V391.756L235.576 408.605ZM251.86 391.756V390.392L252.513 391.079L251.86 391.756Z"
      fill="#8199A7"
    />
    <path
      d="M251.637 401.62L251.86 394.956V401.381L251.637 401.62V401.62ZM251.86 401.381V394.956L251.954 392.118L259.787 384.425L262.26 390.212L251.86 401.381ZM267.968 384.081L267.951 383.157L268.055 383.989L267.968 384.081Z"
      fill="#8199A7"
    />
    <path
      d="M262.26 390.211L259.787 384.424L267.206 377.138L267.951 383.156L267.968 384.08L262.26 390.211"
      fill="#BBD4DF"
    />
    <path
      d="M268.146 391.679V389.522L268.451 389.219L268.201 391.624L268.146 391.679"
      fill="#F7F8E1"
    />
    <path
      d="M252.04 407.954L251.86 406.416V405.747L263.81 393.841L264.471 395.391L252.04 407.954V407.954ZM251.86 406.416L251.789 405.818L251.86 405.747V406.416ZM268.105 391.718L268.067 389.6L268.146 389.521V391.678L268.105 391.718Z"
      fill="#8199A7"
    />
    <path
      d="M264.471 395.392L263.81 393.842L268.067 389.601L268.105 391.719L264.471 395.392"
      fill="#BBD4DF"
    />
    <path
      d="M268.147 412.32V411.376H236.519V377.227H267.202V412.32H268.147V411.376V412.32H269.091V375.338H234.631V413.264H269.091V412.32H268.147"
      fill="#284356"
    />
    <path d="M250.916 412.999H252.804V375.6H250.916V412.999Z" fill="#284356" />
    <path
      d="M437.896 313.069H470.469V277.033H437.896V313.069Z"
      fill="#6C8696"
    />
    <path
      d="M466.071 276.738H461.276C461.704 284.214 462.897 296.34 466.188 308.254C466.721 310.188 467.199 311.873 467.628 313.364H470.469V312.403C470.158 311.067 469.819 309.588 469.448 307.924C466.816 296.12 466.168 284.276 466.071 276.738"
      fill="#B4D0DB"
    />
    <path
      d="M466.953 276.738C467.043 284.267 467.685 296.148 470.329 307.992C470.376 308.21 470.422 308.402 470.469 308.616V276.738H466.953Z"
      fill="#B4D0DB"
    />
    <path
      d="M437.896 276.738V313.364H440.215C445.107 300.83 446.274 286.075 446.702 276.738H437.896"
      fill="#B4D0DB"
    />
    <path
      d="M451.848 276.738H447.459C447.063 289.667 445.353 302.952 440.873 313.364H442.777C442.83 313.156 442.87 312.953 442.97 312.748C448.762 300.469 450.842 285.684 451.848 276.738Z"
      fill="#B4D0DB"
    />
    <path
      d="M452.577 276.738C451.366 289.502 448.798 302.651 443.612 312.743C443.509 312.948 443.442 313.156 443.355 313.364H444.505C445.455 311.873 446.514 310.188 447.702 308.254C455.003 296.34 457.635 284.214 458.591 276.738H452.577"
      fill="#B4D0DB"
    />
    <path
      d="M444.773 296.12C445.366 292.588 445.781 289.142 446.08 285.934L447.013 285.017C446.747 288.378 446.373 291.715 445.863 294.973L444.773 296.12V296.12ZM449.736 290.896C450.178 288.63 450.547 286.438 450.857 284.371H451.684C451.43 286.174 451.144 287.972 450.822 289.754L449.736 290.896"
      fill="#8199A7"
    />
    <path
      d="M438.84 302.364V293.044L446.08 285.933C445.782 289.142 445.366 292.588 444.773 296.12L438.84 302.364Z"
      fill="#BBD4DF"
    />
    <path
      d="M445.863 294.973C446.373 291.714 446.747 288.378 447.013 285.017L447.671 284.371H450.857C450.547 286.437 450.178 288.63 449.736 290.896L445.863 294.973Z"
      fill="#BBD4DF"
    />
    <path
      d="M450.822 289.753C451.144 287.972 451.43 286.174 451.684 284.371H453.242V287.207L450.822 289.753ZM455.13 285.221V284.371H455.421L455.586 284.741L455.13 285.221"
      fill="#BBD4DF"
    />
    <path
      d="M442.966 304.724C443.213 303.766 443.443 302.803 443.658 301.841L444.803 300.692C444.596 301.647 444.376 302.594 444.141 303.527L442.966 304.724V304.724ZM447.608 299.994C447.875 299.033 448.126 298.074 448.364 297.119L449.538 295.94C449.316 296.884 449.08 297.819 448.832 298.746L447.608 299.994"
      fill="#8199A7"
    />
    <path
      d="M438.84 308.93V306.677L443.659 301.841C443.443 302.803 443.213 303.766 442.966 304.724L438.84 308.93Z"
      fill="#BBD4DF"
    />
    <path
      d="M444.141 303.527C444.376 302.594 444.596 301.648 444.803 300.692L448.364 297.12C448.126 298.074 447.875 299.034 447.608 299.994L444.141 303.527Z"
      fill="#BBD4DF"
    />
    <path
      d="M448.832 298.747C449.08 297.82 449.316 296.884 449.539 295.94L453.242 292.224V294.254L448.832 298.747"
      fill="#BBD4DF"
    />
    <path
      d="M455.13 292.328V292.075C455.134 292.06 455.139 292.045 455.144 292.031L455.281 292.175L455.13 292.328"
      fill="#8199A7"
    />
    <path
      d="M455.13 292.075V292.016L455.144 292.031C455.139 292.045 455.134 292.06 455.13 292.075"
      fill="#BBD4DF"
    />
    <path
      d="M455.13 301.954V292.808L462.056 286.009C462.321 288.415 462.657 290.988 463.08 293.664L455.13 301.954V301.954ZM466.729 289.859C466.561 287.949 466.432 286.111 466.335 284.372H467.21C467.293 285.855 467.398 287.411 467.531 289.023L466.729 289.859"
      fill="#8199A7"
    />
    <path
      d="M463.081 293.664C462.658 290.988 462.321 288.414 462.056 286.008L463.723 284.371H466.335C466.432 286.11 466.561 287.948 466.73 289.859L463.081 293.664Z"
      fill="#BBD4DF"
    />
    <path
      d="M467.531 289.023C467.398 287.411 467.294 285.855 467.21 284.372H469.525V286.944L467.531 289.023Z"
      fill="#BBD4DF"
    />
    <path
      d="M455.13 308.718V306.358L463.754 297.596C463.876 298.252 464.002 298.909 464.136 299.571L455.13 308.718V308.718ZM467.419 296.235C467.329 295.528 467.243 294.827 467.164 294.133L467.946 293.339C468.021 294.036 468.103 294.74 468.191 295.452L467.419 296.235Z"
      fill="#8199A7"
    />
    <path
      d="M464.135 299.571C464.002 298.909 463.876 298.252 463.754 297.596L467.164 294.133C467.243 294.827 467.329 295.528 467.419 296.235L464.135 299.571Z"
      fill="#BBD4DF"
    />
    <path
      d="M468.191 295.453C468.103 294.741 468.021 294.037 467.946 293.34L469.525 291.734V294.098L468.191 295.453Z"
      fill="#BBD4DF"
    />
    <path
      d="M470.469 313.069V312.126H438.84V277.977H469.525V313.069H470.469V312.126V313.069H471.413V276.088H436.951V314.013H471.413V313.069H470.469Z"
      fill="#284356"
    />
    <path d="M453.242 313.751H455.13V276.351H453.242V313.751Z" fill="#284356" />
    <path
      d="M675.821 284.371H671.697V276.089H637.235V284.371H622.301V276.089H587.84V284.371H571.216V276.089H536.752V283.821H524.489V284.293V284.371H521.424V276.089H486.956V284.371H471.413V276.089H436.951V284.371H421.695V276.089H387.231V284.371H371.868V276.089H337.408V284.371H322.067V276.089H287.604V284.371H269.205V276.089H234.737V284.371H219.074V276.089H184.612V284.371H176.388V270.419H227.462V269.473H176.388V265.302H686.016V269.766H644.968V270.238V270.71H686.016V283.929H675.821V284.371ZM422.089 269.947V270.419H435.191V269.473H422.089V269.947V269.947ZM374.293 269.947V270.419H404.887V269.473H374.293V269.947ZM244.663 269.947V270.419H257.764V269.473H244.663V269.947V269.947ZM562.002 269.363V269.835H578.472V268.89H562.002V269.363ZM455.76 269.363V269.835H524.489V268.89H455.76V269.363ZM278.333 269.363V269.835H347.063V268.89H278.333V269.363Z"
      fill="#D6D2BA"
    />
    <path
      d="M687.435 284.371H686.948V283.929H686.016V270.71H687.435V284.371V284.371ZM176.388 284.371H175.026V265.302H176.388V269.473H175.42V269.947V270.419H176.388V284.371ZM687.435 269.766H686.016V265.302H687.435V269.766Z"
      fill="#2A3E4D"
    />
    <path d="M687.435 265.302H175.026V264.577H687.435V265.302" fill="#2A3E4D" />
    <path d="M227.462 270.418H175.42V269.473H227.462V270.418Z" fill="#2A3E4D" />
    <path
      d="M257.764 270.418H244.663V269.473H257.764V270.418Z"
      fill="#2A3E4D"
    />
    <path
      d="M347.063 269.836H278.333V268.891H347.063V269.836Z"
      fill="#2A3E4D"
    />
    <path
      d="M209.54 284.371H204.906C205.43 282.033 205.809 279.88 206.082 277.978H209.011C209.133 279.88 209.303 282.033 209.54 284.371ZM194.722 284.371H193.877C194.069 282.078 194.202 279.927 194.302 277.978H195.075C194.997 280.107 194.881 282.242 194.722 284.371V284.371ZM213.875 281.925C213.816 280.523 213.777 279.203 213.751 277.978H214.631C214.65 278.958 214.679 280 214.72 281.095L213.875 281.925V281.925ZM199.025 280.741C199.151 279.778 199.264 278.854 199.366 277.978H200.114C200.051 278.608 199.983 279.239 199.912 279.871L199.025 280.741Z"
      fill="#617380"
    />
    <path
      d="M211.383 284.371H209.54C209.303 282.033 209.133 279.88 209.011 277.978H213.751C213.776 279.203 213.816 280.523 213.875 281.925L211.383 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M214.72 281.096C214.679 280 214.65 278.959 214.632 277.978H217.185V278.676L214.72 281.096"
      fill="#9AAEB7"
    />
    <path
      d="M193.877 284.371H186.5V277.978H194.302C194.202 279.927 194.069 282.078 193.877 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M195.331 284.371H194.722C194.881 282.242 194.997 280.107 195.075 277.978H199.366C199.264 278.854 199.151 279.778 199.025 280.741L195.331 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M204.906 284.371H203.082L202.788 283.713V277.978H206.082C205.809 279.88 205.43 282.033 204.906 284.371ZM199.912 279.871C199.983 279.239 200.051 278.608 200.114 277.978H200.899V279.471L200.723 279.074L199.912 279.871"
      fill="#9AAEB7"
    />
    <path
      d="M199.343 284.371H198.517C198.707 283.11 198.875 281.897 199.025 280.741L199.912 279.871C199.742 281.371 199.554 282.873 199.343 284.371"
      fill="#71828E"
    />
    <path
      d="M198.517 284.371H195.33L199.025 280.741C198.875 281.897 198.707 283.11 198.517 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M203.082 284.371H202.788V283.713L203.082 284.371ZM200.9 284.371H199.343C199.554 282.873 199.742 281.371 199.912 279.871L200.723 279.074L200.9 279.471V284.371"
      fill="#A0B2BA"
    />
    <path
      d="M214.871 284.371H213.994C213.948 283.532 213.907 282.716 213.875 281.925L214.72 281.095C214.757 282.14 214.808 283.234 214.871 284.371Z"
      fill="#71828E"
    />
    <path
      d="M213.994 284.371H211.383L213.875 281.925C213.908 282.716 213.948 283.532 213.994 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M217.185 284.371H214.871C214.808 283.234 214.758 282.14 214.72 281.095L217.185 278.675V284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M219.074 284.371H217.185V277.978H202.788V276.351H201.845H200.899V277.978H200.114H199.366H195.075H194.302H186.5V284.371H184.612V276.089H219.074V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M202.788 284.371H200.9V276.351H202.788V277.978V283.713V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M257.508 284.371H252.914V277.978H257.615C257.346 280.117 257.334 282.241 257.508 284.371V284.371ZM246.546 281.731C246.551 280.482 246.482 279.233 246.323 277.978H251.025V280.688L250.001 278.387L246.546 281.731Z"
      fill="#617380"
    />
    <path
      d="M243.82 284.371H236.625V277.978H246.323C246.482 279.233 246.551 280.482 246.546 281.731L243.82 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M259.927 284.371H257.508C257.334 282.241 257.346 280.117 257.615 277.978H266.413L259.927 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M251.025 284.371H246.432C246.504 283.49 246.544 282.61 246.546 281.731L250.001 278.387L251.025 280.688V284.371Z"
      fill="#71828E"
    />
    <path
      d="M246.432 284.371H243.821L246.547 281.731C246.544 282.61 246.504 283.49 246.432 284.371"
      fill="#A0B2BA"
    />
    <path
      d="M267.317 284.371H259.927L266.412 277.978H267.317V284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M269.205 284.371H267.317V277.978H252.914V276.351H251.969H251.025V277.978H246.323H236.624V284.371H234.737V276.089H269.205V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M252.914 284.371H251.025V276.351H252.914V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M660.691 284.371H655.412V277.978H660.072C660.215 279.881 660.416 282.033 660.691 284.371ZM662.605 283.846C662.361 281.711 662.18 279.738 662.047 277.978H663.081C663.194 279.483 663.342 281.147 663.536 282.932L662.605 283.846"
      fill="#617380"
    />
    <path
      d="M663.698 284.371H662.667C662.645 284.195 662.625 284.02 662.605 283.846L663.536 282.932C663.587 283.403 663.641 283.883 663.698 284.371"
      fill="#71828E"
    />
    <path
      d="M662.667 284.371H660.691C660.416 282.033 660.215 279.881 660.072 277.978H662.047C662.18 279.738 662.361 281.711 662.605 283.846C662.625 284.02 662.645 284.195 662.667 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M669.81 284.371H663.698C663.641 283.883 663.587 283.403 663.536 282.932C663.342 281.147 663.194 279.483 663.081 277.978H669.81V284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M646.153 284.371H646.121C646.335 282.033 646.49 279.881 646.602 277.978H652.545L646.153 284.371V284.371ZM644.26 284.371H642.857C643.234 282.033 643.506 279.881 643.702 277.978H645.104C644.909 279.881 644.637 282.034 644.26 284.371Z"
      fill="#617380"
    />
    <path
      d="M653.523 284.371H646.152L652.545 277.978H653.523V284.371"
      fill="#71828E"
    />
    <path
      d="M646.121 284.371H644.26C644.636 282.034 644.908 279.881 645.103 277.978H646.602C646.49 279.881 646.335 282.033 646.121 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M642.857 284.371H639.123V277.978H643.702C643.506 279.881 643.234 282.033 642.857 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M671.697 284.371H669.81V277.978H655.412V276.351H654.468H653.523V277.978H652.545H646.602H645.104H643.702H639.123V284.371H637.235V276.089H671.697V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M655.412 284.371H653.523V276.351H655.412V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M509.73 284.371H505.134V277.978H509.838C509.568 280.117 509.557 282.241 509.73 284.371ZM498.768 281.731C498.773 280.482 498.704 279.233 498.545 277.978H503.245V280.688L502.222 278.387L498.768 281.731"
      fill="#617380"
    />
    <path
      d="M496.042 284.371H488.844V277.978H498.545C498.703 279.233 498.773 280.482 498.768 281.731L496.042 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M512.148 284.371H509.73C509.557 282.241 509.568 280.117 509.838 277.978H518.635L512.148 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M503.245 284.371H498.652C498.724 283.49 498.764 282.611 498.768 281.731L502.221 278.387L503.245 280.688V284.371"
      fill="#71828E"
    />
    <path
      d="M498.652 284.371H496.042L498.768 281.731C498.764 282.611 498.724 283.49 498.652 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M519.536 284.371H512.148L518.635 277.978H519.536V284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M521.424 284.371H519.535V277.978H505.134V276.351H504.189H503.245V277.978H498.545H488.844V284.371H486.956V276.089H521.424V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M505.134 284.371H503.245V276.351H505.134V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M612.656 284.371H606.023L606.017 284.356V277.978H609.926L612.656 284.371ZM601.612 280.617L602.995 277.978H604.128V280.109L603.515 278.732L601.612 280.617Z"
      fill="#617380"
    />
    <path
      d="M597.824 284.371H589.729V277.978H602.995L601.612 280.617L597.824 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M613.817 284.371H612.656L609.926 277.978H620.328L613.817 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M606.023 284.371H606.017V284.356L606.023 284.371ZM604.128 284.371H599.647L601.612 280.617L603.515 278.732L604.128 280.109V284.371"
      fill="#71828E"
    />
    <path
      d="M599.647 284.371H597.824L601.612 280.617L599.647 284.371"
      fill="#A0B2BA"
    />
    <path
      d="M620.412 284.371H613.817L620.328 277.978H620.412V284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M622.301 284.371H620.412V277.978H606.017V276.351H605.072H604.128V277.978H602.995H589.729V284.371H587.84V276.089H622.301V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M606.017 284.371H604.128V276.351H606.017V277.978V284.356V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M404.887 270.418H374.292V269.473H404.887V270.418Z"
      fill="#2A3E4D"
    />
    <path
      d="M435.191 270.418H422.089V269.473H435.191V270.418Z"
      fill="#2A3E4D"
    />
    <path d="M524.489 269.836H455.76V268.891H524.489V269.836Z" fill="#2A3E4D" />
    <path
      d="M536.752 284.371H524.489V283.821H536.752V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M578.472 269.836H562.002V268.891H578.472V269.836Z"
      fill="#2A3E4D"
    />
    <path d="M687.435 270.71H644.968V269.766H687.435V270.71Z" fill="#2A3E4D" />
    <path
      d="M686.948 284.371H675.821V283.929H686.948V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M410.687 284.371H405.407V277.978H410.068C410.213 279.881 410.412 282.033 410.687 284.371ZM396.15 284.371H396.117C396.331 282.033 396.486 279.881 396.598 277.978H402.542L396.15 284.371ZM394.257 284.371H392.852C393.229 282.033 393.5 279.881 393.697 277.978H395.1C394.904 279.881 394.634 282.034 394.257 284.371ZM412.603 283.846C412.357 281.711 412.177 279.738 412.044 277.978H413.077C413.191 279.483 413.339 281.147 413.532 282.932L412.603 283.846Z"
      fill="#617380"
    />
    <path
      d="M403.518 284.371H396.15L402.542 277.978H403.518V284.371Z"
      fill="#71828E"
    />
    <path
      d="M413.694 284.371H412.663C412.643 284.195 412.621 284.02 412.603 283.846L413.532 282.932C413.583 283.403 413.638 283.883 413.694 284.371Z"
      fill="#71828E"
    />
    <path
      d="M412.663 284.371H410.687C410.412 282.033 410.213 279.881 410.068 277.978H412.043C412.177 279.738 412.357 281.711 412.602 283.846C412.621 284.02 412.643 284.195 412.663 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M419.806 284.371H413.694C413.637 283.883 413.583 283.403 413.532 282.932C413.339 281.147 413.19 279.483 413.077 277.978H419.806V284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M396.117 284.371H394.257C394.634 282.034 394.905 279.881 395.1 277.978H396.598C396.486 279.881 396.331 282.033 396.117 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M392.852 284.371H389.12V277.978H393.697C393.501 279.881 393.229 282.033 392.852 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M421.695 284.371H419.806V277.978H405.407V276.351H404.462H403.518V277.978H402.542H396.598H395.1H393.697H389.12V284.371H387.231V276.089H421.695V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M405.407 284.371H403.518V276.351H405.407V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M311.061 284.371H305.78V277.978H310.442C310.586 279.881 310.785 282.033 311.061 284.371ZM312.975 283.848C312.729 281.712 312.549 279.738 312.416 277.978H313.448C313.563 279.483 313.711 281.147 313.904 282.933L312.975 283.848"
      fill="#617380"
    />
    <path
      d="M314.068 284.371H313.035C313.015 284.195 312.995 284.02 312.975 283.848L313.904 282.933C313.956 283.404 314.01 283.883 314.068 284.371"
      fill="#71828E"
    />
    <path
      d="M313.035 284.371H311.061C310.785 282.033 310.586 279.881 310.441 277.978H312.416C312.549 279.738 312.729 281.712 312.975 283.848C312.995 284.02 313.015 284.195 313.035 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M320.178 284.371H314.068C314.01 283.883 313.956 283.404 313.904 282.933C313.711 281.147 313.563 279.483 313.448 277.978H320.178V284.371"
      fill="#9AAEB7"
    />
    <path
      d="M296.522 284.371H296.49C296.705 282.033 296.859 279.881 296.971 277.978H302.914L296.522 284.371ZM294.63 284.371H293.226C293.602 282.033 293.873 279.881 294.07 277.978H295.473C295.277 279.881 295.006 282.034 294.63 284.371Z"
      fill="#617380"
    />
    <path
      d="M303.892 284.371H296.522L302.914 277.978H303.892V284.371Z"
      fill="#71828E"
    />
    <path
      d="M296.49 284.371H294.629C295.006 282.034 295.277 279.881 295.473 277.978H296.971C296.859 279.881 296.704 282.033 296.49 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M293.225 284.371H289.492V277.978H294.07C293.873 279.881 293.602 282.033 293.225 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M322.067 284.371H320.178V277.978H305.78V276.351H304.836H303.892V277.978H302.915H296.972H295.473H294.071H289.492V284.371H287.604V276.089H322.067V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M305.78 284.371H303.892V276.351H305.78V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M560.209 284.371H554.929V277.978H559.588C559.733 279.881 559.932 282.033 560.209 284.371ZM545.67 284.371H545.638C545.852 282.033 546.007 279.881 546.119 277.978H552.062L545.67 284.371V284.371ZM543.777 284.371H542.373C542.75 282.033 543.022 279.881 543.218 277.978H544.621C544.426 279.881 544.154 282.034 543.777 284.371V284.371ZM562.123 283.846C561.878 281.711 561.698 279.738 561.565 277.978H562.598C562.712 279.483 562.86 281.145 563.053 282.932L562.123 283.846"
      fill="#617380"
    />
    <path
      d="M553.041 284.371H545.67L552.062 277.978H553.041V284.371"
      fill="#71828E"
    />
    <path
      d="M563.216 284.371H562.184C562.163 284.194 562.143 284.02 562.123 283.846L563.053 282.932C563.105 283.403 563.159 283.883 563.216 284.371"
      fill="#71828E"
    />
    <path
      d="M562.184 284.371H560.209C559.932 282.033 559.733 279.881 559.588 277.978H561.565C561.698 279.738 561.878 281.711 562.123 283.846C562.143 284.02 562.163 284.194 562.184 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M569.327 284.371H563.216C563.159 283.883 563.105 283.403 563.053 282.932C562.861 281.145 562.712 279.483 562.599 277.978H569.327V284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M545.638 284.371H543.777C544.154 282.034 544.426 279.881 544.621 277.978H546.119C546.007 279.881 545.852 282.033 545.638 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M542.373 284.371H538.64V277.978H543.218C543.022 279.881 542.75 282.033 542.373 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M571.216 284.371H569.327V277.978H554.929V276.351H553.985H553.041V277.978H552.062H546.119H544.621H543.218H538.64V284.371H536.751V283.821V276.089H571.216V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M554.929 284.371H553.041V276.351H554.929V277.978V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M362.224 284.371H355.59L355.583 284.356V277.978H359.494L362.224 284.371V284.371ZM351.178 280.619L352.56 277.978H353.695V280.109L353.083 278.732L351.178 280.619Z"
      fill="#617380"
    />
    <path
      d="M347.39 284.371H339.295V277.978H352.56L351.178 280.619L347.39 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M363.385 284.371H362.224L359.494 277.978H369.894L363.385 284.371"
      fill="#9AAEB7"
    />
    <path
      d="M355.59 284.371H355.583V284.356L355.59 284.371ZM353.695 284.371H349.213L351.178 280.619L353.083 278.732L353.695 280.109V284.371Z"
      fill="#71828E"
    />
    <path
      d="M349.214 284.371H347.39L351.178 280.619L349.214 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M369.98 284.371H363.385L369.894 277.978H369.98V284.371"
      fill="#A0B2BA"
    />
    <path
      d="M371.867 284.371H369.98V277.978H355.583V276.351H354.639H353.695V277.978H352.56H339.295V284.371H337.408V276.089H371.867V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M355.584 284.371H353.695V276.351H355.584V277.978V284.356V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M461.882 284.371H457.247C457.771 282.033 458.148 279.88 458.422 277.978H461.352C461.475 279.88 461.645 282.033 461.882 284.371ZM466.214 281.924C466.155 280.523 466.116 279.203 466.091 277.978H466.972C466.991 278.957 467.019 279.998 467.059 281.094L466.214 281.924Z"
      fill="#617380"
    />
    <path
      d="M463.722 284.371H461.882C461.645 282.033 461.475 279.88 461.352 277.978H466.091C466.116 279.203 466.155 280.523 466.214 281.924L463.722 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M467.059 281.094C467.019 279.998 466.991 278.957 466.972 277.978H469.525V278.674L467.059 281.094"
      fill="#9AAEB7"
    />
    <path
      d="M457.247 284.371H455.421L455.13 283.715V277.978H458.422C458.148 279.88 457.771 282.033 457.247 284.371Z"
      fill="#9AAEB7"
    />
    <path d="M455.421 284.371H455.13V283.715L455.421 284.371Z" fill="#A0B2BA" />
    <path
      d="M447.063 284.371H446.218C446.41 282.078 446.543 279.927 446.643 277.978H447.416C447.338 280.107 447.222 282.242 447.063 284.371ZM451.364 280.744C451.49 279.779 451.604 278.855 451.706 277.978H452.456C452.392 278.608 452.324 279.24 452.253 279.871L451.364 280.744Z"
      fill="#617380"
    />
    <path
      d="M446.219 284.371H438.84V277.978H446.643C446.543 279.927 446.41 282.078 446.219 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M447.671 284.371H447.063C447.222 282.242 447.338 280.107 447.416 277.978H451.706C451.604 278.855 451.49 279.779 451.364 280.744L447.671 284.371Z"
      fill="#9AAEB7"
    />
    <path
      d="M452.253 279.871C452.324 279.24 452.392 278.608 452.456 277.977H453.242V279.469L453.066 279.074L452.253 279.871"
      fill="#9AAEB7"
    />
    <path
      d="M451.684 284.371H450.857C451.047 283.112 451.215 281.898 451.364 280.744L452.253 279.871C452.083 281.372 451.894 282.873 451.684 284.371Z"
      fill="#71828E"
    />
    <path
      d="M450.857 284.371H447.672L451.365 280.744C451.215 281.898 451.047 283.112 450.857 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M453.242 284.371H451.684C451.895 282.873 452.083 281.372 452.253 279.871L453.066 279.074L453.242 279.47V284.371"
      fill="#A0B2BA"
    />
    <path
      d="M467.21 284.371H466.335C466.287 283.532 466.248 282.714 466.214 281.924L467.059 281.094C467.098 282.139 467.147 283.234 467.21 284.371Z"
      fill="#71828E"
    />
    <path
      d="M466.335 284.371H463.723L466.214 281.924C466.248 282.714 466.287 283.532 466.335 284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M469.525 284.371H467.21C467.147 283.234 467.098 282.139 467.059 281.094L469.525 278.674V284.371Z"
      fill="#A0B2BA"
    />
    <path
      d="M471.413 284.371H469.525V277.978H455.131V276.351H454.186H453.242V277.978H452.456H451.706H447.416H446.643H438.84V284.371H436.951V276.089H471.413V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M455.13 284.371H453.242V276.351H455.13V277.978V283.715V284.371Z"
      fill="#2A3E4D"
    />
    <path
      d="M578.592 354.638H576.918V347.564H578.592V354.638ZM578.592 346.62H576.918V344.819C577.709 344.819 578.348 344.18 578.348 343.389V341.152C578.431 341.152 578.513 341.145 578.592 341.131V346.62Z"
      fill="#D6D2BA"
    />
    <path d="M576.918 347.565H578.592V346.62H576.918V347.565Z" fill="#2A3E4D" />
    <path
      d="M564.052 354.638H543.665V344.819C544.451 344.819 545.092 344.18 545.092 343.389V341.152C545.881 341.152 546.52 340.511 546.52 339.72V339.371H561.195V339.72C561.195 340.511 561.831 341.152 562.62 341.152V343.389C562.62 344.18 563.262 344.819 564.052 344.819V354.638ZM530.793 354.638H510.404V344.819C511.194 344.819 511.835 344.18 511.835 343.389V341.152C512.624 341.152 513.265 340.511 513.265 339.72V339.371H527.933V339.72C527.933 340.511 528.574 341.152 529.366 341.152V343.389C529.366 344.18 530.003 344.819 530.793 344.819V354.638V354.638ZM497.536 354.638H481.942V347.763H384.241V354.638H381.99V344.819C382.778 344.819 383.417 344.18 383.417 343.389V341.152C384.208 341.152 384.849 340.511 384.849 339.72V339.371H494.676V339.72C494.676 340.511 495.315 341.152 496.107 341.152V343.389C496.107 344.18 496.746 344.819 497.536 344.819V354.638ZM369.121 354.638H347.427V344.819C348.216 344.819 348.852 344.18 348.852 343.389V341.152C349.647 341.152 350.288 340.511 350.288 339.72V339.371H366.261V339.72C366.261 340.511 366.899 341.152 367.69 341.152V343.389C367.69 344.18 368.329 344.819 369.121 344.819V354.638ZM334.559 354.638H312.865V354.007H334.328V353.063H312.865V344.819C313.655 344.819 314.292 344.18 314.292 343.389V341.152C315.086 341.152 315.726 340.511 315.726 339.72V339.371H331.698V339.72C331.698 340.511 332.338 341.152 333.128 341.152V343.389C333.128 344.18 333.769 344.819 334.559 344.819V354.638ZM299.998 354.638H280.428V337.569C280.57 337.775 280.73 337.965 280.905 338.14C281.659 338.898 282.722 339.371 283.875 339.371C283.877 339.371 283.878 339.371 283.88 339.371H297.136V339.72C297.136 340.511 297.776 341.152 298.567 341.152V343.389C298.567 344.18 299.208 344.819 299.998 344.819V353.063H282.286V353.535V354.007H299.998V354.638"
      fill="#D6D2BA"
    />
    <path
      d="M578.552 335.594H283.881C283.64 335.594 283.452 335.405 283.451 335.165V334.845H578.592V335.593C578.579 335.594 578.566 335.594 578.552 335.594Z"
      fill="#995A5A"
    />
    <path
      d="M283.875 339.372C282.722 339.372 281.659 338.898 280.905 338.14C280.73 337.965 280.57 337.775 280.428 337.57V334.845H283.451V335.165C283.452 335.405 283.64 335.594 283.88 335.594H578.552C578.566 335.594 578.579 335.594 578.592 335.593V337.483H561.195V339.372H546.52V337.483H527.933V339.372H513.265V337.483H494.676V339.372H384.849V337.483H366.261V339.372H350.288V337.483H331.698V339.372H315.726V337.483H297.136V339.372H283.88C283.878 339.372 283.877 339.372 283.875 339.372Z"
      fill="#2A3E4D"
    />
    <path
      d="M480.998 354.638H479.236V350.997H386.727V354.638H385.185V348.707H480.998V354.638Z"
      fill="#BED4D3"
    />
    <path
      d="M481.942 354.638H480.998V348.707H385.185V354.638H384.241V347.763H481.942V354.638Z"
      fill="#2A3E4D"
    />
    <path d="M387.672 354.638H478.292V351.94H387.672V354.638Z" fill="#89ABAA" />
    <path
      d="M479.236 354.638H478.292V351.94H387.672V354.638H386.728V350.997H479.236V354.638Z"
      fill="#2A3E4D"
    />
    <path
      d="M334.328 354.007H312.865V353.063H334.328V354.007ZM299.998 354.007H282.286V353.535V353.063H299.998V354.007Z"
      fill="#2A3E4D"
    />
    <path
      d="M482.005 235.201H481.868C481.914 235.173 481.961 235.143 482.005 235.113V235.201ZM377.652 235.201H377.338V234.987C377.439 235.064 377.544 235.136 377.652 235.201Z"
      fill="#2A3E4D"
    />
    <path
      d="M480.191 233.777H379.332C378.571 233.776 377.961 233.163 377.958 232.405V230.345H481.561V232.405C481.559 233.163 480.946 233.776 480.191 233.777Z"
      fill="#D6D4D4"
    />
    <path
      d="M481.868 235.201H377.652C377.544 235.136 377.439 235.064 377.338 234.987V230.337H482.005V235.113C481.961 235.143 481.914 235.173 481.868 235.201ZM377.958 230.345V232.405C377.96 233.163 378.571 233.776 379.332 233.777H480.191C480.946 233.776 481.559 233.163 481.561 232.405V230.345H377.958"
      fill="#2A3E4D"
    />
    <path d="M493.47 327.184H563.737V326.239H493.47V327.184Z" fill="#284356" />
    <path
      d="M377.968 331.725H427.154V330.781H377.968V331.725Z"
      fill="#284356"
    />
    <path
      d="M435.425 327.184H457.165V326.239H435.425V327.184Z"
      fill="#284356"
    />
    <path
      d="M361.424 326.381H373.792V325.437H361.424V326.381Z"
      fill="#284356"
    />
    <path
      d="M296.281 329.602H345.468V328.657H296.281V329.602Z"
      fill="#284356"
    />
    <path
      d="M471.509 331.725H485.271V330.781H471.509V331.725Z"
      fill="#284356"
    />
    <path
      d="M510.404 436.209H508.202V432.984C508.202 431.672 507.139 430.61 505.826 430.608H501.438V428.229C501.436 426.918 500.378 425.855 499.065 425.853H497.536V400.895H510.404V436.209V436.209ZM510.404 370.523H497.536V354.638H510.404V370.523Z"
      fill="#D6D2BA"
    />
    <path
      d="M510.405 399.007H503.754L510.405 392.379V399.007ZM499.847 399.007H498.177V372.412H510.405V388.589L499.847 399.007"
      fill="#617380"
    />
    <path
      d="M503.754 399.007H499.847L510.404 388.589V392.379L503.754 399.007"
      fill="#71828E"
    />
    <path
      d="M510.404 400.896H497.536V370.523H510.404V372.412H498.177V399.007H499.847H503.754H510.404V400.896Z"
      fill="#2A3E4D"
    />
    <path
      d="M499.549 430.607H497.536V427.74H499.065C499.328 427.74 499.549 427.961 499.549 428.228V430.607"
      fill="#D6D4D4"
    />
    <path
      d="M501.438 430.607H499.549V428.228C499.549 427.961 499.328 427.74 499.065 427.74H497.536V425.852H499.065C500.378 425.854 501.436 426.917 501.438 428.228V430.607Z"
      fill="#2A3E4D"
    />
    <path
      d="M506.313 436.209H497.536V432.497H505.826C506.096 432.497 506.313 432.715 506.313 432.984V436.209Z"
      fill="#D6D4D4"
    />
    <path
      d="M508.202 436.209H506.313V432.984C506.313 432.715 506.096 432.497 505.826 432.497H497.536V430.608H499.549H501.438H505.826C507.139 430.61 508.202 431.672 508.202 432.984V436.209Z"
      fill="#2A3E4D"
    />
    <path
      d="M511.835 442.732H496.107V441.44C496.107 440.651 496.746 440.01 497.536 440.01V438.096H510.404V440.01C511.194 440.01 511.835 440.651 511.835 441.44V442.732Z"
      fill="#D6D4D4"
    />
    <path
      d="M511.835 443.677H496.107V442.732H511.835V443.677V443.677ZM510.404 438.096H497.536V436.208H506.314H508.202H510.404V438.096Z"
      fill="#2A3E4D"
    />
    <path
      d="M510.404 354.638H497.536V344.819C496.745 344.819 496.107 344.18 496.107 343.389V341.152C495.315 341.152 494.676 340.511 494.676 339.72V339.371H513.265V339.72C513.265 340.511 512.624 341.152 511.835 341.152V343.389C511.835 344.18 511.194 344.819 510.404 344.819V354.638"
      fill="#B5B09D"
    />
    <path
      d="M494.676 339.372H513.265V337.483H494.676V339.372Z"
      fill="#2C3A46"
    />
    <path
      d="M545.092 441.788H529.365V441.44C529.365 440.651 530.003 440.01 530.793 440.01V400.894H543.665V440.01C544.451 440.01 545.092 440.651 545.092 441.44V441.788ZM543.665 370.522H530.793V354.637H543.665V370.522Z"
      fill="#D6D2BA"
    />
    <path
      d="M529.365 443.677H545.092V441.788H529.365V443.677Z"
      fill="#2A3E4D"
    />
    <path
      d="M543.665 399.007H530.793V395.07L543.665 382.155V399.007V399.007ZM530.793 379.468V372.412H537.801L530.793 379.468Z"
      fill="#617380"
    />
    <path
      d="M530.793 395.069V379.468L537.801 372.412H543.665V382.154L530.793 395.069Z"
      fill="#71828E"
    />
    <path
      d="M543.665 400.896H530.793V399.007H543.665V400.896ZM543.665 372.412H537.801H530.793V370.523H543.665V372.412Z"
      fill="#2A3E4D"
    />
    <path
      d="M543.665 354.638H530.793V344.819C530.003 344.819 529.365 344.18 529.365 343.389V341.152C528.573 341.152 527.933 340.511 527.933 339.72V339.371H546.52V339.72C546.52 340.511 545.881 341.152 545.092 341.152V343.389C545.092 344.18 544.451 344.819 543.665 344.819V354.638Z"
      fill="#B5B09D"
    />
    <path d="M527.933 339.372H546.52V337.483H527.933V339.372Z" fill="#2C3A46" />
    <path
      d="M578.347 441.788H562.62V441.44C562.62 440.651 563.262 440.01 564.051 440.01V354.637H576.918V363.31H569.87V363.782V364.254H576.918V387.171H574.92V387.644V388.116H576.918V440.01C577.709 440.01 578.347 440.651 578.347 441.44V441.788Z"
      fill="#D6D2BA"
    />
    <path d="M562.62 443.677H578.347V441.788H562.62V443.677Z" fill="#2A3E4D" />
    <path d="M576.919 388.116H574.92V387.171H576.919V388.116Z" fill="#2A3E4D" />
    <path d="M576.919 364.255H569.87V363.31H576.919V364.255Z" fill="#2A3E4D" />
    <path
      d="M578.592 341.131V339.371C579.005 339.367 579.404 339.303 579.78 339.188V339.72C579.78 340.427 579.268 341.015 578.592 341.131Z"
      fill="#D6D2BA"
    />
    <path
      d="M578.592 339.372V337.483H579.78V339.189C579.404 339.304 579.005 339.368 578.592 339.372Z"
      fill="#2A3E4D"
    />
    <path
      d="M576.919 354.638H564.052V344.819C563.262 344.819 562.62 344.18 562.62 343.389V341.152C561.831 341.152 561.195 340.511 561.195 339.72V339.371H578.552C578.566 339.371 578.578 339.371 578.592 339.371V341.131C578.513 341.145 578.431 341.152 578.348 341.152V343.389C578.348 344.18 577.709 344.819 576.919 344.819V346.62H576.459V347.092V347.564H576.919V354.638"
      fill="#B5B09D"
    />
    <path
      d="M578.552 339.372H561.195V337.483H578.592V339.372C578.578 339.372 578.566 339.372 578.552 339.372Z"
      fill="#2C3A46"
    />
    <path d="M576.919 347.565H576.459V346.62H576.919V347.565Z" fill="#2C3A46" />
    <path
      d="M348.852 441.788H333.128V441.44C333.128 440.651 333.769 440.01 334.559 440.01V400.894H347.427V440.01C348.216 440.01 348.852 440.651 348.852 441.44V441.788ZM347.427 370.522H334.559V354.637H347.427V370.522Z"
      fill="#D6D2BA"
    />
    <path
      d="M333.128 443.677H348.852V441.788H333.128V443.677Z"
      fill="#2A3E4D"
    />
    <path
      d="M347.427 399.007H334.559V391.287L347.427 378.375V399.007ZM334.559 375.673V372.412H337.797L334.559 375.673Z"
      fill="#617380"
    />
    <path
      d="M334.559 391.286V375.672L337.797 372.411H347.427V378.374L334.559 391.286"
      fill="#71828E"
    />
    <path
      d="M347.427 400.896H334.559V399.007H347.427V400.896ZM347.427 372.412H337.797H334.559V370.523H347.427V372.412Z"
      fill="#2A3E4D"
    />
    <path
      d="M347.427 354.638H334.558V344.819C333.769 344.819 333.128 344.18 333.128 343.389V341.152C332.337 341.152 331.698 340.511 331.698 339.72V339.371H350.287V339.72C350.287 340.511 349.646 341.152 348.852 341.152V343.389C348.852 344.18 348.216 344.819 347.427 344.819V354.638"
      fill="#B5B09D"
    />
    <path
      d="M331.698 339.372H350.287V337.483H331.698V339.372Z"
      fill="#2C3A46"
    />
    <path
      d="M314.292 441.788H298.567V441.44C298.567 440.651 299.208 440.01 299.998 440.01V400.894H312.865V440.01C313.655 440.01 314.292 440.651 314.292 441.44V441.788ZM312.865 370.522H299.998V354.637H312.865V370.522Z"
      fill="#D6D2BA"
    />
    <path
      d="M298.567 443.677H314.292V441.788H298.567V443.677Z"
      fill="#2A3E4D"
    />
    <path
      d="M311.384 399.007H303.748L312.865 389.921V397.515L311.384 399.007V399.007ZM299.998 398.851V372.412H312.865V386.157L299.998 398.851"
      fill="#617380"
    />
    <path
      d="M312.865 399.007H311.385L312.865 397.515V399.007Z"
      fill="#71828E"
    />
    <path
      d="M303.748 399.007H299.998V398.851L312.865 386.157V389.921L303.748 399.007Z"
      fill="#71828E"
    />
    <path
      d="M312.865 400.896H299.998V399.007H312.865V400.896ZM312.865 372.412H299.998V370.523H312.865V372.412Z"
      fill="#2A3E4D"
    />
    <path
      d="M312.865 354.638H299.998V354.007H312.865V354.638ZM312.865 353.063H299.998V344.819C299.207 344.819 298.567 344.18 298.567 343.389V341.152C297.776 341.152 297.136 340.511 297.136 339.72V339.371H315.726V339.72C315.726 340.511 315.086 341.152 314.292 341.152V343.389C314.292 344.18 313.655 344.819 312.865 344.819V353.063Z"
      fill="#B5B09D"
    />
    <path
      d="M297.136 339.372H315.726V337.483H297.136V339.372Z"
      fill="#2C3A46"
    />
    <path
      d="M299.998 354.007H312.865V353.063H299.998V354.007Z"
      fill="#2C3A46"
    />
    <path
      d="M369.121 426.315V354.638H381.99V425.852H370.532C370.003 425.852 369.515 426.025 369.121 426.315Z"
      fill="#D6D2BA"
    />
    <path
      d="M381.99 430.607H370.044V428.228C370.046 427.958 370.26 427.74 370.532 427.74H381.99V430.607Z"
      fill="#D6D4D4"
    />
    <path
      d="M370.044 430.607H369.121V426.315C369.515 426.024 370.003 425.852 370.532 425.852H381.99V427.74H370.532C370.26 427.74 370.046 427.958 370.044 428.228V430.607Z"
      fill="#2A3E4D"
    />
    <path
      d="M369.121 436.209H381.989V432.497H369.121V436.209Z"
      fill="#D6D4D4"
    />
    <path d="M381.99 432.496H369.121V430.607H381.99V432.496Z" fill="#2A3E4D" />
    <path
      d="M383.418 442.732H367.69V441.44C367.69 440.651 368.33 440.01 369.122 440.01V438.096H381.99V440.01C382.778 440.01 383.418 440.651 383.418 441.44V442.732Z"
      fill="#D6D4D4"
    />
    <path
      d="M383.418 443.677H367.69V442.732H383.418V443.677V443.677ZM381.99 438.096H369.122V436.208H381.99V438.096Z"
      fill="#2A3E4D"
    />
    <path
      d="M381.989 354.638H369.121V344.819C368.329 344.819 367.69 344.18 367.69 343.389V341.152C366.899 341.152 366.26 340.511 366.26 339.72V339.371H384.849V339.72C384.849 340.511 384.208 341.152 383.417 341.152V343.389C383.417 344.18 382.778 344.819 381.989 344.819V354.638"
      fill="#B5B09D"
    />
    <path d="M366.26 339.372H384.849V337.483H366.26V339.372Z" fill="#2C3A46" />
    <path
      d="M487.954 339.72C487.954 340.51 488.591 341.151 489.386 341.151V343.388C489.386 344.179 490.024 344.818 490.816 344.818V440.01C490.024 440.01 489.386 440.651 489.386 441.44V443.677H505.114V441.44C505.114 440.651 504.47 440.01 503.682 440.01V344.818C504.47 344.818 505.114 344.179 505.114 343.388V341.151C505.902 341.151 506.545 340.51 506.545 339.72V337.482H487.954V339.72"
      fill="white"
    />
    <path
      d="M487.954 339.72H487.01C487.013 341.028 488.07 342.092 489.386 342.095V341.151H488.442V343.388C488.444 344.699 489.503 345.762 490.816 345.763V344.818H489.872V440.01H490.816V439.066C489.503 439.066 488.442 440.13 488.442 441.44V444.621H506.058V441.44C506.055 440.126 504.993 439.067 503.682 439.066V440.01H504.626V344.818H503.682V345.763C504.993 345.762 506.055 344.703 506.058 343.388V341.151H505.114V342.095C506.424 342.094 507.487 341.034 507.488 339.72V336.537H487.01V339.72H487.954H488.899V338.426H505.601V339.72C505.6 339.986 505.379 340.206 505.114 340.206H504.169V343.388C504.168 343.655 503.948 343.874 503.682 343.874H502.738V440.954H503.682C503.948 440.954 504.168 441.175 504.169 441.44V442.732H490.329L490.33 441.44C490.33 441.172 490.546 440.954 490.816 440.954H491.761V343.874H490.816C490.547 343.874 490.33 343.658 490.33 343.388V340.206H489.386C489.111 340.206 488.9 339.992 488.899 339.72H487.954"
      fill="#284356"
    />
    <path
      d="M521.211 339.72C521.211 340.51 521.854 341.151 522.646 341.151V343.388C522.646 344.179 523.284 344.818 524.073 344.818V440.01C523.284 440.01 522.646 440.651 522.646 441.44V443.677H538.369V441.44C538.369 440.651 537.731 440.01 536.942 440.01V344.818C537.731 344.818 538.369 344.179 538.369 343.388V341.151C539.158 341.151 539.8 340.51 539.8 339.72V337.482H521.211V339.72"
      fill="white"
    />
    <path
      d="M521.211 339.72H520.267C520.268 341.034 521.332 342.095 522.646 342.095V341.151H521.701V343.388C521.704 344.698 522.76 345.763 524.073 345.763V344.818H523.129V440.01H524.073V439.066C522.76 439.066 521.701 440.131 521.701 441.44V444.621H539.314V441.44C539.314 440.131 538.255 439.066 536.942 439.066V440.01H537.886V344.818H536.942V345.763C538.255 345.763 539.311 344.698 539.314 343.388V341.151H538.369V342.095C539.68 342.094 540.743 341.034 540.744 339.72V336.537H520.267V339.72H521.211H522.156V338.426H538.855V339.72C538.854 339.987 538.635 340.206 538.369 340.206H537.425V343.388C537.425 343.659 537.207 343.874 536.942 343.874H535.997V440.954H536.942C537.208 440.954 537.425 441.171 537.425 441.44V442.732H523.589L523.59 441.44C523.59 441.171 523.806 440.954 524.073 440.954H525.016V343.874H524.073C523.806 343.874 523.59 343.659 523.59 343.388V340.206H522.646C522.374 340.206 522.156 339.987 522.156 339.72H521.211"
      fill="#284356"
    />
    <path
      d="M554.472 337.482V339.72C554.472 340.51 555.112 341.151 555.9 341.151V343.388C555.9 344.179 556.541 344.818 557.33 344.818V440.01C556.541 440.01 555.9 440.651 555.9 441.44V443.677H571.626V441.44C571.626 440.651 570.988 440.01 570.196 440.01V344.818C570.988 344.818 571.626 344.179 571.626 343.388V341.151C572.421 341.151 573.057 340.51 573.057 339.72V337.482H554.472"
      fill="white"
    />
    <path
      d="M554.472 337.482H553.528V339.72C553.528 341.031 554.588 342.095 555.9 342.095V341.151H554.956V343.388C554.956 344.7 556.018 345.763 557.33 345.763V344.818H556.386V440.01H557.33V439.066C556.018 439.067 554.957 440.129 554.956 441.44V444.621H572.571V441.44C572.568 440.131 571.511 439.068 570.196 439.066V440.01H571.14V344.818H570.196V345.763C571.511 345.762 572.568 344.698 572.571 343.388V341.151H571.626V342.095C572.942 342.092 573.999 341.027 574.001 339.72V336.537H553.528V337.482H554.472V338.426H572.112V339.72C572.11 339.993 571.9 340.205 571.626 340.206H570.682V343.388C570.681 343.659 570.467 343.874 570.196 343.874H569.252V440.954H570.196C570.467 440.954 570.682 441.171 570.682 441.44V442.732H556.843L556.844 441.44C556.844 441.174 557.063 440.954 557.33 440.954H558.273V343.874H557.33C557.063 343.874 556.844 343.656 556.844 343.388V340.206H555.9C555.636 340.206 555.417 339.99 555.417 339.72V337.482H554.472V338.426V337.482"
      fill="#284356"
    />
    <path
      d="M324.975 339.72C324.975 340.51 325.616 341.151 326.406 341.151V343.388C326.406 344.179 327.047 344.818 327.837 344.818V440.01C327.047 440.01 326.406 440.651 326.406 441.44V443.677H342.132V441.44C342.132 440.651 341.495 440.01 340.704 440.01V344.818C341.495 344.818 342.132 344.179 342.132 343.388V341.151C342.924 341.151 343.566 340.51 343.566 339.72V337.482H324.975V339.72"
      fill="white"
    />
    <path
      d="M324.975 339.72H324.031C324.032 341.032 325.094 342.095 326.406 342.095V341.151H325.461V343.388C325.463 344.7 326.525 345.763 327.837 345.763V344.818H326.893V440.01H327.837V439.066C326.525 439.066 325.463 440.129 325.461 441.44V444.621H343.076V441.44C343.075 440.131 342.017 439.066 340.704 439.066V440.01H341.649V344.818H340.704V345.763C342.017 345.763 343.075 344.698 343.076 343.388V341.151H342.132V342.095C343.445 342.095 344.511 341.034 344.511 339.72V336.537H324.031V339.72H324.975H325.92V338.426H342.622V339.72C342.622 339.987 342.404 340.206 342.132 340.206H341.188V343.388C341.188 343.659 340.971 343.874 340.704 343.874H339.76V440.954H340.704C340.972 440.954 341.188 441.171 341.188 441.44V442.732H327.35V441.44C327.351 441.172 327.568 440.954 327.837 440.954H328.782V343.874H327.837C327.568 343.874 327.351 343.656 327.35 343.388V340.206H326.406C326.139 340.206 325.921 339.988 325.92 339.72H324.975"
      fill="#284356"
    />
    <path
      d="M290.415 339.72C290.415 340.51 291.054 341.151 291.846 341.151V343.388C291.846 344.179 292.485 344.818 293.276 344.818V440.01C292.485 440.01 291.846 440.651 291.846 441.44V443.677H307.572V441.44C307.572 440.651 306.932 440.01 306.143 440.01V344.818C306.932 344.818 307.572 344.179 307.572 343.388V341.151C308.365 341.151 309.004 340.51 309.004 339.72V337.482H290.415V339.72"
      fill="white"
    />
    <path
      d="M290.415 339.72H289.471C289.473 341.03 290.532 342.092 291.846 342.095V341.151H290.901V343.388C290.904 344.699 291.963 345.763 293.276 345.763V344.818H292.332V440.01H293.276V439.066C291.963 439.066 290.901 440.13 290.901 441.44V444.621H308.516V441.44C308.516 440.13 307.456 439.067 306.143 439.066V440.01H307.087V344.818H306.143V345.763C307.456 345.763 308.516 344.699 308.516 343.388V341.151H307.572V342.095C308.887 342.092 309.945 341.03 309.948 339.72V336.537H289.471V339.72H290.415H291.36V338.426H308.059V339.72C308.058 339.991 307.844 340.206 307.572 340.206H306.628V343.388C306.628 343.658 306.41 343.874 306.143 343.874H305.199V440.954H306.143C306.41 440.954 306.628 441.172 306.628 441.44V442.732H292.79V441.44C292.79 441.172 293.007 440.954 293.276 440.954H294.22V343.874H293.276C293.007 343.874 292.79 343.658 292.79 343.388V340.206H291.846C291.576 340.206 291.361 339.991 291.36 339.72H290.415"
      fill="#284356"
    />
    <path
      d="M359.541 339.72C359.541 340.51 360.178 341.151 360.967 341.151V343.388C360.967 344.179 361.608 344.818 362.399 344.818V440.01C361.608 440.01 360.967 440.651 360.967 441.44V443.677H376.696V441.44C376.696 440.651 376.054 440.01 375.265 440.01V344.818C376.054 344.818 376.696 344.179 376.696 343.388V341.151C377.487 341.151 378.127 340.51 378.127 339.72V337.482H359.541V339.72"
      fill="white"
    />
    <path
      d="M359.541 339.72H358.596C358.598 341.03 359.655 342.095 360.967 342.095V341.151H360.023V343.388C360.024 344.7 361.087 345.763 362.399 345.763V344.818H361.455V440.01H362.399V439.066C361.087 439.067 360.024 440.129 360.023 441.44V444.621H377.641V441.44C377.638 440.127 376.575 439.067 375.265 439.066V440.01H376.209V344.818H375.265V345.763C376.577 345.763 377.639 344.701 377.641 343.388V341.151H376.696V342.095C378.008 342.095 379.071 341.032 379.071 339.72V336.537H358.596V339.72H359.541H360.485V338.426H377.182V339.72C377.182 339.988 376.964 340.206 376.696 340.206H375.752V343.388C375.751 343.655 375.532 343.874 375.265 343.874H374.32V440.954H375.265C375.532 440.954 375.751 441.174 375.752 441.44V442.732H361.912V441.44C361.913 441.174 362.131 440.954 362.399 440.954H363.343V343.874H362.399C362.131 343.874 361.913 343.656 361.912 343.388V340.206H360.967C360.702 340.206 360.485 339.991 360.485 339.72H359.541"
      fill="#284356"
    />
  </svg>
);

export default BackgroundLoading;
